<template>
    <div></div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faAnchor,
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faBug,
    faCalendar,
    faCaretDown,
    faCheck,
    faCheckCircle,
    faChild,
    faEnvelope,
    faExclamation,
    faGrin,
    faHome,
    faInfo,
    faLaugh,
    faLongArrowAltRight,
    faMap,
    faMinus,
    faMinusCircle,
    faPhone,
    faPlane,
    faPlus,
    faPlusCircle,
    faShip,
    faSpinner,
    faStar,
    faSuitcase,
    faTags,
    faTimes,
    faUser,
    faArrowUp,
    faArrowDown,
    faInfoCircle,
    faUserSecret,
    faAlignLeft,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faAngleLeft,
    faAngleRight,
    faBug,
    faCalendar,
    faCheck,
    faChild,
    faExclamation,
    faGrin,
    faHome,
    faInfo,
    faInfoCircle,
    faLaugh,
    faMap,
    faMinus,
    faMinusCircle,
    faPhone,
    faPlane,
    faPlus,
    faPlusCircle,
    faSpinner,
    faSuitcase,
    faTags,
    faTimes,
    faUser,
    faStar,
    faCaretDown,
    faCheckCircle,
    faEnvelope,
    faLongArrowAltRight,
    faShip,
    faArrowRight,
    faArrowLeft,
    faAnchor,
    faArrowUp,
    faArrowDown,
    faUserSecret,
    faSpinner,
    faAlignLeft
)

export default {
    name: 'style.vue',
}
</script>

<style lang="scss">
p,
a,
div {
    font-family: Ubuntu, sans-serif;
    color: #7f8386;
}
.drop-enter-active {
    transition: all 0.5s ease-in;
}

.drop-leave-active {
    transition: all 0.3s ease-out;
}

.drop-enter {
    transform: translateY(-100%);
}

.drop-enter-to {
    transform: translateY(0);
    opacity: 1;
}

.drop-leave {
    transform: translateY(0);
    opacity: 1;
}

.drop-leave-to {
    transform: translateY(-100%);
    opacity: 0;
}

.slide-enter-active {
    transition: all 0.3s ease-out;
    transform-origin: top;
}

.slide-leave-active {
    transition: all 0.3s ease-in;
    transform-origin: top;
}

.slide-enter {
    max-height: 0px;
    opacity: 0;
    overflow: hidden;
}

.slide-enter-to {
    max-height: 600px;
    opacity: 1;
}

.slide-leave {
    max-height: 600px;
    opacity: 1;
}

.slide-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}

.slide-sm-enter-active {
    transition: all 0.3s ease-in-out;
    transform-origin: top;
}

.slide-sm-leave-active {
    transition: all 0.3s ease-in-out;
    transform-origin: bottom;
}

.slide-sm-enter {
    max-height: 0px;
    opacity: 0;
    overflow: hidden;
}

.slide-sm-enter-to {
    opacity: 1;
}

.slide-sm-leave {
    top: -60px;
    opacity: 1;
}

.slide-sm-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}

.fade-enter-active {
    transition: opacity 0.3s ease-out;
}

.fade-leave-active {
    transition: opacity 0.3s ease-out;
}

.fade-enter {
    opacity: 0;
}

.fade-enter-to {
    opacity: 1;
}

.fade-leave {
    opacity: 1;
}

.fade-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 1200px) {
    .bookingheader {
        .hoofdmenu {
            .logo {
                padding-left: 20px;
            }

            .info {
                float: right !important;
                clear: none !important;
            }

            .item288 {
                border-right: none !important;
            }

            .logos-img,
            .bel .tijden {
                display: none;
            }
        }

        .return_section {
            > div {
                margin-left: 20px;
            }
        }
    }

    .maincontent {
        width: 70% !important;
    }

    .sidebar {
        width: 30% !important;
    }

    .midblock {
        margin: 5px 20px !important;
    }

    .cabin-wrapper {
        box-sizing: border-box;
        padding: 0 25px;
    }

    .midblock {
        width: 90% !important;
    }

    .item .midblock {
        width: 100% !important;
        margin: 0 !important;
    }

    #paxinfo {
        width: 95%;
    }

    .cabin-container .scroll-arrow {
        -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 255);
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 155);
    }

    .cabin-container .scroll-left {
        left: 10px !important;
    }

    .cabin-container .scroll-right {
        right: 10px !important;
    }

    .numberHeaderContainer {
        margin-left: 20px;
    }

    .deckmapoverlay {
        width: 60% !important;

        .dim {
            width: 40% !important;
        }
    }

    .sideBarRederijLogo {
        left: 25px !important;
    }

    #footer {
        > span {
            margin-left: 20px;
            line-height: normal;
            display: inline-block;
        }
    }
}

@media only screen and (max-width: 740px) {
    .bookingheader {
        .hoofdmenu {
            .logo,
            .logo > img {
                width: 125px !important;
            }

            > div {
                width: 100% !important;
            }

            .info {
                padding-left: 0 !important;
            }

            .tel {
                font-size: 20px;
            }

            .bel {
                > div {
                    font-size: 10px !important;
                }
            }

            .topmenu {
                ul {
                    li {
                        float: right !important;
                    }
                }
            }
        }
    }

    .sidebar {
        padding-bottom: 20px;
    }

    .deckmapoverlay {
        width: 100% !important;

        .dim {
            width: 0 !important;
        }
    }

    .hutselectie {
        display: block;

        .button-wrapper {
            display: flex !important;
            justify-content: center !important;
        }
    }

    .maincontent,
    .sidebar,
    .cabin_images {
        width: 100% !important;
    }


    .cabin_section {
        .cabin_images {
          height: 100px !important;


            img {
                width: 100%;
            }
        }

        .cabin_info {
            margin-top: 10px;

            float: left;
        }
    }
    .ups {
        display: none;
    }

    .info {
        float: none !important;
        padding-left: 20px;
    }

    #footer {
        > span {
            float: none !important;
            width: 90%;
        }

        > div {
            float: none !important;
            margin-left: 20px;
            width: 90%;
        }
    }

    .importantimages {
        display: none;
    }

    #content .font20 {
        font-size: 15px !important;
    }

    .maincontent .paddingbottom30 {
        padding-bottom: 5px;
    }

    #flights td {
        display: block !important;
    }

    #transfers td {
      display: block !important;
    }

    #flights tr:nth-child(even) {
        //background-color: #ecf5fb;
    }
}


/*
    MAIN
    */

.router-link-exact-active {
    text-decoration: underline !important;
    color: red !important;
}

.yellow-notification {
    background-color: #fcf8e3;
    padding: 15px;
    border-radius: 6px;
    color: #8a6d40;

    p {
        margin-top: 5px !important;
    }

    h3,
    p {
        color: #8a6d40 !important;
        margin: 0;
    }
}

.top-notification {
    background-color: #dff6e1;
    padding: 15px;
    border-radius: 6px;
    color: #2f7000;

    p {
        margin-top: 5px !important;
    }

    h3,
    p,
    a {
        color: #2f7000 !important;
        margin: 0;
    }
}

.noscroll {
    //overflow: hidden;
    height: 100vh;
}

.noscroll {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
.noscroll::-webkit-scrollbar { /* WebKit */
  width: 0;
  height: 0;
}

#content {
    padding-top: 25px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    float: none !important;
}

.deckmapoverlay {
    width: 40%;
    pointer-events: none;
    height: 100%;
    position: fixed;
    z-index: 10001;
    right: 0;
    top: 0;
    overflow-x: hidden;
}

.maincontent {
    width: 75%;
}

.cabin-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .cabin-container {
        width: 100%;
        height: 100%;
        box-sizing: content-box;
        overflow: hidden;
        .item {
            display: inline-block;
            vertical-align: top;
            white-space: normal;
            width: calc((100% - 32px)  / 4);
          @media screen and (max-width: 900px) {
            width: 100%;
            margin-bottom:10px !important;
            img {
              max-height: initial !important;
            }
          }
            margin: 0 !important;

            &:not(:last-child) {
                padding-right: 10px;
            }
        }
        &.cabin-container-vertical {
          .item {
            display: inline-block;
            vertical-align: top;
            white-space: normal;
            width: 100%;
            margin: 0 !important;

            &:not(:last-child) {
              padding-right: 10px;
            }
          }
        }
        .scroll-arrow {
            cursor: pointer;
            float: left;
            position: absolute;
            top: 120px;
            font-size: 30px;
            color: #fff;
            background: #bab5af;
            border-radius: 6px;
            padding: 10px;
            z-index: 10;

            &:hover {
                background: #2178b3;
            }
        }

        .scroll-left {
            left: -45px;
        }

        .scroll-right {
            right: -45px;
        }
    }
}

#deckmap-content > img {
    width: 100%;
    height: auto;
}

.action-selection {
    .action-dropdown-section {
        background-color: #f1f1f1;
        padding: 10px;
        margin-top: 10px;

        .text {
            line-height: 35px;
            margin-right: 10px;
        }

        .select-drop {
            clear: none !important;
            margin-right: 10px;
        }
    }
}

/*
    Sidebar
    */
.sidebar {
    width: 20%;
}

/*
    Form styling
    */
.tform {
    select,
    input,
    textarea {
        padding: 10px 12px;
        border-radius: 5px;
        font-size: 14px;
        box-shadow: inset 0 1px 2px 1px rgba(0, 0, 0, 0.18);
    }

    textarea {
        border: none;
    }

    .datepicker {
        input {
            width: 100%;
        }
    }
}

.pointer {
    cursor: pointer;
}

.errorMessage {
    box-sizing: border-box;
    padding: 20px;
    position: fixed;
    z-index: 1;
    background-color: #ecd7d5;
    bottom: 0;
    right: 0;
    width: 100%;
    text-align: center;
}

.errorText {
    color: #ecd7d5;
}

.flex-container {
    display: inline-flex;
    align-content: flex-end;
}

.flex-column {
    flex-direction: column;
}

.item {
    margin-right: 5px;
}

.item + .item {
    margin-left: 5px;
}

.overlay .closebtn {
    position: absolute;
    top: 20px;
    right: 45px;
    font-size: 60px;
}

.dim button {
    background-color: #bab5af;
}

.hide {
    overflow: hidden;
    height: 0px;
    animation: fade 0.5s linear forwards;
}

.show {
    animation: show 0.5s linear forwards;
}

@keyframes show {
    from {
        opacity: 0;
        visibility: hidden;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        visibility: visible;
        transform: translateY(0px);
    }
}

@keyframes fade {
    from {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        visibility: hidden;
        transform: translateY(-10px);
    }
}

/* ALGEMEEN */
html,
body {
    color: #333333;
    font-family: Ubuntu, sans-serif;
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 20px;
}

body {
    min-width: 360px;
    //overscroll-behavior-y: contain;
}

img {
    display: block;
}

p,
a,
div {
    font-family: Ubuntu, sans-serif;
    color: #7f8386;
    margin-top: 0;
}

a:link,
a:visited,
a:hover {
    font-family: Ubuntu, sans-serif;
    color: #7f8386;
    text-decoration: none;
    font-weight: bold;
}

a:hover {
    text-decoration: underline !important;
    color: #37b5d3;
}

.hoofdmenu a:link,
.hoofdmenu a:visited,
.hoofdmenu a:hover {
    font-weight: normal;
}

input {
    font-family: Ubuntu, sans-serif;
    color: #333333;
    font-size: 12px;
    padding: 0 4px;
    border: 1px solid #ddd;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 8px 6px;
    color: #8a8e93;
}

h1 {
    font-size: 20px;
    margin-bottom: 6px;
    margin-top: 0;
}

select {
    margin: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    -webkit-box-shadow: 0;
    -moz-box-shadow: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    line-height: 12px !important;
    clear: both;
    display: block;
    border: 1px solid #e7e6e6;
    background: none;
    background-color: rgba(0, 0, 0, 0);
    background-position-x: 0%;
    background-position-y: 0%;
    background-repeat: repeat;
    width: 100%;
    background-color: #fff;
    padding: 0 10px;
    padding-right: 10px;
    height: 38px;
    font-family: sans-serif;
    background-repeat: no-repeat;
    background-position: center right;
    padding-right: 30px !important;
    cursor: pointer;
    font-size: 12px;
}

.select-drop {
    background-color: #fff;
    position: relative;
    clear: both;
}

.select-drop::after {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -806px -132px;
    display: block;
    width: 11px;
    height: 16px;
    content: '';
    display: block;
    position: absolute;
    top: 10px;
    right: 11px;
    pointer-events: none;
}

.tcenter {
    text-align: center;
}

.clear {
    clear: both;
    width: 100%;
}

.clearfix {
    clear: both;
}

.anvr-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -511px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.sgr-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -552px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.cal-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -592px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.clia-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -632px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.blijdorp-img {
    background-image: url(https://cdn.cruisereizen.nl/img/overig/partners/blijdorp.png);
    display: block;
    width: 39px;
    height: 50px;
}

.fd-img {
    background-image: url(https://cdn.cruisereizen.nl/img/overig/partners/fd.png);
    display: block;
    width: 75px;
    height: 50px;
}

.ideal-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -246px;
    display: block;
    width: 40px;
    height: 32px;
}

.paypal-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -44px -246px;
    display: block;
    width: 94px;
    height: 32px;
}

.mrcash-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -232px -246px;
    display: block;
    width: 46px;
    height: 32px;
}

.visa-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -142px -246px;
    display: block;
    width: 40px;
    height: 32px;
}

.master-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -188px -246px;
    display: block;
    width: 40px;
    height: 32px;
}

.amex-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -469px -247px;
    display: block;
    width: 32px;
    height: 30px;
}

.logosmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -682px -16px;
    margin: 0;
    display: block;
    width: 156px;
    height: 32px;
}

.checks li:before {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -272px -9px;
    content: ' ';
    padding-right: 17px;
}

.cruise-logo {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 0;
    display: block;
    width: 266px;
    height: 44px;
}

.vluchtheen {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -720px -132px;
    display: block;
    width: 20px;
    height: 20px;
}

.vluchtterug {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -690px -132px;
    display: block;
    width: 20px;
    height: 20px;
}

.vluchticon-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -719px -132px;
    width: 23px;
    height: 20px;
    display: block;
    margin: 0 auto;
}

.cruiseicon-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -891px -132px;
    width: 23px;
    height: 20px;
    display: block;
    margin: 0 auto;
}

.transfericon-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -917px -132px;
    width: 23px;
    height: 20px;
    display: block;
    margin: 0 auto;
}

.schip-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -78px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.vloot-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -515px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.live-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -156px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.verken-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.entertainment-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -229px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.haven-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -441px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.highlights-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -300px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.excursies-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -370px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.search-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -868px -132px;
    display: block;
    width: 18px;
    height: 18px;
    margin: 0 auto;
    float: left;
}

.aida-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1346px -165px;
    display: inline-block;
    width: 58px;
    height: 32px;
    margin: 0 auto;
}

.azamara-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1140px -202px;
    display: inline-block;
    width: 84px;
    height: 32px;
    margin: 0 auto;
}

.carnival-cruise-lines-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1496px -203px;
    display: inline-block;
    width: 88px;
    height: 32px;
    margin: 0 auto;
}

.celebrity-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1496px -165px;
    display: inline-block;
    width: 82px;
    height: 32px;
    margin: 0 auto;
}

.disney-cruise-line-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1422px -203px;
    display: inline-block;
    width: 76px;
    height: 32px;
    margin: 0 auto;
}

.hapag-lloyd-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1026px -201px;
    display: inline-block;
    width: 116px;
    height: 30px;
    margin: 0 auto;
}

.holland-america-line-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1170px -162px;
    display: inline-block;
    width: 92px;
    height: 36px;
    margin: 0 auto;
}

.msc-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1274px -166px;
    display: inline-block;
    width: 68px;
    height: 30px;
    margin: 0 auto;
}

.norwegian-cruise-line-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1022px -164px;
    display: inline-block;
    width: 120px;
    height: 30px;
    margin: 0 auto;
}

.oceania-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -610px -203px;
    display: inline-block;
    width: 60px;
    height: 30px;
    margin: 0 auto;
}

.ponant-yacht-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -680px -203px;
    display: inline-block;
    width: 130px;
    height: 30px;
    margin: 0 auto;
}

.royal-caribbean-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1404px -166px;
    display: inline-block;
    width: 90px;
    height: 30px;
    margin: 0 auto;
}

.seadream-yacht-club-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1316px -202px;
    display: inline-block;
    width: 102px;
    height: 30px;
    margin: 0 auto;
}

.silversea-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -825px -203px;
    display: inline-block;
    width: 140px;
    height: 30px;
    margin: 0 auto;
}

.star-clippers-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -615px -242px;
    display: inline-block;
    width: 60px;
    height: 30px;
    margin: 0 auto;
}

.princess-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1690px -179px;
    display: inline-block;
    width: 111px;
    height: 25px;
    margin: 0 auto;
}

.regent-seven-seas-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1805px -159px;
    display: inline-block;
    width: 78px;
    height: 44px;
    margin: 0 auto;
}

.seabourn-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -202px -202px;
    display: inline-block;
    width: 84px;
    height: 30px;
    margin: 0 auto;
}

.holland-america-line-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -218px -56px;
    display: block;
    width: 130px;
    height: 52px;
    margin: 0 auto;
}

.royal-caribbean-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -550px -68px;
    width: 132px;
    height: 34px;
    display: block;
    margin: 0 auto;
}

.seadream-yacht-club-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1316px -202px;
    display: block;
    width: 102px;
    height: 30px;
    margin: 0 auto;
}

.norwegian-cruise-line-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1026px -64px;
    width: 202px;
    height: 49px;
    display: block;
    margin: 0 auto;
}

.aida-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1346px -165px;
    display: inline-grid;
    width: 58px;
    height: 32px;
    margin: 0 auto;
}

.costa-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1582px -204px;
    width: 42px;
    display: inline-grid;
    height: 32px;
    margin: 0 auto;
}

.azamara-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1140px -202px;
    display: block;
    width: 84px;
    height: 32px;
    margin: 0 auto;
}

.carnival-cruise-lines-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1496px -203px;
    display: block;
    width: 88px;
    height: 32px;
    margin: 0 auto;
}

.costa-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    display: block;
    background-position: -1980px -66px;
    width: 54px;
    height: 34px;
    margin: 0 auto;
}

.celebrity-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    display: block;
    background-position: -691px -70px;
    width: 120px;
    margin: 0 auto;
    height: 28px;
    margin: 0 auto;
}

.disney-cruise-line-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    display: block;
    background-position: -580px -120px;
    width: 112px;
    margin: 0 auto;
    height: 36px;
    margin: 0 auto;
}

.hapag-lloyd-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1026px -201px;
    display: block;
    width: 116px;
    height: 30px;
    margin: 0 auto;
}

.msc-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1390px -67px;
    width: 90px;
    height: 38px;
    margin: 0 auto;
}

.aida-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1498px -68px;
    display: block;
    width: 71px;
    height: 32px;
    margin: 0 auto;
}

.seabourn-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1326px -122px;
    display: block;
    width: 117px;
    height: 32px;
    margin: 0 auto;
}

.idealsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -289px -258px;
    display: block;
    width: 22px;
    height: 28px;
}

.paypalsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -314px -258px;
    display: block;
    width: 60px;
    height: 28px;
}

.mrcashsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -432px -259px;
    display: block;
    width: 34px;
    height: 32px;
}

.visasmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -376px -260px;
    display: block;
    width: 28px;
    height: 28px;
}

.mastersmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -404px -260px;
    display: block;
    width: 28px;
    height: 28px;
}

.amexsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -506px -258px;
    display: block;
    width: 21px;
    height: 21px;
}

.klm-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -552px -169px;
    display: block;
    width: 34px;
    height: 28px;
}

.vluchtheen-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -720px -126px;
    display: block;
    width: 24px;
    height: 28px;
}

.vluchtterug-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -688px -128px;
    display: block;
    width: 24px;
    height: 28px;
}

.whatsapp-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -841px -26px;
    display: block;
    width: 20px;
    height: 20px;
    margin: 0 auto;
}

.eten-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -59px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.ontspanning-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -158px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.beauty-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.sport-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -333px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.kinderen-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -104px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.rolstoel-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -218px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.wifi-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -390px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.schip2-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -272px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.haven2-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -272px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.gezinnen-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -366px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.dranken-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -70px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.fooien-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -144px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.korting-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -516px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.kleding-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -440px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.gala-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -220px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.gewoontes-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -294px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.bagage-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.ajax-loader {
    background-image: url(https://cdn.cruisereizen.nl/img/template/ajax_loader_blue_128.gif);
    background-position: 0 0;
    display: block;
    width: 128px;
    height: 128px;
    text-align: center;
    margin: 0 auto;
    margin-top: 30%;
}

.hoofdmenu .menu,
.hoofdmenu .sub-menu {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.hoofdmenu .menu li {
    display: inline-block;
    cursor: pointer;
    position: relative;
    font-size: 13px;
    transition: background-color 0.5s;
    -moz-transition: background-color 0.5s;
    -o-transition: background-color 0.5s;
    -webkit-transition: background-color 0.5s;
}

.hoofdmenu .menu li a.active {
    color: #568fba !important;
}

.hoofdmenu .menu a {
    /*color: #568fba;*/
    display: block;
    font-family: Ubuntu, sans-serif;
    overflow: hidden;
    position: relative;
    text-align: center;
    text-decoration: none;
    word-wrap: break-word;
    padding: 10px;
}

.hoofdmenu .menu a:hover {
    color: #568fba;
    text-decoration: none !important;
}

.hoofdmenu .menu > li {
    height: 100%;
    width: auto;
    margin-right: 1px;
    padding: 0 4px;
}

.hoofdmenu .menu li.submenudrop a:hover {
    background-image: none;
}

.hoofdmenu .menu li.submenudrop-current ul li a,
.hoofdmenu .menu li.submenudrop ul li a {
    background-image: none;
    text-transform: none;
}

.hoofdmenu .menu > li.current,
.hoofdmenu .menu > li.submenudrop-current {
    background-color: #37b5d3 !important; /* !important VS .menu li:hover */
    color: #fff;
    box-shadow: none !important;
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.hoofdmenu .menu > li.current a {
    color: #fff !important;
}

.hoofdmenu .sub-menu li.current {
    background-color: #37b5d3 !important;
    color: #fff !important;
}

.hoofdmenu .menu li.submenudrop ul li a:hover > li.submenudrop a {
    color: #fff !important;
}

.hoofdmenu .menu li .menu-tekst {
    margin-left: 5px;
}

#footer-1 a,
#footer-1 a:link,
#footer-1 a:visited,
#footer-1 a:hover {
    color: #fff;
}

#footer-1 ul,
#footer-1 ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.copyrightmenu ul,
.copyrightsocial ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.copyrightsocial ul li,
.copyrightmenu ul li {
}

.copyrightmenu li {
    margin-right: 20px;
}

.copyrightsocial li {
    margin-right: 5px;
}

.copyright img {
    margin-bottom: 8px;
}

.usp span {
    clear: both;
    display: block;
    font-size: 20px;
    line-height: 26px;
}

.usp p {
    font-weight: normal;
    margin-top: 4px;
    padding: 0 20px;
    color: #333333;
}

/* Temaplate Width */
.width2 {
    width: 2%;
}

.width5 {
    width: 5%;
}

.width15 {
    width: 15%;
}

.width17 {
    width: 17%;
}

.width21 {
    width: 21%;
}

.width22 {
    width: 22%;
}

.width28 {
    width: 28%;
}

.width18 {
    width: 18%;
}

.width19 {
    width: 19%;
}

.width20 {
    width: 20%;
}

.width40 {
    width: 40% !important;
}

.width21 {
    width: 21%;
}

.width22 {
    width: 22%;
}

.width23 {
    width: 23%;
}

.width24 {
    width: 24%;
}

.widthimp24 {
    width: 24% !important;
}

.widthimp31 {
    width: 31% !important;
}

.widthimp32 {
    width: 32% !important;
}

.widthimp33 {
    width: 33% !important;
}

.width25 {
    width: 25%;
}

.width26 {
    width: 26%;
}

.width10 {
    width: 10%;
}

.width29 {
    width: 29%;
}

.width30 {
    width: 30%;
}

.width31 {
    width: 31%;
}

.width32 {
    width: 32% !important;
}

.width33 {
    width: 33%;
}

.width35 {
    width: 35%;
}

.width36 {
    width: 36% !important;
}

.width37 {
    width: 37% !important;
}

.width38 {
    width: 38% !important;
}

.width42 {
    width: 42%;
}

.width45 {
    width: 45%;
}

.width48 {
    width: 48%;
}

.width49 {
    width: 49%;
}

.width44 {
    width: 44%;
}

.width45 {
    width: 45%;
}

.width46 {
    width: 46%;
}

.width47 {
    width: 47%;
}

.width48 {
    width: 48%;
}

.width50 {
    width: 50%;
}

.width52 {
    width: 52% !important;
}

.width58 {
    width: 58% !important;
}

.width55 {
    width: 55%;
}

.width59 {
    width: 59%;
}

.width60 {
    width: 60%;
}

.width61 {
    width: 61%;
}

.width62 {
    width: 62%;
}

.width65 {
    width: 65%;
}

.width66 {
    width: 66%;
}

.width68 {
    width: 68%;
}

.width69 {
    width: 69%;
}

.width70 {
    width: 70%;
}

.width72 {
    width: 72%;
}

.width73 {
    width: 73%;
}

.width74 {
    width: 74%;
}

.width75 {
    width: 75%;
}

.width80 {
    width: 80%;
}

.width85 {
    width: 85%;
}

.width90 {
    width: 90%;
}

.width92 {
    width: 92%;
}

.width93 {
    width: 93%;
}

.width94 {
    width: 94%;
}

.width95 {
    width: 95%;
}

.width100 {
    width: 100%;
}

.width98 {
    width: 98%;
}

.width100000 {
    width: 100%;
    overflow: hidden;
    white-space: nowrap !important;
}

.widthauto {
    width: auto !important;
}

.widthpix5 {
    width: 5px;
}

.widthpix10 {
    width: 10px;
}

.widthpix15 {
    width: 15px;
}

.widthpix50 {
    width: 50px;
}

.widthpix75 {
    width: 75px;
}

/* Template Height */
.height5 {
    height: 5px;
}

.height10 {
    height: 10px;
}

.height15 {
    height: 15px;
}

.height20 {
    height: 20px;
}

.height25 {
    height: 25px;
}

.height23 {
    height: 23px;
}

.lineheight18 {
    line-height: 18px !important;
}

.lineheight22 {
    line-height: 22px;
}

.height30 {
    height: 30px;
}

.height36 {
    height: 36px;
}

.height38 {
    height: 38px;
}

.height38imp {
    height: 38px !important;
}

.lineheight30 {
    line-height: 30px;
}

.lineheight36 {
    line-height: 36px;
}

.lineheight38 {
    line-height: 38px;
}

.lineheight38imp {
    line-height: 38px !important;
}

.lineheight40 {
    line-height: 40px;
}

.lineheight42 {
    line-height: 42px;
}

.lineheight50 {
    line-height: 50px;
}

.lineheight70 {
    line-height: 70px;
}

.lineheight80 {
    line-height: 80px;
}

.lineheight82 {
    line-height: 82px;
}

.lineheight90 {
    line-height: 90px;
}

.lineheight92 {
    line-height: 92px;
}

.height1 {
    height: 1px;
}

.height32 {
    height: 32px;
}

.height40 {
    height: 40px;
}

.height50 {
    height: 50px;
}

.height60 {
    height: 60px;
}

.height70 {
    height: 70px;
}

.height75 {
    height: 75px;
}

.height100 {
    height: 100px;
}

.height125 {
    height: 125px;
}

.height108 {
    height: 108px;
}

.height147 {
    height: 147px;
}

.height150 {
    height: 150px;
}

.height162 {
    height: 162px;
}

.height170 {
    height: 170px;
}

.height200 {
    height: 200px;
}

.height300 {
    height: 300px;
}

.height320 {
    height: 320px;
}

.height340 {
    height: 340px;
}

.height50imp {
    height: 50px !important;
}

.minheight126 {
    min-height: 126px;
}

.widthpix15 {
    width: 15px;
}

/* Line Height */
.lineheight50imp {
    line-height: 50px !important;
}

.lineheight20 {
    line-height: 20px;
}

.lineheight62 {
    line-height: 62px;
}

.lineheight150 {
    line-height: 150px;
}

/* Template Round */
.round5 {
    border-radius: 5px;
}

.round10 {
    border-radius: 10px;
}

.round15 {
    border-radius: 15px;
}

.round50 {
    border-radius: 50px;
}

.round75 {
    border-radius: 75px;
}

/* Template padding & margin */
.padding {
    padding: 5px;
}

.padding2 {
    padding: 2px;
}

.padding5 {
    padding: 5px;
}

.padding8 {
    padding: 8px;
}

.padding10 {
    padding: 10px;
}

.padding15 {
    padding: 15px;
}

.padding20 {
    padding: 20px;
}

.paddingtop5 {
    padding-top: 5px;
}

.paddingtop0 {
    padding-top: 0 !important;
}

.paddingtop10 {
    padding-top: 10px !important;
}

.paddingtop15 {
    padding-top: 15px;
}

.paddingtop20 {
    padding-top: 20px;
}

.paddingtop30 {
    padding-top: 30px !important;
}

.paddingbottom5 {
    padding-bottom: 5px;
}

.paddingbottom10 {
    padding-bottom: 10px !important;
}

.paddingbottom15 {
    padding-bottom: 10px !important;
}

.paddingbottom20 {
    padding-bottom: 20px;
}

.paddingbottom30 {
    padding-bottom: 30px !important;
}

.paddingbottom35 {
    padding-bottom: 35px;
}

.paddingbottom45 {
    padding-bottom: 45px;
}

.paddingbottom50 {
    padding-bottom: 50px;
}

.paddingbottom60 {
    padding-bottom: 60px;
}

.paddingbottom65 {
    padding-bottom: 65px;
}

.paddingbottom70 {
    padding-bottom: 70px;
}

.paddingbottom75 {
    padding-bottom: 75px;
}

.paddingleft5 {
    padding-left: 5px;
}

.paddingleft20 {
    padding-left: 20px;
}

.paddingleft15 {
    padding-left: 15px;
}

.paddingleft10 {
    padding-left: 10px !important;
}

.paddingleft20 {
    padding-left: 20px;
}

.paddingleft25 {
    padding-left: 25px;
}

.paddingright20 {
    padding-right: 20px;
}

.paddingright15 {
    padding-right: 20px;
}

.nopadding {
    padding: 0 !important;
}

.nomargin {
    margin: 0 !important;
}

.marginbottom0 {
    margin-bottom: 0 !important;
}

.marginbottom5 {
    margin-bottom: 5px !important;
}

.marginbottom10 {
    margin-bottom: 10px !important;
}

.marginbottom15 {
    margin-bottom: 15px;
}

.marginbottom20 {
    margin-bottom: 20px !important;
}

.marginbottom50 {
    margin-bottom: 50px !important;
}

.margintop5 {
    margin-top: 5px !important;
}

.margintop10 {
    margin-top: 10px !important;
}

.margintop10 {
    margin-top: 10px;
}

.margintop20 {
    margin-top: 20px;
}

.margintop20imp {
    margin-top: 20px !important;
}

.margintop0 {
    margin-top: 0;
}

.margintop15 {
    margin-top: 15px !important;
}

.margintop30 {
    margin-top: 30px !important;
}

.margintop35 {
    margin-top: 35px !important;
}

.margintop40 {
    margin-top: 40px !important;
}

.margintop40imp {
    margin-top: 40px !important;
}

.margintop50 {
    margin-top: 50px !important;
}

.margintop75 {
    margin-top: 75px !important;
}

.margintop100 {
    margin-top: 100px;
}

.margintop150 {
    margin-top: 150px;
}

.marginright3 {
    margin-right: 3px !important;
}

.marginright5 {
    margin-right: 5px !important;
}

.marginright10 {
    margin-right: 10px !important;
}

.marginright20 {
    margin-right: 20px !important;
}

.marginright50 {
    margin-right: 50px !important;
}

.marginright60 {
    margin-right: 60px !important;
}

.marginright70 {
    margin-right: 70px !important;
}

.marginleft0 {
    margin-left: 0 !important;
}

.marginleft3 {
    margin-left: 3px;
}

.marginleftperc3 {
    margin-left: 3%;
}

.marginleftperc10 {
    margin-left: 10%;
}

.marginrightperc10 {
    margin-right: 10%;
}

.marginleftperc15 {
    margin-left: 15%;
}

.marginrightperc15 {
    margin-right: 15%;
}

.marginleft5 {
    margin-left: 5px;
}

.marginleft10 {
    margin-left: 10px;
}

.marginleft15 {
    margin-left: 15px;
}

.marginleft20 {
    margin-left: 20px;
}

.marginleft130 {
    margin-left: 130px;
}

.marginright0 {
    margin-right: 0 !important;
}

.marginright5 {
    margin-right: 5px;
}

.marginright10 {
    margin-right: 10px;
}

.marginright13 {
    margin-right: 13px;
}

.marginright14 {
    margin-right: 14px;
}

.marginright15 {
    margin-right: 15px;
}

.margincenter {
    margin: 0 auto;
    float: none;
}

.margin5 {
    margin: 5px;
}

.margin10 {
    margin: 10px;
}

.margin10imp {
    margin: 10px !important;
}

.minmargintop36 {
    margin-top: -36px;
}

.top26 {
    top: 26px;
}

.right10 {
    right: 10px;
}

.bel,
.logos-img {
    float: left;
    text-align: right;
}

/* Pagination */
.pagination {
    border-top: 1px solid #e3e3e3;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 20px;
    width: 100%;
    clear: both;
    display: block;
    text-align: center;
}

.pagination a,
.pagination strong {
    background: #fff;
    display: inline-block;
    margin-right: 3px;
    padding: 4px 12px;
    text-decoration: none;
    line-height: 1.5em;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
}

.pagination a:hover {
    background-color: #bebebe !important;
    color: #fff !important;
}

.pagination-active {
    background-color: #bebebe !important;
    color: #fff !important;
}

.pagination a {
    cursor: pointer;
}

/* Template Kleuren */
.bluebg {
    background-color: #dcf8fe;
    border: 1px solid #afe6f3;
}

.headerbg {
    background-color: #37b5d3 !important;
}

.greybg {
    background-color: #f8f8f8;
}

.grey {
    background-color: #f8f8f8;
}

.darkgreybg {
    background-color: #e9e9e9;
}

.lichtgreybg {
    background-color: #f0f0f0;
}

.midgreybg {
    background-color: #f7f7f5;
}

.greenbg {
    background-color: #eaf3d8;
    border: 1px solid #c9df9f;
}

.green span {
    color: #ffffff;
    background-color: #2f7000;
}

.gray span {
    color: #ffffff;
    background-color: #bab5af;
}

.green {
    color: #2f7000;
}

.orangebg {
    background-color: #f39c12 !important;
}

.lightorangebg {
    background-color: #f3ddbb !important;
}

.orangebg:hover {
    background-color: #d58a13 !important;
}

.groenbg {
    background-color: #9dd057 !important;
}

.groenbg:hover {
    background-color: #8bbb48 !important;
}

.orange {
    color: #f39c12 !important;
}

.black {
    color: #333 !important;
}

.blauw {
    color: #568fba;
}

.ultralichtblauwbg {
    background-color: #f4fcfe;
}

.hoverblauw:hover {
    background-color: #e3f2f6 !important;
}

.lichtblauw {
    color: #def7fe;
}

.lichtblauwbg {
    background-color: #def7fe;
}

.midblauw {
    color: #37b5d3;
}

.darkblue,
.darkblue:link,
.darkblue:visited,
.darkblue:hover {
    color: #2178b3;
}

a.darkblue:hover {
    color: #000;
}

.ultradarkblue {
    color: #2b2869;
}

.midbluebg {
    background-color: #3783c7;
}

.darkbluebg {
    background-color: #1ca2c2 !important;
}

.pinkbg {
    background-color: #f06 !important;
}

.midblauwbg {
    background-color: #37b5d3 !important;
}

.midblauwbg:hover {
    background-color: #34abc8 !important;
}

.paars,
.purple {
    color: #6666cc;
}

.paarsbg,
.purplebg {
    background-color: #6666cc;
}

.white {
    color: #fff;
}

.whitebg {
    background-color: #fff;
}

.groen {
    color: #669900;
}

.groenbg {
    background-color: #9dd057;
}

.lichtgroenbg {
    background-color: #dff2bf;
}

.rood {
    color: #ff0066;
}

.midgroen {
    color: #9dd057 !important;
    font-weight: bold;
}

.grey {
    color: #cacaca !important;
}

.blue {
    color: #5ba2d6;
}

.lightgrey {
    color: #b0b0b0;
}

.silver {
    color: #b4b5b7;
}

.gold {
    color: #c4ac52;
}

.diamond {
    color: #718896;
}

.orange {
    color: #f39c12;
}

.darkorange {
    color: #d28929;
}

.yellow {
    color: #feb500;
}

.rounded {
    border-radius: 5px !important;
}

.rounded5 {
    border-radius: 5px !important;
}

.rounded10 {
    border-radius: 10px !important;
}

/* Template font size */
.font8 {
    font-size: 8px;
}

.font8imp {
    font-size: 8px !important;
}

.font10 {
    font-size: 10px;
}

.font11 {
    font-size: 11px;
}

.font12 {
    font-size: 12px;
}

.font12imp {
    font-size: 12px !important;
}

.font14 {
    font-size: 14px;
}

.font15 {
    font-size: 15px !important;
}

.font16 {
    font-size: 16px !important;
}

.font18 {
    font-size: 18px !important;
}

.font20 {
    font-size: 20px;
}

.font22 {
    font-size: 22px;
}

.font24 {
    font-size: 24px;
}

.font26 {
    font-size: 26px;
}

.font28 {
    font-size: 28px;
}

.font30 {
    font-size: 30px;
}

.font40 {
    font-size: 40px;
}

.font50 {
    font-size: 50px;
}

.font70 {
    font-size: 70px;
}

.font80 {
    font-size: 80px;
}

.font90 {
    font-size: 90px;
}

.label {
    width: 22%;
}

.variabel {
    width: 78%;
}

.autowidth {
    width: auto;
}

.nofloat,
.nofloat li {
    float: none !important;
}

/* Template font styles */
.italic {
    font-style: italic;
}

.small {
    font-size: 10px !important;
    line-height: 10px !important;
}

.museo {
    font-family: 'museo-slab' !important;
}

.bold {
    font-weight: bold !important;
}

.nobold {
    font-weight: normal !important;
}

/* Opacity */
.opacity3 {
    opacity: 0.3;
}

.opacity5 {
    opacity: 0.5;
}

.opacity8 {
    opacity: 0.8;
    transition: all 0.4s;
}

.opacity8:hover {
    opacity: 1;
}

/* Zoom */
.zoom60 {
    zoom: 60%;
    -moz-transform: scale(0.6); /* Firefox */
}

.zoom70 {
    zoom: 70%;
    -moz-transform: scale(0.7); /* Firefox */
}

.zoom80 {
    zoom: 80%;
    -moz-transform: scale(0.8); /* Firefox */
}

/* Buttons */
.btn {
    display: inline-block;
    padding: 8px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
    font-size: 14px !important;
    border-radius: 5px;
    background-color: #f38900;
    border-radius: 4px;
    color: #ffffff;
    box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.06),
        0 2px 0 0 rgba(0, 0, 0, 0.1);
}

.btn-success {
    color: #fff;
    background-color: #da7a00;
}
.btn-success :active {
    color: #fff;
    background-color: #da7a00 !important;
}

.btn-fail {
    color: #fff !important;
    background-color: #bf7162;
}

.btn-light {
    color: #ffffff;
    background-color: #bab5af;
}

.btn-fail:hover {
    text-decoration: none !important;
}

.start {
    margin-left: 0;
    margin-bottom: 0;
}

.last {
    margin-right: 0;
    margin-bottom: 0;
}

.padding-small {
    padding: 4px 6px !important;
    margin-top: 1px !important;
}

.absolute {
    position: absolute;
}

.fixed {
    position: fixed;
}

.relative {
    position: relative;
}

.autosize {
    width: auto !important;
    height: auto !important;
}

.zindextop {
    z-index: 100 !important;
}

.marginauto {
    margin: 0 auto;
}

.floatnone {
    float: none;
}

.favorieten {
    cursor: pointer;
}

.favorieten span:hover {
    color: #f39c12 !important;
}

.lineheight26 {
    line-height: 26px !important;
}

.lineheight32 {
    line-height: 32px !important;
}

.regelpadding {
    padding: 6px 10px !important;
}

#footer-1 ul li a,
#footer-1 ul li a:link {
    font-weight: normal !important;
}

.bottom {
    bottom: 0;
}

.noborder {
    border: 0;
}

.border1 {
    border: 1px solid #ddd;
}

.border2 {
    border: 1px solid #eee;
}

.border3 {
    border: 3px solid #eee;
}

.border4 {
    border: 4px solid #ddd;
}

.borderbottomdashed1 {
    border-bottom: 1px dashed #ccc;
}

.border1-purple {
    border: 1px solid #6666cc;
}

.borderblue1 {
    border: 1px solid #9adceb;
}

.borderorange1 {
    border: 1px solid #efb476;
}

.bordertopblue1 {
    border-top: 1px solid #2178b3;
}

.borderbottomgrey1 {
    border-bottom: 1px solid #e9e9e9;
}

.bordertopgrey1 {
    border-top: 1px solid #ddd;
}

.bordergrey1 {
    border: 1px solid #e3e3e3;
}

.borderright1 {
    border-right: 1px solid #eee;
}

.bordergroen1 {
    border: 1px solid #cee6a7;
}

.shadowbottom1 {
    -webkit-box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.1);
    box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.1);
}

/* Search module */
.searchfield {
    padding: 10px 12px;
    font-size: 14px;
    border-radius: 5px;
    box-shadow: inset 0 1px 2px 1px rgba(0, 0, 0, 0.18);
}

.logos img {
}

.filter-header {
    color: #fff;
    font-size: 20px;
    margin: 0;
    padding-left: 15px;
    font-weight: 400;
    background-color: #37b5d3;
    padding: 16px;
    padding-bottom: 12px;
    background-position: 10px;
}

.filter-body {
    padding: 16px;
}

.col25 {
    padding-left: 10px;
    padding-right: 10px;
}

.topblock {
    border: 1px solid #eee;
    border-radius: 5px;
}

.midblock {
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 0 2px 0 rgba(19, 41, 61, 0.2);
    border-radius: 5px;
}

.midblockFree {
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 0 2px 0 rgba(19, 41, 61, 0.2);
    border-radius: 5px;
}

.checks a,
.checks a:link {
    color: #fff;
}

.footer2 .checks a,
.footer2 .checks a:link {
    font-weight: normal;
}

#filter .select {
    margin-bottom: 4px !important;
}

.selectpaddingsmall {
    padding: 6px 24px 6px 12px !important;
    height: auto !important;
    line-height: 18px !important;
}

.divlink {
    font-weight: normal;
}

.divlink:hover {
    background-color: #f4fcfe;
}

.landing h3 {
    color: #2178b3;
    margin-bottom: 0;
}

.overflowhidden {
    overflow: hidden !important;
}

.block {
    display: block !important;
}

.nolist {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.textcenter,
.textcenter img {
    text-align: center;
    margin: 0 auto;
}

.textleft {
    text-align: left;
}

.textright {
    text-align: right;
}

.uppercase {
    text-transform: uppercase;
}

select::-ms-expand {
    display: none;
}

.floatleft,
.floatleft li {
    float: left;
}

.floatleftimp,
.floatleftimp li {
    float: left !important;
}

.floatright {
    float: right;
}

.floatnone {
    float: none;
}

div a img {
    border: 0 !important;
}

li.aanleghaven a {
    font-weight: normal;
}

li.vertrekhaven a {
    font-weight: normal;
}

.leesmeer {
    font-weight: bold;
    cursor: pointer;
    margin-top: 8px;
}

.leesmeer:hover {
    text-decoration: underline;
}

.thumbnails {
    height: 58px;
    margin-top: 5px;
}

.topblocklinks a,
.topblocklinks a:link {
    font-weight: normal;
    text-decoration: underline;
}

.topblocklinks {
    margin: 16px;
    padding: 0;
}

.topblocklinks li {
    margin: 0;
    padding: 0;
}

/*Tables*/
.Table {
    display: table;
    border-collapse: separate;
    width: 100%;
}

.Heading {
    display: table-row;
    font-weight: bold;
}

.Row {
    display: table-row;
}

.Cell {
    display: table-cell;
    padding: 10px;
    text-align: left;
    border-top: 1px solid #ddd;
}

.Cell1 {
    display: table-cell;
    padding: 10px;
    text-align: left;
    border-top: 0;
}

/*Pagina next*/
ul.paginanext {
    display: inline-block;
    padding: 0;
    margin: 0;
}

ul.paginanext li {
    display: inline;
}

ul.paginanext li a {
    color: black;

    padding: 2px 4px;
    text-decoration: none;
    border-radius: 5px;
}

.loading:after {
    content: ' .';
    animation: dots 1s steps(5, end) infinite;
}

@keyframes dots {
    0%,
    20% {
        color: rgba(0, 0, 0, 0);
        text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    40% {
        color: white;
        text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    60% {
        text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    80%,
    100% {
        text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
    }
}

/* ALGEMEEN */

html,
body {
    color: #333333;
    font-family: sans-serif !important;
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 20px;
}

body {
    min-width: 1024px;
}

#bottom {
    min-width: 1024px !important;
}

img {
    display: block;
}

p,
a,
div {
    font-family: sans-serif !important;
    margin-top: 0;
}

a:link,
a:visited,
a:hover {
    font-family: sans-serif !important;
    color: #333333;
    text-decoration: none;
    font-weight: bold;
}

a:hover {
    text-decoration: underline !important;
    color: #37b5d3;
}

.hoofdmenu a:link,
.hoofdmenu a:visited,
.hoofdmenu a:hover {
    font-weight: normal;
}

input {
    font-family: sans-serif !important;
    color: #333333;
    font-size: 12px;
    padding: 0 4px;
    border: 1px solid #ddd;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

h1 {
    font-size: 20px;
    margin-bottom: 6px;
    margin-top: 0;
}

select {
    margin: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    -webkit-box-shadow: 0;
    -moz-box-shadow: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    line-height: 12px !important;
    clear: both;
    display: block;
    border: 1px solid #e7e6e6;
    background: none;
    width: 100%;
    background-color: #fff;
    padding: 0 10px;
    height: 38px;
    font-family: sans-serif;
    background-repeat: no-repeat;
    background-position: center right;
    /*margin-bottom: 4px;*/
    padding-right: 30px !important;
    cursor: pointer;
    font-size: 12px;
}

.center {
    width: 1020px;
    margin: 0 auto;
    position: relative;
}

/* gewijzigd van ID naar class */

.main {
    margin-top: 20px !important;
}

#noCookieContainer {
    display: none;
}

/* HEADER */

.bigheader-center h1,
.bigheader-center h2 {
    font-size: 22px;
    text-align: center;
}

#logo {
    float: left;
}

#logos {
    float: left;
    width: 70%;
    margin-bottom: 10px;
}

.logos-img {
    float: left;
}

.hoofdmenu {
    clear: both;
}

#slideshow {
    height: 320px;
    overflow: hidden;
    clear: both;
}

#main-image-sub {
    max-height: 380px;
    overflow: hidden;
    clear: both;
}

#slideshow-cruise {
    height: 334px;
    overflow: hidden;
    clear: both;
}

#slideshow img {
    width: auto;
    /* height: auto; */
    min-height: 432px;
    min-width: 100%;
    max-width: none !important;
    height: auto !important;
}

#main-image-sub img,
#main-image-sub2 img {
    width: 100%;
    /*height: auto;*/
    min-height: 432px;
    min-width: 100%;
    margin-top: -40px;
}

#introtekst_leesmeer {
    font-weight: bold;
    cursor: pointer;
}

#introtekst_leesmeer:hover {
    text-decoration: underline;
}

.openingstijden {
    color: #3cb221;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    margin-left: 3px;
}

.openingstijden-dicht {
    color: #000000;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    margin-left: 3px;
}

.lijst {
    margin-left: 200px !important;
    margin-top: 5px !important;
    padding: 3px 3px 3px 7px !important;
    background: #f8f8f8;
    z-index: 5;
    color: initial;
    font-weight: initial;
    border: 1px solid #e6e6e6;
    box-shadow: 0 0 2px 0 rgba(19, 41, 61, 0.2);
}

.lijst-item {
    padding-left: 5px;
    margin-top: 3px !important;
}

.arrow_box {
    position: relative;
    background: #f8f8f8;
    border: 1px solid #e6e6e6;
}

.arrow_box:after,
.arrow_box:before {
    bottom: 100%;
    left: 25%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

.arrow_box:after {
    border-color: rgba(248, 248, 248, 0);
    border-bottom-color: #f8f8f8;
    border-width: 10px;
    margin-left: -10px;
}

.arrow_box:before {
    border-color: rgba(230, 230, 230, 0);
    border-bottom-color: #e6e6e6;
    border-width: 11px;
    margin-left: -11px;
}

.vandaag {
    font-weight: 600;
}

.openingstijden:hover ul {
    display: block;
}

.openingstijden ul {
    position: absolute;
    width: 150px;
    display: none;
}

.openingstijden-dicht:hover ul {
    display: block;
}

.openingstijden-dicht ul {
    position: absolute;
    width: 150px;
    display: none;
}

.lijst ul li {
    display: block;
}

#cruise-logo {
    margin-top: 20px;
}

/* TOPMENU */

.topmenu {
    float: right;
    width: auto;
}

#content h1 {
    font-size: 26px;
    margin-bottom: 8px;
}

.bel {
    float: left;
    text-align: right;
}

.checkjes-box {
    display: flex;
    flex-direction: row;
    margin-top: 17px;
}

.checkjes {
    font-size: 12px !important;
    color: #7bbe69;
    padding-right: 5px;
    margin-top: 4px;
}

.checkjes-text {
    color: black;
    padding-right: 10px;
}

.topmenu ul,
.topmenu ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.topmenu ul li {
    float: left;
    margin-left: 5px;
    margin-top: 8px;
}

.spreek,
.tel {
    clear: both;
    display: block;
}

.tel {
    font-size: 25px;
    color: #f39c12;
    font-weight: bold;
}

.tijden {
    color: #666666;
    font-size: 12px;
}

.topmenu ul li.item288 {
    border-right: 1px solid #f0f0f0;
    padding-right: 20px;
    margin-top: 0;
}

/* MENU V2 */

/*.hoofdmenu .menu,
.hoofdmenu .sub-menu {list-style-type: none; margin: 0; padding: 0;}
.hoofdmenu .menu li {background-color: #eee; font-size: 14px; text-transform: uppercase; cursor: pointer; position: relative; transition: background-color .5s; -moz-transition: background-color .5s; -o-transition: background-color .5s; -webkit-transition: background-color .5s;}
.hoofdmenu .menu li:hover {background-color: #37b5d3;}
.hoofdmenu .menu li:hover a:hover,.hoofdmenu .menu li a:hover,.hoofdmenu .menu li:hover a {background-image:none !important;color:#fff !important;}
.hoofdmenu .menu li.submenudrop ul li a {color:#333 !important;}
.hoofdmenu .menu li li a {color:#333 !important;}
.hoofdmenu .menu li:hover li:hover a {color:#fff !important;}
.copyrightmenu a {font-weight:bold !important;}
.euro {display:none !important;}
.header3 a {color:#2178b3 !important;}
.aanbiedingen_datepicker2 {height:38px !important;line-height:38px !important;}
#filter #filtersubcontent input {width:100% !important;}
#filter #begindatum2, #filter #einddatum {background-position:194px !important;}
.select {clear: both; width: 100%; float: left}
.hoofdmenu .menu a {color: #333333; display: block; font-family: 'Open Sans', sans-serif; font-size: 14px; height: 100%; margin: 0 5px; overflow: hidden; position: relative; text-align: center; text-decoration: none; text-transform: uppercase; word-wrap: break-word; line-height:50px; padding: 0 20px;}
.hoofdmenu .menu a:hover {color: #fff;text-decoration:none !important;}
.hoofdmenu .menu {height: 50px;float:right;}
.hoofdmenu .menu > li {float: left; height: 100%; width:auto; margin-right:1px; padding: 0 4px;}
.hoofdmenu .menu li.submenudrop a:hover {background-image:none;}
.hoofdmenu .menu li.submenudrop-current ul li a,.hoofdmenu .menu li.submenudrop ul li a {background-image:none;text-transform:none;}
.hoofdmenu .menu > li.current,.hoofdmenu .menu > li.submenudrop-current {background-color: #37b5d3 !important; !* !important VS .menu li:hover *! color:#fff; box-shadow: none !important; -moz-box-shadow: none !important; -webkit-box-shadow: none !important;}
.hoofdmenu .menu > li.current a {color:#fff !important;}
.hoofdmenu .sub-menu li.current {background-color: #37b5d3 !important; color: #fff !important;}
.hoofdmenu .menu li.submenudrop ul li a:hover > li.submenudrop a {color:#fff !important;}

.submenudrop a.level-1:after {
background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);background-position: -828px -132px;
    display: block;
    width: 21px;
    height: 16px;
    content: "";
    display: block;
    position: absolute;
    top: 15px;
    right: 0px;}
    }


.hoofdmenu {margin-top:16px; z-index: 99999;float: right;}*/

/* MENU V3 */

.hoofdmenu-wrapper {
    width: 100%;
    float: right;
    background-color: #ffffff;
    border-top: solid 1px #f0f0f0;
    border-bottom: solid 1px #f0f0f0;
}

.hoofdmenu .menu,
.hoofdmenu .sub-menu {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.hoofdmenu .menu li {
    font-size: 14px !important;
    text-transform: uppercase;
    cursor: pointer;
    position: relative;
    transition: background-color 0.5s;
    -moz-transition: background-color 0.5s;
    -o-transition: background-color 0.5s;
    -webkit-transition: background-color 0.5s;
}

.hoofdmenu .menu .home-button {
    font-size: 20px;
}

.hoofdmenu .menu li:hover {
    background-color: #eeeeee;
}

.hoofdmenu .menu li ul li:hover {
    background-color: #d1d1d1;
}

.hoofdmenu .menu li:hover a:hover,
.hoofdmenu .menu li a:hover,
.hoofdmenu .menu li:hover a {
    background-image: none !important;
}

.hoofdmenu .menu li.submenudrop ul li a {
    color: #333 !important;
}

.hoofdmenu .menu li li a {
    color: #333 !important;
}

.hoofdmenu .menu li:hover li:hover a {
    color: #000000 !important;
}

.copyrightmenu a {
    font-weight: bold !important;
}

.euro {
    display: none !important;
}

.header3 a {
    color: #2178b3 !important;
}

.aanbiedingen_datepicker2 {
    height: 38px !important;
    line-height: 38px !important;
}

#filter #filtersubcontent input {
    width: 100% !important;
}

#filter #begindatum2,
#filter #einddatum {
    background-position: 194px !important;
}

.select {
    clear: both;
    width: 100%;
    float: left;
}

.hoofdmenu .menu a {
    color: #333;
    display: block;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    height: 100%;
    margin: 0 5px;
    overflow: hidden;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    word-wrap: break-word;
    line-height: 50px;
    padding: 0 5px;
}

.hoofdmenu .menu a:hover {
    text-decoration: none !important;
}

.hoofdmenu .menu .level-1 {
    font-weight: bold;
}

.hoofdmenu .menu {
    height: 50px;
    float: left;
}

.hoofdmenu .menu-extra {
    float: right !important;
}

.hoofdmenu .menu > li {
    float: left;
    height: 100%;
    width: auto;
    margin-right: 1px;
    padding: 0 4px;
}

.hoofdmenu .menu li.submenudrop a:hover {
    background-image: none;
}

.hoofdmenu .menu li.submenudrop-current ul li a,
.hoofdmenu .menu li.submenudrop ul li a {
    background-image: none;
    text-transform: none;
}

.hoofdmenu .menu > li.current a {
    color: #333 !important;
}

.hoofdmenu .sub-menu {
    background-color: #eee;
}

.hoofdmenu .sub-menu li.current {
    background-color: #79c8da !important;
    color: #fff !important;
}

.hoofdmenu .menu li.submenudrop ul li a:hover > li.submenudrop a {
    color: #fff !important;
}

/*
Booked counter menu
 */

#booked_counter {
    padding-top: 15px;
    font-size: 14px !important;
}

#booked_counter > .counter_item {
    font-weight: bold;
    background-color: #f0f0f0;
    padding: 7px;
    border-radius: 4px;
    border-bottom: solid 2px #aeaeae;
}

#booked_counter > .counter_item:first-child {
    margin-left: 10px;
}

#booked_counter > .background {
    position: relative;
    z-index: 1;
}

#booked_counter > .background:before {
    border-top: 2px solid #dfdfdf;
    content: '';
    margin: 0 auto;
    /* this centers the line to the full width specified */
    position: absolute;
    /* positioning must be absolute here, and relative positioning must be applied to the parent */
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: -1;
}

/* mega menu */

.big-menu-wrapper {
    position: inherit !important;
}

.big-menu {
    background-color: #fff !important;
}

.big-menu .big-menu-list {
    list-style-type: none;
    width: 25%;
    height: auto;
    padding: 10px 0;
    background-color: #fff !important;
}

.big-menu > li {
    border-bottom: none !important;
}

.big-menu > li:hover {
    background-color: inherit !important;
}

.big-menu .big-menu-list > li {
    font-size: 12px !important;
    height: auto !important;
    list-style-type: none;
    width: 85%;
    text-transform: none;
    line-height: 30px;
}

.big-menu .big-menu-list > li:hover {
    background-color: inherit !important;
}

.big-menu .big-menu-list > li > b {
    color: #37b5d3;
    text-transform: uppercase;
}

.big-menu .big-menu-list .big-menu-image-title {
    border-bottom: none !important;
    width: 100%;
    text-align: center;
}

.big-menu .big-menu-list .big-menu-image {
    border-bottom: none !important;
    width: 50%;
}

.big-menu .big-menu-list .big-menu-image > .big-menu-circle-image {
    background-size: cover !important;
    background-position: center !important;
    border-radius: 50px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    margin: 0 auto;
    height: 100px;
    width: 100px;
}

.big-menu .big-menu-list .big-menu-image > p {
    text-align: center;
}

/*
Booked counter menu
 */

#booked_counter {
    padding-top: 15px;
    font-size: 14px !important;
}

#booked_counter > .counter_item {
    font-weight: bold;
    background-color: #f0f0f0;
    padding: 7px;
    border-radius: 4px;
    border-bottom: solid 2px #aeaeae;
}

#booked_counter > .counter_item:first-child {
    margin-left: 10px;
}

#booked_counter > .background {
    position: relative;
    z-index: 1;
}

#booked_counter > .background:before {
    border-top: 2px solid #dfdfdf;
    content: '';
    margin: 0 auto;
    /* this centers the line to the full width specified */
    position: absolute;
    /* positioning must be absolute here, and relative positioning must be applied to the parent */
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: -1;
}

/*
Facebook like button in menu
 */

.facebook_menu {
    padding-top: 15px;
    clear: right;
}

/* CAMPAIGN */

.campaign-left {
    width: 50%;
    position: absolute;
    top: 0;
    left: 0;
    height: 70px;
}

.campaign-button {
    width: 20%;
    display: block;
    float: right;
    margin-top: 20px;
}

.campaign-slogan {
    width: 54%;
    display: block;
    float: initial;
    font-size: 16px;
    line-height: 70px;
}

.campaign-sale {
    width: 25%;
    display: block;
    float: left;
    font-size: 20px;
}

/*.campaign-sale:after {
    content: "";
    display: block;
    border: 35px solid #3d97cb !important;
    border-left-color: #0066b3 !important;
    position: absolute;
    top: 0;
    margin-left: -49px;
    left: 100%;
    z-index: 0;
}*/

#campaign,
.campaign {
    min-height: 70px;
    position: relative;
}

.banner-groen {
    background-color: #444;
}

.banner-oranje {
    background-color: #fd6e6e;
}

.banner-oranje .campaign-button a {
    background: #fa4c5a !important;
}

.banner-groen .campaign-button a {
    background: #333 !important;
}

/* waarom cruisereizen */

.checks {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

/* FILTER */

#home-filter {
    position: absolute;
    background-color: #fff;
    width: 300px;
    left: 10px;
    top: 25px;
    z-index: 100;
}

.link-arrow {
    font-weight: normal !important;
}

.link-arrow:hover {
    text-decoration: none !important;
}

.link-arrow:after {
    white-space: pre;
    content: ' >\A';
    font-size: 14px;
    margin-left: 4px;
}

/* TRAVEL ICONS */

.travel-icons {
    margin-top: 15px;
}

.fly {
    display: block;
    width: 20px;
    height: 20px;
    float: left;
}

.cruise {
    display: block;
    width: 20px;
    height: 20px;
    float: left;
}

.plus {
    display: block;
    width: 20px;
    height: 20px;
    float: left;
}

.buttongrijs {
    background-color: #efefef;
    width: auto;
    padding: 8px;
    float: left;
    font-size: 11px;
    margin-top: 4px;
    font-weight: normal;
    cursor: pointer;
}

.buttongrijs:hover {
    font-size: 11px !important;
    font-weight: normal !important;
    text-decoration: none !important;
}

.delete {
    font-weight: bold;
}

.slideshow-text {
    position: absolute;
    color: #fff;
    font-size: 30px;
    margin-top: 132px;
    width: 587px;
    text-align: center;
    line-height: 42px;
}

.topline {
    font-size: 40px;
    font-weight: bold;
}

.subline {
    padding-top: 30px;
}

.filter-header {
    color: #fff;
    font-size: 20px;
    margin: 0;
    text-transform: uppercase;
    padding-left: 15px;
    font-weight: normal;
    background-color: #37b5d3;
    padding: 16px;
    padding-bottom: 12px;
    background-position: 10px;
}

.front-featured,
.cruiseblok {
    position: relative;
    border: 1px solid #e3e3e3;
}

.filter-body {
    padding: 16px;
    text-transform: uppercase;
}

.call {
    font-size: 14px;
    padding-left: 20px;
}

.call img {
    position: absolute;
    margin-top: 6px;
    height: 18px;
    margin-left: -24px;
}

.cruise-foto {
    overflow: hidden;
}

.cruise-foto img {
    width: 104%;
    min-height: 146px !important;
    margin-left: -9px;
}

#front-banner img {
    width: 255px;
}

.cruise-boeken {
    text-align: center;
}

.block .nolist li {
    float: none;
}

/* BEGIN */

.hoofdmenu .sub-menu {
    max-height: 0;
    min-width: 100%;
    overflow: hidden;
    position: absolute;
    /*top: 100%;*/
    transition: max-height 0.5s 0.2s;
    -moz-transition: max-height 0.5s 0.2s;
    -o-transition: max-height 0.5s 0.2s;
    -webkit-transition: max-height 0.5s 0.2s;
    left: 0;
    z-index: 100000 !important;
}

/* Rederij menu dropdown max-height */
li:hover > .sub-menu {
    max-height: 1000px;
}

.hoofdmenu .sub-menu li {
    height: 45px;
    border-bottom: 1px solid #ddd;
}

.introbg {
    height: 250px;
    position: absolute;
    width: 460px;
    /* margin-top: -200px; */
    z-index: 0;
}

.introtekst {
    z-index: 1000000 !important;
    position: relative;
}

.introtekst h1 {
    color: #2178b3 !important;
}

.hoofdmenu .sub-menu a {
    line-height: 45px;
    transition: color 0.5s;
    -moz-transition: color 0.5s;
    -o-transition: color 0.5s;
    -webkit-transition: color 0.5s;
    white-space: nowrap;
    width: 200px;
    text-align: left;
    padding-left: 18px;
}

.slogan {
    display: none;
}

.highlight {
    font-weight: bold;
    outline: 3px solid #37b5d2;
    outline-offset: -3px;
}

.hoofdmenu .menu li:hover li a {
    color: #333 !important;
}

.hoofdmenu .menu li:hover li.current a {
    color: #fff !important;
}

.submenudrop-current a {
    color: #fff !important;
}

.hoofdmenu .sub-menu li.current a,
.hoofdmenu .sub-menu a:hover {
    background-color: transparent;
    color: #fff !important;
    /* !important VS .menu a:hover */
}

#begindatum,
#begindatum2,
#einddatum {
    clear: both;
    display: block;
    border: 1px solid #cccccc;
    background: none;
    width: 100%;
    background-color: transparent;
    padding: 0 10px;
    height: 36px;
    line-height: 36px;
    background-position: right 10px center;
    font-family: sans-serif;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.text-cal {
    background-color: #fff;
    position: relative;
    clear: both;
}

.text-cal::after {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -772px -132px;
    display: block;
    width: 21px;
    height: 16px;
    content: '';
    display: block;
    position: absolute;
    top: 10px;
    right: 6px;
    pointer-events: none;
}

.text-cal input {
    cursor: pointer !important;
}

.select-drop,
.smallselect-drop {
    background-color: #fff;
    position: relative;
    clear: both;
}

.select-drop::after {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -806px -132px;
    display: block;
    width: 11px;
    height: 16px;
    content: '';
    display: block;
    position: absolute;
    top: 10px;
    right: 11px;
    pointer-events: none;
}

.smallselect-drop::after {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -806px -132px;
    display: block;
    width: 11px;
    height: 16px;
    content: '';
    display: block;
    position: absolute;
    top: 3px;
    right: 11px;
    pointer-events: none;
}

.ui-datepicker-month,
.ui-datepicker-year {
    height: 22px;
    clear: none;
    float: left;
    margin-right: 5px;
}

.ui-datepicker-month::after,
.ui-datepicker-year::after {
    /*background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);background-position: -806px -132px;*/
    display: block;
    width: 11px;
    height: 16px;
    content: '';
    display: block;
    position: absolute;
    top: 3px;
    right: 11px;
    pointer-events: none;
}

.artikel-content ul {
    margin: 0;
}

.displaynone {
    display: none;
}

#faq .vraag {
    font-weight: bold;
    cursor: pointer;
}

#logo img {
    display: inherit;
}

.intro,
#intro {
    position: absolute;
    margin-top: -366px;
    width: 45% !important;
    left: 50%;
    padding: 20px;
    z-index: 10;
    background-image: url(https://cdn.cruisereizen.nl/img/template/transbg.png);
    background-repeat: repeat;
    overflow: hidden;
}

.korting_label {
    text-align: center;
    font-size: 14px;
    font-family: arial !important;
    margin-bottom: 26px;
    background-color: #ff0066;
    padding: 12px;
    font-weight: bold;
    margin: 0;
    color: #fff;
    clear: both;
    display: block;
    margin-bottom: 7px;
    -webkit-transform: rotate(8deg);
    -moz-transform: rotate(8deg);
    -o-transform: rotate(8deg);
    -ms-transform: rotate(8deg);
    transform: rotate(8deg);
    position: absolute;
    margin-top: 216px;
    margin-left: 65%;
    z-index: 100;
}

.cruiseblok .korting_label {
    -webkit-transform: rotate(-5deg);
    -moz-transform: rotate(-5deg);
    -o-transform: rotate(-5deg);
    -ms-transform: rotate(-5deg);
    transform: rotate(-5deg);
    margin-top: 0;
    margin-left: -10px;
}

.ajax_loader2 {
    position: fixed !important;
}

#slides {
    display: none;
}

#slides .slidesjs-navigation {
    margin-top: 3px;
}

#slides .slidesjs-previous {
    margin-right: 5px;
    float: left;
}

#slides .slidesjs-next {
    margin-right: 5px;
    float: left;
}

.slidesjs-pagination,
.slidesjs-pagination2 {
    margin: 6px 0 0;
    float: right;
    list-style: none;
}

.slidesjs-pagination li,
.slidesjs-pagination2 li {
    float: left;
    margin: 0 1px;
    font-size: 0;
    /*background-color: white;*/
}

.slidesjs-pagination li a,
.slidesjs-pagination2 li a {
    display: block;
    width: 13px;
    height: 0;
    padding-top: 13px;
    background-position: 0 0;
    float: left;
    overflow: hidden;
}

.infocruise .slidesjs-pagination li a {
    background-image: none;
    padding: 0;
}

.slidesjs-pagination li a:hover,
.slidesjs-pagination2 li a:hover {
    background-position: 0 -26px;
}

#slides a:link,
#slides a:visited {
    color: #fff;
}

#slides a:hover,
#slides a:active {
    color: #fff;
}

.navbar {
    overflow: hidden;
}

.slider {
    z-index: -1;
}

/* SLIDER */

.slidesjs-previous {
    margin-top: -34px !important;
    z-index: 100000;
    position: relative;
    margin-left: 50px;
    display: none !important;
}

.slidesjs-next {
    margin-top: -34px !important;
    z-index: 100000;
    position: relative;
    margin-left: 66px;
    display: none !important;
}

.slidesjs-container {
    height: 562px !important;
}

.slidesjs-pagination {
    margin-top: -176px;
    z-index: 10 !important;
    position: relative;
    margin-right: 50px;
    float: left;
}

.slidesjs-pagination2 {
    margin-top: -34px;
    z-index: 10000;
    position: relative;
    margin-right: 50px;
    float: left;
}

.slidesjs-pagination {
    margin-top: -340px;
}

/*.infocruise .slidesjs-pagination2{margin-top:-253px;}*/

.slidesjs-pagination li a,
.infocruise .slidesjs-pagination2 li a {
    width: 118px;
    height: 37px;
    background-size: 200%;
    background-position: 38% 43%;
    font-size: 0;
}

.slidesjs-pagination li a {
    height: 50px;
    background-color: #fff;
    opacity: 0.5;
    transition: all 0.4s;
}

.slidesjs-pagination li a.active {
    opacity: 100;
}

.slidesjs-pagination li a:hover {
    opacity: 100;
    margin: 0;
    padding: 0;
    background-position: bottom left;
    padding-top: 13px;
}

/* DIVIDERS */

.divider {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-repeat: repeat-x;
    background-position: -4px -522px;
    display: block;
    height: 5px;
    width: 100%;
    clear: both;
}

#divider2 {
    border-top: 1px dashed #ccc;
    display: block;
    height: 5px;
    width: 100%;
    clear: both;
}

/* FRONT FEATURED */

.block {
    display: block;
    position: relative;
    margin-bottom: 15px;
}

.inlineblock {
    display: inline-block;
}

.prijsfly {
    right: 0;
    margin-top: -12px;
    margin-right: -12px;
}

.front-featured,
.cruiseblok {
    position: relative;
    border: 1px solid #e3e3e3;
}

#front-blok {
    border: 1px solid #f5f5f5;
}

.front-featured img {
    width: 100%;
}

.front-featured .rederij-logo img {
    margin: 0 auto;
}

#middle-top {
    clear: both;
    display: block;
    float: left;
}

.fooien_inclusief .width58 {
    width: 60% !important;
}

#overcruise {
    display: none;
}

#ui-datepicker-div {
    width: 302px !important;
    background-color: #fff !important;
}

.ui-datepicker td span,
.ui-datepicker td a {
    padding: 0.8em !important;
}

#overcruise {
    position: absolute;
    margin-top: 46px;
    left: 63%;
    padding: 20px;
    background-image: url(https://cdn.cruisereizen.nl/img/template/transbg.png);
    background-repeat: repeat;
    width: 256px !important;
}

#intro h2,
.intro h2,
#overcruise h2 {
    font-size: 14px;
    margin-bottom: 4px;
}

.filterbutton {
    margin-top: 15px;
    width: 100%;
    display: block;
    clear: both;
    float: left;
    position: relative;
}

.regel {
    clear: both;
}

.checks {
    clear: both;
}

.front-featured a.button:hover {
    color: #fff !important;
}

.filterzoeken {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    width: 100%;
    background-color: #f39c12;
    transition: all 0.4s;
    border: 0;
    color: #fff;
    padding: 16px 0;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    text-shadow: 1px 1px #da8c0e;
    cursor: pointer;
}

.campaign-button a {
    opacity: 0.8;
    transition: all 0.4s;
}

.campaign-button a:hover {
    opacity: 1;
}

#newsletter-content input.button:hover {
    background-color: #d58a13 !important;
}

.filterzoeken:hover {
    background-color: #d58a13 !important;
}

.artikel-content h2 {
    margin-bottom: 5px;
    font-size: 14px;
}

#cruise-overzicht {
    float: left;
    border: 3px solid #e3f8fe;
    margin-top: 0;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
}

#cruise-overzicht:after {
    width: 40px;
    height: 60px;
    content: ' ';
    display: block;
    position: absolute;
    right: -17px;
    top: -25px;
    background-color: #fff;
    border-left: 4px solid #e3f8fe;
    transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    /* IE 9 */
    -webkit-transform: rotate(-45deg);
    /* Safari and Chrome */
}

.cruise-rederijlogo img {
    width: 120px;
}

.opsomming {
    list-style-type: none;
    padding: 0;
    margin: 0;
    float: left;
    display: block;
    clear: both;
    width: 100%;
}

.opsomming li {
    border-bottom: 1px dashed #e8e8e8;
    width: 100%;
    padding-top: 8px;
    padding-bottom: 8px;
    line-height: 26px;
}

.dagplanning {
    background-color: #f8f8f8;
    float: left;
}

.clear {
    display: block;
    clear: both;
    height: 0;
    width: 100%;
    position: relative;
}

.noclear {
    clear: none !important;
}

.usp {
    border: 1px solid #f5f5f5;
    margin: 0 9px;
    padding: 20px 0;
    padding-bottom: 10px;
    -moz-box-shadow: 0 0 4px #efefef;
    -webkit-box-shadow: 0 0 4px #efefef;
    box-shadow: 0 0 4px #efefef;
    text-align: center;
    margin-bottom: 20px;
}

.button,
.button:link,
.button:visited,
.button:hover {
    margin-top: 10px;
    position: relative;
    border: none;
    background-color: #f39c12;
    font-weight: bold;
    color: #fff;
    outline: none;
    transition: all 0.4s;
    cursor: pointer;
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    text-align: center;
    display: block;
    text-transform: uppercase;
    height: 30px;
    line-height: 32px;
}

.button:hover {
    text-decoration: none;
    background-color: #d58a13;
}

.button5 {
    cursor: pointer;
}

.button5:hover {
    color: #fff;
    background-color: #9dd057 !important;
}

#footer-1 {
    width: 100%;
    background-color: #0d89a7;
    float: left;
}

.cruise-overzicht .stap-header {
    display: none;
}

.blog-image {
    width: 200px;
    height: 146px;
    overflow: hidden;
}

.blog-article {
    height: 146px;
}

.blog-image img {
    width: 208px;
    height: 146px;
    margin-left: -12px;
}

.blogartikel-image {
    width: 200px !important;
}

.blogartikel-article .blog-intro {
    height: auto;
    overflow: hidden;
}

.blogartikel-article .blog-intro img {
    height: auto !important;
    width: 100%;
}

#topmenu {
    background-color: #f6f6f6;
    height: 40px;
    line-height: 40px;
    width: 100%;
    color: #666;
    display: none;
    padding: 0 15px;
}

#campaign,
.slideshow-text {
    display: block;
}

.topmenucontent,
#topmenu input {
    color: #666;
}

.topmenucontent .button {
    height: 25px !important;
    margin-top: 8px !important;
    font-size: 14px !important;
    line-height: 15px !important;
}

.topmenucontent,
#topmenu input {
    height: 25px;
}

.cruiseimageoverlay {
    border-radius: 5px;
}

.cruisemarketingimageoverlay {
    border-radius: 5px 5px 1px 1px;
}

.cruiseimage-textreposition {
    position: absolute;
    width: 30%;
    margin-top: -160px;
}

.cruisedestination-textreposition {
    position: absolute;
    width: 12%;
    margin-top: -115px;
}

.underline-white {
    color: white !important;
}

.buttonradius {
    border-radius: 2px !important;
}

/* Waiting pagina */

#waiting {
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-attachment: fixed;
    color: #fff;
    font-size: 75%;
    height: 100%;
    background-position: center;
}

#waiting .text {
    top: 118px;
    text-align: center;
}

#waiting h1 {
    color: #fff;
    font-size: 38px;
    margin-bottom: 14px;
}

#waiting p {
    font-size: 24px;
    color: #fff;
}

#waiting .middle {
    width: 100%;
    position: fixed;
    bottom: 0;
}

#waiting .middle-footer {
    margin: 0 auto;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
}

#waiting .text img {
    margin: 0 auto;
}

#waiting .middle-footer span {
    margin-right: 20px;
}

#waiting .image-loader {
    height: 25px;
    width: 270px;
    margin-left: 200px;
    overflow: hidden;
}

#waiting .image-loader img {
    margin-top: -137px;
    margin-left: -66px;
    width: 400px;
}

/* Progress labels en bars */

.progress {
    height: 20px;
    padding: 1px;
    background-color: #f7f7f7;
    border: 1px solid #eeeeee;
    overflow: hidden;
    margin-bottom: 20px;
    border-radius: 8px;
}

.progress__bar {
    display: block;
    height: 100%;
    background: #5bc0de;
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 34px -7px rgba(0, 0, 0, 0.83);
    -moz-box-shadow: inset 0 0 34px -7px rgba(0, 0, 0, 0.83);
    box-shadow: inset 0 0 34px -7px rgba(0, 0, 0, 0.83);
}

.progress__label {
    float: right;
    padding: 0 2px;
    color: #ffffff;
    font-size: 12px;
}

.progress--radius {
    border-radius: 2px;
}

.progress--round {
    border-radius: 1000px;
}

.progress--radius .progress__bar,
.progress--round .progress__bar {
    border-radius: inherit;
}

.progress--small {
    height: 15px;
}

.progress--large {
    height: 10px;
}

.progress--success .progress__bar {
    background-color: #43ac6a;
}

.progress--alert .progress__bar {
    background-color: #f04124;
}

.progress--striped .progress__bar {
    background-size: 40px 40px;
}

.cruiseinfoimg {
    cursor: pointer !important;
    color: #3976e4;
    font-size: 15px !important;
}

.blog-intro-blok {
    position: absolute !important;
    width: 500px !important;
    left: 0 !important;
    margin-left: 50px !important;
    margin-top: 24px !important;
    background-image: url(https://cdn.cruisereizen.nl/img/template/transbg.png);
    background-repeat: repeat;
    overflow: hidden;
}

/*Cruise thumbnails movile version*/
#slider_epic {
    position: relative;
}

#slider_epic > .slider_arrow_left,
#slider_epic > .slider_arrow_right {
    color: #fff;
    display: block;
    position: absolute;
}

#slider_epic > .slider_arrow_left:hover,
#slider_epic > .slider_arrow_right:hover {
    color: #37b5d3;
}

#slider_epic > .slider_arrow_left {
    left: 20px;
    top: 50%;
}

#slider_epic > .slider_arrow_right {
    right: 20px;
    top: 50%;
}

#mc_embed_signup input.button {
    background-image: none !important;
    width: 178px !important;
    color: #fff;
    height: 44px;
    border: 0;
    cursor: pointer;
}

.artikel-intro {
    height: 282px;
    width: auto;
}

.artikel-intro img {
    height: 280px;
    width: auto;
}

#map {
    text-align: center;
}

#map img {
    opacity: 0.4;
}

.stap-content {
    background-color: #ffffff;
    .hut {
        width: 20% !important;
    }
    .bedrag {
        width: 25% !important;
    }
}
@media screen and (max-width: 400px) {
    .stap-content {
        .hut {
            width: 50% !important;
        }
        .bedrag {
            width: 100% !important;
        }
    }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
    .stap-content {
        .hut {
            width: 33% !important;
        }
        .bedrag {
            width: 50% !important;
        }
    }
}
.stap-content .cijfers {
    overflow: hidden;
    white-space: nowrap !important;
    float: none !important;
}

.stap-content .cijfers .width24 .width100 {
    width: 100% !important;
}

.rederij-logo img {
    height: 30px;
    width: auto !important;
    margin: 0 auto;
}

.rederij-logo {
    display: block;
    text-align: center;
    margin-top: 10px;
    padding-top: 10px;
}

.selected-cruises {
    background-color: #edf6fd;
}

#filter .block-content {
    background-color: #f7f7f7;
}

#cruise-overzicht .stap-header {
    display: none !important;
}

.front-featured {
    background-color: #fff;
    position: relative;
    padding-right: 2px;
    margin-bottom: 15px;
}

.cruise-prijs-content {
    margin: 2px;
    background-color: #f7f7f5;
    text-align: center;
}

.cruise-prijs-content-image img {
    height: 30px;
    display: inline;
}

.cruise-prijs-content-prijs {
    z-index: 1;
}

.cruise-prijs-content-prijs-vanaf {
    clear: both;
    display: block;
    margin-bottom: 2px;
}

.cruise-prijs-content-prijs-euro {
    font-size: 14px;
}

.cruise-prijs-content-prijs-bedrag {
    font-size: 24px;
}

.vaarroute_extra_informatie {
    background: none repeat scroll 0 0 #ffedbc;
    border: 1px solid #eeae01;
    padding: 5px 10px;
    border-radius: 5px;
}

/* nieuwsbrief */

#newsletter {
    width: 100%;
    background-color: #f0f0f0;
    float: left;
}

#newsletter-content h3 {
    color: #fda61c;
    font-size: 18px;
    margin: 0;
    padding: 0;
    margin-bottom: 4px;
}

#newsletter-content input {
    float: left;
    margin-right: 8px !important;
    height: 42px;
    padding: 0 16px;
    transition: all 0.4s;
    line-height: 46px;
    font-family: sans-serif;
    font-size: 12px;
    width: 198px;
    background-position: right 15px center;
    background-repeat: no-repeat;
    margin-top: 0 !important;
    border: 1px solid #cccccc !important;
}

#newsletter-content input.button {
    width: auto !important;
    border: 0 !important;
}

#front-newsletter,
#filter {
    border: 1px solid #eee;
    margin-bottom: 10px;
}

#front-newsletter input,
#filter input {
    padding: 4px 6px;
    width: 94%;
    font-size: 12px;
}

/*footer */

.footer-blok {
    color: #fff !important;
}

#footer-1 a,
#footer-1 a:link,
#footer-1 a:visited,
#footer-1 a:hover {
    color: #fff;
}

#footer-1 ul,
#footer-1 ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

/* footer-2 */

.copyrightmenu ul,
.copyrightsocial ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.copyrightsocial ul li,
.copyrightmenu ul li {
    float: left;
}

.copyrightmenu li {
    margin-right: 20px;
}

.copyrightsocial li {
    margin-right: 5px;
}

.copyright img {
    margin-bottom: 8px;
}

.totaal {
    border-top: 1px solid #eee;
}

.copyrightsocial,
.copyrightmenu {
    line-height: 36px;
}

.usp span {
    clear: both;
    display: block;
    font-size: 20px;
    line-height: 26px;
}

.usp p {
    font-weight: normal;
    font-size: 12px;
    margin-top: 4px;
    padding: 0 20px;
    color: #333333;
}

.d-flex {
    display: flex;
    flex-wrap: wrap;
}

.footer-item-logo {
    width: 25%;
}

.footer-item-menu {
    width: 20%;
}

.footer-item-images {
}

/* Temaplate Width */

.width2 {
    float: left;
    width: 2%;
}

.width5 {
    float: left;
    width: 5%;
}

.width15 {
    float: left;
    width: 15%;
}

.width17 {
    float: left;
    width: 17%;
}

.width21 {
    float: left;
    width: 21%;
}

.width22 {
    float: left;
    width: 22%;
}

.width28 {
    float: left;
    width: 28%;
}

.width18 {
    float: left;
    width: 18%;
}

.width19 {
    float: left;
    width: 19%;
}

.width20 {
    float: left;
    width: 20%;
}

.width40 {
    float: left;
    width: 40% !important;
}

.width21 {
    float: left;
    width: 21%;
}

.width22 {
    float: left;
    width: 22%;
}

.width23 {
    float: left;
    width: 23%;
}

.width24 {
    float: left;
    width: 24%;
}

.widthimp24 {
    float: left;
    width: 24% !important;
}

.widthimp31 {
    float: left;
    width: 31% !important;
}

.widthimp32 {
    float: left;
    width: 32% !important;
}

.widthimp33 {
    float: left;
    width: 33% !important;
}

.width25 {
    float: left;
    width: 25%;
}

.width26 {
    float: left;
    width: 26%;
}

.width10 {
    float: left;
    width: 10%;
}

.width29 {
    float: left;
    width: 29%;
}

.width30 {
    float: left;
    width: 31%;
}

.width31 {
    float: left;
    width: 31%;
}

.width32 {
    float: left;
    width: 32% !important;
}

.width33 {
    float: left;
    width: 33%;
}

.width35 {
    float: left;
    width: 35%;
}

.width36 {
    float: left;
    width: 36% !important;
}

.width37 {
    float: left;
    width: 37% !important;
}

.width38 {
    float: left;
    width: 38% !important;
}

.width42 {
    float: left;
    width: 42%;
}

.width45 {
    float: left;
    width: 45%;
}

.width48 {
    width: 48%;
    float: left;
}

.width49 {
    width: 49%;
    float: left;
}

.width44 {
    float: left;
    width: 44%;
}

.width45 {
    float: left;
    width: 45%;
}

.width46 {
    float: left;
    width: 46%;
}

.width47 {
    float: left;
    width: 47%;
}

.width48 {
    float: left;
    width: 48%;
}

.width50 {
    float: left;
    width: 50%;
}

.width52 {
    float: left;
    width: 52% !important;
}

.width58 {
    float: left;
    width: 58% !important;
}

.width55 {
    float: left;
    width: 55%;
}

.width59 {
    float: left;
    width: 59%;
}

.width60 {
    float: left;
    width: 60%;
}

.width61 {
    float: left;
    width: 61%;
}

.width62 {
    float: left;
    width: 62%;
}

.width65 {
    float: left;
    width: 65%;
}

.width66 {
    float: left;
    width: 66%;
}

.width68 {
    float: left;
    width: 68%;
}

.width69 {
    float: left;
    width: 69%;
}

.width70 {
    float: left;
    width: 70%;
}

.width72 {
    float: left;
    width: 72%;
}

.width73 {
    float: left;
    width: 73%;
}

.width74 {
    float: left;
    width: 74%;
}

.width75 {
    float: left;
    width: 75%;
}

.width80 {
    float: left;
    width: 80%;
}

.width85 {
    float: left;
    width: 85%;
}

.width90 {
    float: left;
    width: 90%;
}

.width92 {
    float: left;
    width: 92%;
}

.width93 {
    float: left;
    width: 93%;
}

.width94 {
    float: left;
    width: 94%;
}

.width95 {
    float: left;
    width: 95%;
}

.width100 {
    float: left;
    width: 100%;
}

.width98 {
    float: left;
    width: 98%;
}

.width100000 {
    float: left;
    width: 100%;
    overflow: hidden;
    white-space: nowrap !important;
}

.widthauto {
    width: auto !important;
}

.widthpix5 {
    width: 5px;
}

.widthpix10 {
    width: 10px;
}

.widthpix15 {
    width: 15px;
}

.widthpix50 {
    width: 50px;
}

.widthpix75 {
    width: 75px;
}

/* Template Height */

.height1 {
    height: 1px;
}

.height5 {
    height: 5px;
}

.height10 {
    height: 10px;
}

.height15 {
    height: 15px;
}

.height20 {
    height: 20px;
}

.height25 {
    height: 25px;
}

.height23 {
    height: 23px;
}

.lineheight18 {
    line-height: 18px !important;
}

.lineheight22 {
    line-height: 22px;
}

.height30 {
    height: 30px;
}

.height36 {
    height: 36px;
}

.height38 {
    height: 38px;
}

.height38imp {
    height: 38px !important;
}

.lineheight30 {
    line-height: 30px;
}

.lineheight36 {
    line-height: 36px;
}

.lineheight38 {
    line-height: 38px;
}

.lineheight38imp {
    line-height: 38px !important;
}

.lineheight40 {
    line-height: 40px;
}

.lineheight42 {
    line-height: 42px;
}

/* Pagination */

.pagination {
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 20px;
    width: 100%;
    clear: both;
    display: block;
    text-align: center;
}

.pagination a,
.pagination strong {
    background: #fff;
    display: inline-block;
    margin-right: 3px;
    padding: 4px 12px;
    text-decoration: none;
    line-height: 1.5em;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
}

.pagination a:hover {
    background-color: #bebebe !important;
    color: #fff !important;
}

.pagination-active {
    background-color: #bebebe !important;
    color: #fff !important;
}

.pagination a {
    cursor: pointer;
}

/* TABJES */

.cruise-tabs-ul,
.cruise-tabs-ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.cruise-tabs-ul li {
    float: left;
}

.cruise-tabs-ul li a {
    padding: 10px 20px;
    text-transform: uppercase;
    float: left;
}

.cruise-tabs-ul li a.active {
    font-weight: bold;
    border: 1px solid #eee;
    background-color: #def7fe;
    color: #37b5d3;
}

.cruise-rederij-usps li {
    margin-left: 20px;
}

.cruise-tabs-ul li a {
    cursor: pointer;
}

.cruise-tabs-ul li a:hover {
    font-weight: normal;
}

.cruise-tabs-ul li a.midgroen:hover {
    font-weight: bold;
}

.cruise-tabs-ul li a.active:hover {
    font-weight: bold;
}

.cruise-tabs-style {
    position: fixed;
    top: 0;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    width: 100%;
    left: 0;
    box-shadow: 0 12px 23px 6px #fff;
    z-index: 101;
}

#campaign-body {
    height: 70px;
    line-height: 68px;
}

#middle-content {
    float: left;
}

#side {
    float: left;
}

.rederij-logos {
    /*	text-align:center;*/
    margin-bottom: 20px;
    /*    margin-left: -22%; */
    width: 100%;
}

.rederij-logos .nolist {
    width: auto !important;
    margin: 0 auto !important;
}

.borderbottom {
    border-bottom: 1px solid #eee;
}

.overiglogos {
    width: 100%;
}

.overiglogos .logos-img {
    width: 164px;
    margin: 0 auto;
    float: none;
}

#filter #filtersubcontent input[type='checkbox'] {
    width: 16px !important;
    float: left;
    padding: 0 !important;
}

/*#filter #filtersubcontent input {width:96% !important;padding:0px 6px !important;  background-position: 194px;}*/

.newsletter {
    background-color: #efefef;
    position: relative;
    float: left;
    width: 100%;
}

.telegraaf .uitverkocht {
    background-image: url(https://cdn.cruisereizen.nl/img/marketing/actie/telegraaf/uitverkocht.png);
    background-repeat: no-repeat;
    /* width: 100%; */
    display: block;
    height: 400px;
    z-index: 10000;
    background-size: 92%;
    vertical-align: middle;
    background-position: center center;
}

.cruise-prijs-content {
    height: 145px !important;
}

.aanbiedingen_vaarroute_leesmeer {
    text-decoration: underline;
    cursor: pointer;
}

.aanbiedingen_vaarroute_leesmeer:hover {
    font-weight: bold;
}

#filter .label {
    width: 100% !important;
    margin-top: 4px;
}

.underline,
.underline:link,
.underline:visited {
    text-decoration: underline;
    font-weight: normal;
}

.content a,
.content a:hover,
.content a:link,
.content a:visited {
    color: #2178b3;
    font-weight: bold;
}

.content a:hover {
    text-decoration: underline;
}

.fontsize14 {
    font-size: 14px;
}

.fontsize20 {
    font-size: 20px;
}

.specialist-img {
    height: 50px;
    width: 50px;
    overflow: hidden;
    border-radius: 50px;
    border: 3px solid #fff;
    margin-right: 6px;
    margin-top: -8px;
}

.specialist-img img {
    width: 50px;
}

.pand {
    border: 1px solid #eee;
}

.pand img {
    width: 100%;
    border-radius: 2px;
}

.rederij-logos li span {
    margin-right: 10px;
}

.rederij-logos img {
    height: 22px;
    margin-right: 17px;
}

.header {
    font-size: 14px;
    padding: 8px 15px;
    background-color: #36b5d3;
}

.header3 {
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 4px;
    display: block;
}

.smallbutton {
    height: 25px !important;
    line-height: 25px !important;
    margin-top: 8px !important;
    font-size: 11px !important;
}

.grootbutton {
    height: 45px !important;
    line-height: 45px !important;
    margin-top: 8px !important;
    font-size: 11px !important;
}

.header6 {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 4px;
    display: block;
}

.top-right .block {
    border-radius: 5px;
}

.shadow {
    -moz-box-shadow: 0 0 4px #efefef;
    -webkit-box-shadow: 0 0 4px #efefef;
    box-shadow: 0 0 4px #efefef;
}

.normal {
    font-weight: normal !important;
}

a.darkblue:link,
a.darkblue:visited,
a.darkblue:hover {
    text-decoration: underline;
}

.zindex10 {
    z-index: 10;
}

/* Template Kleuren */

.bluebg {
    background-color: #dcf8fe;
    border: 1px solid #afe6f3;
}

.headerbg {
    background-color: #37b5d3 !important;
}

.greybg {
    background-color: #f8f8f8;
}

.darkgreybg {
    background-color: #eee;
}

.lichtgreybg {
    background-color: #f0f0f0;
}

.midgreybg {
    background-color: #f7f7f5;
}

.greenbg {
    background-color: #eaf3d8;
    border: 1px solid #c9df9f;
}

.groenbg {
    background-color: #9dd057 !important;
}

.groenbg:hover {
    background-color: #8bbb48 !important;
}

.orangebg {
    background-color: #f39c12 !important;
}

.lightorangebg {
    background-color: #f3ddbb !important;
}

.orangebg:hover {
    background-color: #d58a13 !important;
}

.orange {
    color: #f39c12 !important;
}

.black {
    color: #333 !important;
}

.blauw {
    color: #259abb;
}

.ultralichtblauwbg {
    background-color: #f4fcfe;
}

.hoverblauw:hover {
    background-color: #e3f2f6 !important;
}

.lichtblauw {
    color: #def7fe;
}

.lichtblauwbg {
    background-color: #def7fe;
}

.midblauw {
    color: #37b5d3;
}

.darkblue,
.darkblue:link,
.darkblue:visited,
.darkblue:hover {
    color: #2178b3;
}

a.darkblue:hover {
    color: #000;
}

.ultradarkblue {
    color: #2b2869;
}

.darkbluebg {
    background-color: #1ca2c2 !important;
}

.pinkbg {
    background-color: #f06 !important;
}

.midblauwbg {
    background-color: #37b5d3 !important;
}

.midblauwbg:hover {
    background-color: #34abc8 !important;
}

.actiebg {
    background-color: #d8e9f5 !important;
}

.paars,
.purple {
    color: #6666cc;
}

.paarsbg,
.purplebg {
    background-color: #6666cc;
}

.white {
    color: #fff;
}

.whitebg {
    background-color: #fff;
}

.groen {
    color: #669900;
}

.groenbg {
    background-color: #9dd057;
}

.lichtgroenbg {
    background-color: #dff2bf;
}

.rood {
    color: #ff0066;
}

.midgroen {
    color: #9dd057 !important;
    font-weight: bold;
}

.grey {
    color: #cacaca !important;
}

.blue {
    color: #5ba2d6;
}

.silver {
    color: #b4b5b7;
}

.gold {
    color: #c4ac52;
}

.diamond {
    color: #718896;
}

.darkorange {
    color: #d28929;
}

.rounded {
    border-radius: 5px !important;
}

/* Icoontjes Sprite */

.anvr-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -511px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.sgr-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -552px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.cal-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -592px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.clia-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -632px -16px;
    display: block;
    width: 40px;
    height: 32px;
}

.blijdorp-img {
    background-image: url(https://cdn.cruisereizen.nl/img/overig/partners/blijdorp.png);
    display: block;
    width: 39px;
    height: 50px;
}

.fd-img {
    background-image: url(https://cdn.cruisereizen.nl/img/overig/partners/fd.png);
    display: block;
    width: 75px;
    height: 50px;
}

.ideal-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -246px;
    display: block;
    width: 40px;
    height: 32px;
}

.paypal-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -44px -246px;
    display: block;
    width: 94px;
    height: 32px;
}

.mrcash-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -232px -246px;
    display: block;
    width: 46px;
    height: 32px;
}

.visa-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -142px -246px;
    display: block;
    width: 40px;
    height: 32px;
}

.master-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -188px -246px;
    display: block;
    width: 40px;
    height: 32px;
}

.amex-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -469px -247px;
    display: block;
    width: 32px;
    height: 30px;
}

.logosmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -682px -16px;
    margin: 0;
    display: block;
    width: 156px;
    height: 32px;
}

.checks li:before {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -272px -9px;
    content: ' ';
    padding-right: 17px;
}

.cruise-logo {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 0;
    display: block;
    width: 266px;
    height: 44px;
}

.klm-logo {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -553px -174px;
    display: block;
    width: 30px;
    height: 18px;
}

.transavia-logo {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -592px -174px;
    display: block;
    width: 60px;
    height: 18px;
}

.vluchtheen {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -720px -132px;
    display: block;
    width: 20px;
    height: 20px;
}

.vluchtterug {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -690px -132px;
    display: block;
    width: 20px;
    height: 20px;
}

.vluchticon-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -719px -132px;
    width: 23px;
    height: 20px;
    display: block;
    margin: 0 auto;
}

.cruiseicon-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -891px -132px;
    width: 23px;
    height: 20px;
    display: block;
    margin: 0 auto;
}

.transfericon-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -917px -132px;
    width: 23px;
    height: 20px;
    display: block;
    margin: 0 auto;
}

.schip-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -78px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.vloot-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -515px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.live-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -156px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.verken-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.entertainment-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -229px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.haven-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -441px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.highlights-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -300px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.excursies-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -370px -358px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.search-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -868px -132px;
    display: block;
    width: 18px;
    height: 18px;
    margin: 0 auto;
    float: left;
}

.aida-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1346px -165px;
    display: inline-block;
    width: 58px;
    height: 32px;
    margin: 0 auto;
}

.azamara-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1140px -202px;
    display: inline-block;
    width: 84px;
    height: 32px;
    margin: 0 auto;
}

.carnival-cruise-lines-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1496px -203px;
    display: inline-block;
    width: 88px;
    height: 32px;
    margin: 0 auto;
}

.celebrity-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1496px -165px;
    display: inline-block;
    width: 82px;
    height: 32px;
    margin: 0 auto;
}

.disney-cruise-line-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1422px -203px;
    display: inline-block;
    width: 76px;
    height: 32px;
    margin: 0 auto;
}

.hapag-lloyd-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1026px -201px;
    display: inline-block;
    width: 116px;
    height: 30px;
    margin: 0 auto;
}

.holland-america-line-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1170px -162px;
    display: inline-block;
    width: 92px;
    height: 36px;
    margin: 0 auto;
}

.msc-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1274px -166px;
    display: inline-block;
    width: 68px;
    height: 30px;
    margin: 0 auto;
}

.norwegian-cruise-line-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1022px -164px;
    display: inline-block;
    width: 58px;
    height: 30px;
    margin: 0 auto;
}

.oceania-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -610px -203px;
    display: inline-block;
    width: 60px;
    height: 30px;
    margin: 0 auto;
}

.ponant-yacht-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -680px -203px;
    display: inline-block;
    width: 130px;
    height: 30px;
    margin: 0 auto;
}

.royal-caribbean-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1404px -166px;
    display: inline-block;
    width: 90px;
    height: 30px;
    margin: 0 auto;
}

.seadream-yacht-club-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1316px -202px;
    display: inline-block;
    width: 102px;
    height: 30px;
    margin: 0 auto;
}

.silversea-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -825px -203px;
    display: inline-block;
    width: 140px;
    height: 30px;
    margin: 0 auto;
}

.star-clippers-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -615px -242px;
    display: inline-block;
    width: 60px;
    height: 30px;
    margin: 0 auto;
}

.princess-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1690px -179px;
    display: inline-block;
    width: 111px;
    height: 25px;
    margin: 0 auto;
}

.regent-seven-seas-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1805px -159px;
    display: inline-block;
    width: 78px;
    height: 44px;
    margin: 0 auto;
}

.seabourn-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -202px -202px;
    display: inline-block;
    width: 84px;
    height: 30px;
    margin: 0 auto;
}

.holland-america-line-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -218px -56px;
    display: block;
    width: 130px;
    height: 52px;
    margin: 0 auto;
}

.royal-caribbean-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -550px -68px;
    width: 132px;
    height: 34px;
    display: block;
    margin: 0 auto;
}

.seadream-yacht-club-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1316px -202px;
    display: block;
    width: 102px;
    height: 30px;
    margin: 0 auto;
}

.norwegian-cruise-line-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1026px -64px;
    width: 30px;
    height: 49px;
    display: block;
    margin: 0 auto;
}

.aida-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1346px -165px;
    display: inline-grid;
    width: 58px;
    height: 32px;
    margin: 0 auto;
}

.costa-cruises-small-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1582px -204px;
    width: 42px;
    display: inline-grid;
    height: 32px;
    margin: 0 auto;
}

.azamara-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1140px -202px;
    display: block;
    width: 84px;
    height: 32px;
    margin: 0 auto;
}

.carnival-cruise-lines-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1496px -203px;
    display: block;
    width: 88px;
    height: 32px;
    margin: 0 auto;
}

.costa-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    display: block;
    background-position: -1980px -66px;
    width: 54px;
    height: 34px;
    margin: 0 auto;
}

.celebrity-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    display: block;
    background-position: -691px -70px;
    width: 120px;
    margin: 0 auto;
    height: 28px;
    margin: 0 auto;
}

.disney-cruise-line-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    display: block;
    background-position: -580px -120px;
    width: 112px;
    margin: 0 auto;
    height: 36px;
    margin: 0 auto;
}

.hapag-lloyd-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1026px -201px;
    display: block;
    width: 116px;
    height: 30px;
    margin: 0 auto;
}

.msc-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1390px -67px;
    width: 90px;
    height: 38px;
    margin: 0 auto;
}

.aida-cruises-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1498px -68px;
    display: block;
    width: 71px;
    height: 32px;
    margin: 0 auto;
}

.seabourn-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1326px -122px;
    display: block;
    width: 117px;
    height: 32px;
    margin: 0 auto;
}

.idealsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -289px -258px;
    display: block;
    width: 22px;
    height: 28px;
}

.paypalsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -314px -258px;
    display: block;
    width: 60px;
    height: 28px;
}

.mrcashsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -432px -259px;
    display: block;
    width: 34px;
    height: 32px;
}

.visasmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -376px -260px;
    display: block;
    width: 28px;
    height: 28px;
}

.mastersmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -404px -260px;
    display: block;
    width: 28px;
    height: 28px;
}

.amexsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -506px -258px;
    display: block;
    width: 21px;
    height: 21px;
}

.klm-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -552px -169px;
    display: block;
    width: 34px;
    height: 28px;
}

.vluchtheen-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -720px -126px;
    display: block;
    width: 24px;
    height: 28px;
}

.vluchtterug-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -688px -128px;
    display: block;
    width: 24px;
    height: 28px;
}

.whatsapp-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -841px -26px;
    display: block;
    width: 20px;
    height: 20px;
    margin: 0 auto;
}

.eten-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -59px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.ontspanning-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -158px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.beauty-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.sport-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -333px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.kinderen-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -104px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.rolstoel-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -218px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.wifi-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -390px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.schip2-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -272px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.haven2-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -272px -287px;
    display: block;
    width: 58px;
    height: 58px;
    margin: 0 auto;
}

.gezinnen-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -366px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.dranken-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -70px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.fooien-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -144px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.korting-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -516px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.kleding-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -440px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.gala-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -220px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.gewoontes-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -294px -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.bagage-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: 0 -434px;
    display: block;
    width: 68px;
    height: 68px;
    margin: 0 auto;
}

.ajax-loader {
    background-image: url(https://cdn.cruisereizen.nl/img/template/ajax_loader_blue_128.gif);
    background-position: 0 0;
    display: block;
    width: 128px;
    height: 128px;
    text-align: center;
    margin: 0 auto;
    margin-top: 30%;
}

/* Template font size */

.font8 {
    font-size: 8px;
}

.font10 {
    font-size: 10px;
}

.font11 {
    font-size: 11px;
}

.font12 {
    font-size: 12px;
}

.font12imp {
    font-size: 12px !important;
}

.font13 {
    font-size: 13px;
}

.font14 {
    font-size: 14px;
}

.font15 {
    font-size: 15px !important;
}

.font16 {
    font-size: 16px !important;
}

.font18 {
    font-size: 18px !important;
}

.font20 {
    font-size: 20px;
}

.font22 {
    font-size: 22px;
}

.font24 {
    font-size: 24px;
}

.font26 {
    font-size: 26px;
}

.font28 {
    font-size: 28px;
}

.font30 {
    font-size: 30px;
}

.font40 {
    font-size: 40px;
}

.font50 {
    font-size: 50px;
}

.font70 {
    font-size: 70px;
}

.font80 {
    font-size: 80px;
}

.font90 {
    font-size: 90px;
}

.label {
    float: left;
    width: 22%;
}

.variabel {
    float: left;
    width: 78%;
}

.autowidth {
    width: auto;
}

.nofloat,
.nofloat li {
    float: none !important;
}

/* Template font styles */

.italic {
    font-style: italic;
}

.small {
    font-size: 10px !important;
    line-height: 10px !important;
}

.museo {
    font-family: 'museo-slab' !important;
}

.bold {
    font-weight: bold !important;
}

.nobold {
    font-weight: normal !important;
}

/* Opacity */

.opacity3 {
    opacity: 0.3;
}

.opacity5 {
    opacity: 0.5;
}

.opacity8 {
    opacity: 0.8;
    transition: all 0.4s;
}

.opacity8:hover {
    opacity: 1;
}

/* Zoom */

.zoom60 {
    zoom: 60%;
    -moz-transform: scale(0.6);
    /* Firefox */
}

.zoom70 {
    zoom: 70%;
    -moz-transform: scale(0.7);
    /* Firefox */
}

.zoom80 {
    zoom: 80%;
    -moz-transform: scale(0.8);
    /* Firefox */
}

.start {
    margin-left: 0;
    margin-bottom: 0;
}

.last {
    margin-right: 0;
    margin-bottom: 0;
}

.padding-small {
    padding: 4px 6px !important;
    margin-top: 1px !important;
}

.absolute {
    position: absolute;
}

.inherit {
    position: inherit;
}

.fixed {
    position: fixed;
}

.relative {
    position: relative;
}

.autosize {
    width: auto !important;
    height: auto !important;
}

.zindextop {
    z-index: 100 !important;
}

.favorieten {
    cursor: pointer;
}

.favorieten:hover {
    color: #f39c12 !important;
}

.toesturen {
    cursor: pointer;
}

.toesturen:hover {
    color: #f39c12 !important;
}

.toesturen {
    cursor: pointer;
}

.toesturen:hover {
    color: #f39c12 !important;
}

.lineheight32 {
    line-height: 32px !important;
}

.regelpadding {
    padding: 6px 10px !important;
}

#footer-1 ul li a,
#footer-1 ul li a:link {
    font-weight: normal !important;
}

/* Cruisereizen TV */

.background-stripe {
    width: 100%;
    border-bottom: #ededed 1px solid;
    float: left;
}

.bottom {
    bottom: 0;
}

.noborder {
    border: 0;
}

.border1 {
    border: 1px solid #ddd;
}

.border2 {
    border: 1px solid #eee;
}

.border3 {
    border: 3px solid #eee;
}

.border4 {
    border: 4px solid #ddd;
}

.borderbottomwhite1 {
    border-bottom: 1px solid #fff;
}

.border1-purple {
    border: 1px solid #6666cc;
}

.borderblue1 {
    border: 1px solid #9adceb;
}

.borderlichtblauw1 {
    border: 1px solid #e3f8fe;
}

.borderorange1 {
    border: 1px solid #efb476;
}

.borderorange2 {
    border: 2px solid #efb476;
}

.bordertopblue1 {
    border-top: 1px solid #2178b3;
}

.borderbottomgrey1 {
    border-bottom: 1px solid #ddd;
}

.bordertopgrey1 {
    border-top: 1px solid #ddd;
}

.bordergrey1 {
    border: 1px solid #e3e3e3;
}

.borderright1 {
    border-right: 1px solid #eee;
}

.bordergroen1 {
    border: 1px solid #cee6a7;
}

#filter .select {
    margin-bottom: 4px !important;
}

.divlink {
    font-weight: normal;
}

.divlink:hover {
    background-color: #f4fcfe;
}

.landing h3 {
    color: #2178b3;
    margin-bottom: 0;
}

.overflowhidden {
    overflow: hidden !important;
}

.block {
    display: block !important;
    float: left;
}

.nolist {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.textcenter,
.textcenter img {
    text-align: center;
    margin: 0 auto;
}

.textleft {
    text-align: left;
}

.textright {
    text-align: right;
}

.bedrag {
    border-left: 1px solid #fff;
    width: 25% !important;
    float: none !important;
    display: inline-block !important;
}

.uppercase {
    text-transform: uppercase;
}

select::-ms-expand {
    display: none;
}

.floatleft,
.floatleft li {
    float: left;
}

.floatleftimp,
.floatleftimp li {
    float: left !important;
}

.floatright {
    float: right;
}

.floatnone {
    float: none;
}

div a img {
    border: 0 !important;
}

li.aanleghaven a {
    font-weight: normal;
}

li.vertrekhaven a {
    font-weight: normal;
}

.leesmeer {
    font-weight: bold;
    cursor: pointer;
    margin-top: 8px;
}

.leesmeer:hover {
    text-decoration: underline;
}

.thumbnails {
    height: 58px;
    margin-top: 5px;
}

/* VLAGGEN */

.flag {
    width: 16px;
    height: 11px;
    background-image: url(https://cdn.cruisereizen.nl/img/template/flags.png);
    background-repeat: no-repeat;
    float: left;
    display: block;
    margin-top: 4px;
}

.flag.flag-ad {
    background-position: -16px 0;
}

.flag.flag-ae {
    background-position: -32px 0;
}

.flag.flag-af {
    background-position: -48px 0;
}

.flag.flag-ag {
    background-position: -64px 0;
}

.flag.flag-ai {
    background-position: -80px 0;
}

.flag.flag-al {
    background-position: -96px 0;
}

.flag.flag-am {
    background-position: -112px 0;
}

.flag.flag-an {
    background-position: -128px 0;
}

.flag.flag-ao {
    background-position: -144px 0;
}

.flag.flag-ar {
    background-position: -160px 0;
}

.flag.flag-as {
    background-position: -176px 0;
}

.flag.flag-at {
    background-position: -192px 0;
}

.flag.flag-au {
    background-position: -208px 0;
}

.flag.flag-aw {
    background-position: -224px 0;
}

.flag.flag-az {
    background-position: -240px 0;
}

.flag.flag-ba {
    background-position: 0 -11px;
}

.flag.flag-bb {
    background-position: -16px -11px;
}

.flag.flag-bd {
    background-position: -32px -11px;
}

.flag.flag-be {
    background-position: -48px -11px;
}

.flag.flag-bf {
    background-position: -64px -11px;
}

.flag.flag-bg {
    background-position: -80px -11px;
}

.flag.flag-bh {
    background-position: -96px -11px;
}

.flag.flag-bi {
    background-position: -112px -11px;
}

.flag.flag-bj {
    background-position: -128px -11px;
}

.flag.flag-bm {
    background-position: -144px -11px;
}

.flag.flag-bn {
    background-position: -160px -11px;
}

.flag.flag-bo {
    background-position: -176px -11px;
}

.flag.flag-br {
    background-position: -192px -11px;
}

.flag.flag-bs {
    background-position: -208px -11px;
}

.flag.flag-bt {
    background-position: -224px -11px;
}

.flag.flag-bv {
    background-position: -240px -11px;
}

.flag.flag-bw {
    background-position: 0 -22px;
}

.flag.flag-by {
    background-position: -16px -22px;
}

.flag.flag-bz {
    background-position: -32px -22px;
}

.flag.flag-ca {
    background-position: -48px -22px;
}

.flag.flag-catalonia {
    background-position: -64px -22px;
}

.flag.flag-cd {
    background-position: -80px -22px;
}

.flag.flag-cf {
    background-position: -96px -22px;
}

.flag.flag-cg {
    background-position: -112px -22px;
}

.flag.flag-ch {
    background-position: -128px -22px;
}

.flag.flag-ci {
    background-position: -144px -22px;
}

.flag.flag-ck {
    background-position: -160px -22px;
}

.flag.flag-cl {
    background-position: -176px -22px;
}

.flag.flag-cm {
    background-position: -192px -22px;
}

.flag.flag-cn {
    background-position: -208px -22px;
}

.flag.flag-co {
    background-position: -224px -22px;
}

.flag.flag-cr {
    background-position: -240px -22px;
}

.flag.flag-cu {
    background-position: 0 -33px;
}

.flag.flag-cv {
    background-position: -16px -33px;
}

.flag.flag-cw {
    background-position: -32px -33px;
}

.flag.flag-cy {
    background-position: -48px -33px;
}

.flag.flag-cz {
    background-position: -64px -33px;
}

.flag.flag-de {
    background-position: -80px -33px;
}

.flag.flag-dj {
    background-position: -96px -33px;
}

.flag.flag-dk {
    background-position: -112px -33px;
}

.flag.flag-dm {
    background-position: -128px -33px;
}

.flag.flag-do {
    background-position: -144px -33px;
}

.flag.flag-dz {
    background-position: -160px -33px;
}

.flag.flag-ec {
    background-position: -176px -33px;
}

.flag.flag-ee {
    background-position: -192px -33px;
}

.flag.flag-eg {
    background-position: -208px -33px;
}

.flag.flag-eh {
    background-position: -224px -33px;
}

.flag.flag-england {
    background-position: -240px -33px;
}

.flag.flag-er {
    background-position: 0 -44px;
}

.flag.flag-es {
    background-position: -16px -44px;
}

.flag.flag-et {
    background-position: -32px -44px;
}

.flag.flag-eu {
    background-position: -48px -44px;
}

.flag.flag-fi {
    background-position: -64px -44px;
}

.flag.flag-fj {
    background-position: -80px -44px;
}

.flag.flag-fk {
    background-position: -96px -44px;
}

.flag.flag-fm {
    background-position: -112px -44px;
}

.flag.flag-fo {
    background-position: -128px -44px;
}

.flag.flag-fr {
    background-position: -144px -44px;
}

.flag.flag-ga {
    background-position: -160px -44px;
}

.flag.flag-gb {
    background-position: -176px -44px;
}

.flag.flag-gd {
    background-position: -192px -44px;
}

.flag.flag-ge {
    background-position: -208px -44px;
}

.flag.flag-gf {
    background-position: -224px -44px;
}

.flag.flag-gg {
    background-position: -240px -44px;
}

.flag.flag-gh {
    background-position: 0 -55px;
}

.flag.flag-gi {
    background-position: -16px -55px;
}

.flag.flag-gl {
    background-position: -32px -55px;
}

.flag.flag-gm {
    background-position: -48px -55px;
}

.flag.flag-gn {
    background-position: -64px -55px;
}

.flag.flag-gp {
    background-position: -80px -55px;
}

.flag.flag-gq {
    background-position: -96px -55px;
}

.flag.flag-gr {
    background-position: -112px -55px;
}

.flag.flag-gs {
    background-position: -128px -55px;
}

.flag.flag-gt {
    background-position: -144px -55px;
}

.flag.flag-gu {
    background-position: -160px -55px;
}

.flag.flag-gw {
    background-position: -176px -55px;
}

.flag.flag-gy {
    background-position: -192px -55px;
}

.flag.flag-hk {
    background-position: -208px -55px;
}

.flag.flag-hm {
    background-position: -224px -55px;
}

.flag.flag-hn {
    background-position: -240px -55px;
}

.flag.flag-hr {
    background-position: 0 -66px;
}

.flag.flag-ht {
    background-position: -16px -66px;
}

.flag.flag-hu {
    background-position: -32px -66px;
}

.flag.flag-ic {
    background-position: -48px -66px;
}

.flag.flag-id {
    background-position: -64px -66px;
}

.flag.flag-ie {
    background-position: -80px -66px;
}

.flag.flag-il {
    background-position: -96px -66px;
}

.flag.flag-im {
    background-position: -112px -66px;
}

.flag.flag-in {
    background-position: -128px -66px;
}

.flag.flag-io {
    background-position: -144px -66px;
}

.flag.flag-iq {
    background-position: -160px -66px;
}

.flag.flag-ir {
    background-position: -176px -66px;
}

.flag.flag-is {
    background-position: -192px -66px;
}

.flag.flag-it {
    background-position: -208px -66px;
}

.flag.flag-je {
    background-position: -224px -66px;
}

.flag.flag-jm {
    background-position: -240px -66px;
}

.flag.flag-jo {
    background-position: 0 -77px;
}

.flag.flag-jp {
    background-position: -16px -77px;
}

.flag.flag-ke {
    background-position: -32px -77px;
}

.flag.flag-kg {
    background-position: -48px -77px;
}

.flag.flag-kh {
    background-position: -64px -77px;
}

.flag.flag-ki {
    background-position: -80px -77px;
}

.flag.flag-km {
    background-position: -96px -77px;
}

.flag.flag-kn {
    background-position: -112px -77px;
}

.flag.flag-kp {
    background-position: -128px -77px;
}

.flag.flag-kr {
    background-position: -144px -77px;
}

.flag.flag-kurdistan {
    background-position: -160px -77px;
}

.flag.flag-kw {
    background-position: -176px -77px;
}

.flag.flag-ky {
    background-position: -192px -77px;
}

.flag.flag-kz {
    background-position: -208px -77px;
}

.flag.flag-la {
    background-position: -224px -77px;
}

.flag.flag-lb {
    background-position: -240px -77px;
}

.flag.flag-lc {
    background-position: 0 -88px;
}

.flag.flag-li {
    background-position: -16px -88px;
}

.flag.flag-lk {
    background-position: -32px -88px;
}

.flag.flag-lr {
    background-position: -48px -88px;
}

.flag.flag-ls {
    background-position: -64px -88px;
}

.flag.flag-lt {
    background-position: -80px -88px;
}

.flag.flag-lu {
    background-position: -96px -88px;
}

.flag.flag-lv {
    background-position: -112px -88px;
}

.flag.flag-ly {
    background-position: -128px -88px;
}

.flag.flag-ma {
    background-position: -144px -88px;
}

.flag.flag-mc {
    background-position: -160px -88px;
}

.flag.flag-md {
    background-position: -176px -88px;
}

.flag.flag-me {
    background-position: -192px -88px;
}

.flag.flag-mg {
    background-position: -208px -88px;
}

.flag.flag-mh {
    background-position: -224px -88px;
}

.flag.flag-mk {
    background-position: -240px -88px;
}

.flag.flag-ml {
    background-position: 0 -99px;
}

.flag.flag-mm {
    background-position: -16px -99px;
}

.flag.flag-mn {
    background-position: -32px -99px;
}

.flag.flag-mo {
    background-position: -48px -99px;
}

.flag.flag-mp {
    background-position: -64px -99px;
}

.flag.flag-mq {
    background-position: -80px -99px;
}

.flag.flag-mr {
    background-position: -96px -99px;
}

.flag.flag-ms {
    background-position: -112px -99px;
}

.flag.flag-mt {
    background-position: -128px -99px;
}

.flag.flag-mu {
    background-position: -144px -99px;
}

.flag.flag-mv {
    background-position: -160px -99px;
}

.flag.flag-mw {
    background-position: -176px -99px;
}

.flag.flag-mx {
    background-position: -192px -99px;
}

.flag.flag-my {
    background-position: -208px -99px;
}

.flag.flag-mz {
    background-position: -224px -99px;
}

.flag.flag-na {
    background-position: -240px -99px;
}

.flag.flag-nc {
    background-position: 0 -110px;
}

.flag.flag-ne {
    background-position: -16px -110px;
}

.flag.flag-nf {
    background-position: -32px -110px;
}

.flag.flag-ng {
    background-position: -48px -110px;
}

.flag.flag-ni {
    background-position: -64px -110px;
}

.flag.flag-nl {
    background-position: -80px -110px;
}

.flag.flag-no {
    background-position: -96px -110px;
}

.flag.flag-np {
    background-position: -112px -110px;
}

.flag.flag-nr {
    background-position: -128px -110px;
}

.flag.flag-nu {
    background-position: -144px -110px;
}

.flag.flag-nz {
    background-position: -160px -110px;
}

.flag.flag-om {
    background-position: -176px -110px;
}

.flag.flag-pa {
    background-position: -192px -110px;
}

.flag.flag-pe {
    background-position: -208px -110px;
}

.flag.flag-pf {
    background-position: -224px -110px;
}

.flag.flag-pg {
    background-position: -240px -110px;
}

.flag.flag-ph {
    background-position: 0 -121px;
}

.flag.flag-pk {
    background-position: -16px -121px;
}

.flag.flag-pl {
    background-position: -32px -121px;
}

.flag.flag-pm {
    background-position: -48px -121px;
}

.flag.flag-pn {
    background-position: -64px -121px;
}

.flag.flag-pr {
    background-position: -80px -121px;
}

.flag.flag-ps {
    background-position: -96px -121px;
}

.flag.flag-pt {
    background-position: -112px -121px;
}

.flag.flag-pw {
    background-position: -128px -121px;
}

.flag.flag-py {
    background-position: -144px -121px;
}

.flag.flag-qa {
    background-position: -160px -121px;
}

.flag.flag-re {
    background-position: -176px -121px;
}

.flag.flag-ro {
    background-position: -192px -121px;
}

.flag.flag-rs {
    background-position: -208px -121px;
}

.flag.flag-ru {
    background-position: -224px -121px;
}

.flag.flag-rw {
    background-position: -240px -121px;
}

.flag.flag-sa {
    background-position: 0 -132px;
}

.flag.flag-sb {
    background-position: -16px -132px;
}

.flag.flag-sc {
    background-position: -32px -132px;
}

.flag.flag-scotland {
    background-position: -48px -132px;
}

.flag.flag-sd {
    background-position: -64px -132px;
}

.flag.flag-se {
    background-position: -80px -132px;
}

.flag.flag-sg {
    background-position: -96px -132px;
}

.flag.flag-sh {
    background-position: -112px -132px;
}

.flag.flag-si {
    background-position: -128px -132px;
}

.flag.flag-sk {
    background-position: -144px -132px;
}

.flag.flag-sl {
    background-position: -160px -132px;
}

.flag.flag-sm {
    background-position: -176px -132px;
}

.flag.flag-sn {
    background-position: -192px -132px;
}

.flag.flag-so {
    background-position: -208px -132px;
}

.flag.flag-somaliland {
    background-position: -224px -132px;
}

.flag.flag-sr {
    background-position: -240px -132px;
}

.flag.flag-ss {
    background-position: 0 -143px;
}

.flag.flag-st {
    background-position: -16px -143px;
}

.flag.flag-sv {
    background-position: -32px -143px;
}

.flag.flag-sx {
    background-position: -48px -143px;
}

.flag.flag-sy {
    background-position: -64px -143px;
}

.flag.flag-sz {
    background-position: -80px -143px;
}

.flag.flag-tc {
    background-position: -96px -143px;
}

.flag.flag-td {
    background-position: -112px -143px;
}

.flag.flag-tf {
    background-position: -128px -143px;
}

.flag.flag-tg {
    background-position: -144px -143px;
}

.flag.flag-th {
    background-position: -160px -143px;
}

.flag.flag-tibet {
    background-position: -176px -143px;
}

.flag.flag-tj {
    background-position: -192px -143px;
}

.flag.flag-tk {
    background-position: -208px -143px;
}

.flag.flag-tl {
    background-position: -224px -143px;
}

.flag.flag-tm {
    background-position: -240px -143px;
}

.flag.flag-tn {
    background-position: 0 -154px;
}

.flag.flag-to {
    background-position: -16px -154px;
}

.flag.flag-tr {
    background-position: -32px -154px;
}

.flag.flag-tt {
    background-position: -48px -154px;
}

.flag.flag-tv {
    background-position: -64px -154px;
}

.flag.flag-tw {
    background-position: -80px -154px;
}

.flag.flag-tz {
    background-position: -96px -154px;
}

.flag.flag-ua {
    background-position: -112px -154px;
}

.flag.flag-ug {
    background-position: -128px -154px;
}

.flag.flag-um {
    background-position: -144px -154px;
}

.flag.flag-us {
    background-position: -160px -154px;
}

.flag.flag-uy {
    background-position: -176px -154px;
}

.flag.flag-uz {
    background-position: -192px -154px;
}

.flag.flag-va {
    background-position: -208px -154px;
}

.flag.flag-vc {
    background-position: -224px -154px;
}

.flag.flag-ve {
    background-position: -240px -154px;
}

.flag.flag-vg {
    background-position: 0 -165px;
}

.flag.flag-vi {
    background-position: -16px -165px;
}

.flag.flag-vn {
    background-position: -32px -165px;
}

.flag.flag-vu {
    background-position: -48px -165px;
}

.flag.flag-wales {
    background-position: -64px -165px;
}

.flag.flag-wf {
    background-position: -80px -165px;
}

.flag.flag-ws {
    background-position: -96px -165px;
}

.flag.flag-xk {
    background-position: -112px -165px;
}

.flag.flag-ye {
    background-position: -128px -165px;
}

.flag.flag-yt {
    background-position: -144px -165px;
}

.flag.flag-za {
    background-position: -160px -165px;
}

.flag.flag-zanzibar {
    background-position: -176px -165px;
}

.flag.flag-zm {
    background-position: -192px -165px;
}

.flag.flag-zw {
    background-position: -208px -165px;
}

/* OVERZICHT CAMPAGNES */

#main-image-sub2 {
    height: 380px;
    overflow: hidden;
    clear: both;
    margin-bottom: -350px;
}

.aanbevolen_cruise {
    background-color: #f39c12;
    color: #fff;
    padding: 4px 8px;
    width: auto !important;
    float: left;
    position: absolute;
    z-index: 10;
    margin-top: 12px;
    font-weight: bold;
}

/* SCHIP PAGINA */

#content_pagina .cruise-foto img {
    min-height: 110px !important;
}

#content_pagina .cruise-foto img {
    margin: 0;
}

#content_pagina .cruise-prijs-content {
    height: auto !important;
}

#content_pagina .header3 {
    font-size: 11px;
}

.tabs .tab {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border: 1px solid #e3e3e3;
    padding: 10px 0;
    cursor: pointer;
    display: block;
    position: relative;
}

.tabs .tab:hover {
    background-color: #f39c12;
    color: #333;
    font-weight: normal;
    text-decoration: none;
}

.tabs .active {
    background-color: #f39c12;
}

.tabs .active:after,
.tabs a:hover:after {
    content: '';
    display: block;
    border: 8px solid #f7f7f5;
    border-top-color: #f39c12;
    position: absolute;
    bottom: -16px;
    margin-left: -8px;
    left: 50%;
}

.tab-boven {
    clear: both;
    display: block;
    background-repeat: no-repeat;
    background-position: bottom center;
}

.verticalmenu a,
.verticalmenu2 a,
.verticalmenu3 a,
.verticalmenu4 a {
    border-bottom: 1px solid #fff;
    padding: 1px 4px 1px 6px;
    cursor: pointer;
    position: relative;
    display: block;
    font-weight: normal;
}

.verticalmenu .active,
.verticalmenu2 .active,
.verticalmenu3 .active,
.verticalmenu4 .active {
    background-color: #f39c12;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
}

.verticalmenu4 .active {
    background-color: #37b5d3;
}

.verticalmenu a:hover:after,
.verticalmenu .active:after {
    content: '';
    display: block;
    border: 12px solid #f7f7f5;
    border-left-color: #f39c12;
    position: absolute;
    top: 0;
    margin-left: -2px;
    left: 100%;
}

.verticalmenu2 a:hover:after,
.verticalmenu2 .active:after {
    content: '';
    display: block;
    border: 12px solid #fff;
    border-left-color: #f39c12;
    position: absolute;
    top: 0;
    margin-left: 0;
    left: 100%;
}

.verticalmenu3 a:hover:after,
.verticalmenu3 .active:after {
    content: '';
    display: block;
    border: 12px solid #f7f7f5;
    border-left-color: #f39c12;
    position: absolute;
    top: 0;
    margin-left: 0;
    left: 100%;
}

.verticalmenu4 a:hover:after,
.verticalmenu4 .active:after {
    content: '';
    display: block;
    border: 12px solid #fff;
    border-left-color: #37b5d3;
    position: absolute;
    top: 0;
    margin-left: -24px;
    left: 100%;
}

.verticalmenu a:hover,
.verticalmenu2 a:hover,
.verticalmenu3 a:hover,
.verticalmenu4 a:hover {
    background-color: #f39c12;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
}

.verticalmenu4 a:hover {
    background-color: #37b5d3;
}

.dekken a,
.dekken a:link,
.dekken a:visited,
.dekken a:hover {
    font-weight: normal;
    color: #333;
}

.checks2 li {
    margin-bottom: 8px;
}

.checks2 li:before {
    margin-top: -2px;
    content: ' ';
    position: relative;
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-repeat: no-repeat;
    background-position: -749px -128px;
    line-height: 25px;
    width: 22px;
    display: block;
    height: 22px;
    float: left;
    margin-right: 5px;
}

/* STAPPEN */

ul.stappenlijst {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

ul.stappenlijst li {
    display: inline-block;
    background-color: #f0f0f0;
    padding: 10px 0;
    text-align: center;
    color: #979797;
    position: relative;
    cursor: pointer;
    width: 19%;
}

ul.stappenlijst li:after {
    position: absolute;
    display: block;
    border: 20px solid transparent;
    content: ' ';
    top: 0;
    right: -42px;
    border-left-color: #fff;
    z-index: 9;
}

ul.stappenlijst li:before {
    position: absolute;
    display: block;
    border: 20px solid transparent;
    content: ' ';
    top: 0;
    right: -40px;
    border-left-color: #f0f0f0;
    z-index: 99;
}

ul.stappenlijst li.doorlopen {
    background-color: #def7fe;
    z-index: 2;
    color: #37b5d3;
}

ul.stappenlijst li.doorlopen:before {
    border-left-color: #def7fe;
}

ul.stappenlijst li.doorlopen:after {
    border-left-color: #fff;
}

.ztop {
    z-index: 10000 !important;
}

ul.stappenlijst li.active {
    background-color: #37b5d3;
    color: #fff;
    z-index: 1;
}

ul.stappenlijst li.active:before {
    border-left-color: #37b5d3;
}

ul.stappenlijst li.active:after {
    border-left-color: #fff;
}

.div_extra_informatie {
    border: 1px solid #f6e98b;
    background-color: #fdf6ab;
    max-width: 260px;
    color: #a17b33;
    font-size: 14px;
    padding: 10px;
    text-align: center;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    line-height: 20px;
    margin-left: 25pt;
}

.active .button5 {
    background-color: #9dd057 !important;
}

/* CRUISE PAGINA */

.centerwidth {
    margin: 0 auto;
    width: 1028px;
}

.regel {
    width: 100%;
}

.cruisepagina .cruise-rederijlogo {
    margin-bottom: 10px;
}

.cruise-title-wrapper {
    padding: 15px 0;
    background-color: #def7fe;
}

.cruise-title {
    text-align: center;
}

.cruise-title h2 {
    margin-bottom: 5px;
}

.cruise-subtitle-wrapper {
    padding: 15px 0;
    background-color: #f4fcfe;
}

.cruise-subtitle {
    text-align: center;
}

.cruise-subtitle .favorieten:hover {
    color: #f39c12 !important;
}

/*campagne new*/

.campagne_banner {
    padding: 20px 0;
    margin: 15px 0;
    position: relative;
    overflow: hidden;
}

.campagne_banner .campagne_star {
    position: absolute;
    font-size: 130px;
    color: #fff;
    top: -20px;
    left: -10px;
    opacity: 0.5;
}

.campagne_banner .campagne_title,
.campagne_subtitle,
.campagne_subtitle > p {
    color: #fff !important;
    text-align: center !important;
    padding: 0 100px;
    margin: 0 !important;
}

.campagne_banner .campagne_title {
    margin-bottom: 5px !important;
}

.cruisepage-header-image {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    width: 33.3%;
    float: left;
    height: 300px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

#cruisepagina-header {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
}

.nounderline {
    text-decoration: none !important;
}

/* BOEKEN */

#deckplan_placeholder {
    position: absolute;
    z-index: 10;
    margin-top: 474px;
    font-size: 18px;
    line-height: 24px;
    font-style: italic;
}

.stappenlijst li.active a,
.stappenlijst li.active a:link,
.stappenlijst li.active a:visited {
    color: #fff;
}

/* OVERIG */

.overiglogos2 {
    clear: both;
    display: block;
    margin-left: 268px;
    float: left;
    margin-top: 10px;
    margin-bottom: 10px;
}

.pointer {
    cursor: pointer;
}

.personeelsfoto_index {
    max-width: none !important;
    width: 300px !important;
    height: 450px;
    position: relative;
    bottom: -15px;
    right: 66px;
}

.mobile {
    display: none;
}

#ui-datepicker-div {
    z-index: 100000 !important;
}

.front-featured a:hover {
    color: #2178b3 !important;
}

.introtekst h3 {
    margin: 0;
    font-size: 12px;
    color: #2178b3;
}

#keuze_toonmeer {
    display: none;
}

.displaynone_desktop {
    display: none;
}

.keuze_hidemobile {
    display: block;
}

.breadcrumb ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.breadcrumb ul li {
    float: left;
}

.breadcrumb ul a {
    position: relative;
    margin-right: 6px;
    padding-right: 0;
    float: left;
}

.breadcrumb ul a:after {
    content: '';
    display: block;
    border: 5px solid #fff;
    border-left-color: #000;
    margin-top: 5px;
    margin-left: 8px;
    float: right;
}

.reisstappen .regel {
    width: 97% !important;
    background-color: #fff;
}

.reisstappen .height32 {
    float: left;
    height: auto;
}

.inactive {
    opacity: 0.4;
}

.inactive:hover {
    opacity: 1;
}

#reisgezelschap_melding {
    clear: both;
}

.artikelslider {
    position: relative;
}

.prev {
    cursor: pointer;
    float: left;
    left: 0;
    position: absolute;
    /* background-color: #fff; */
    height: 60px;
    width: 24px;
    margin-top: 130px;
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-repeat: no-repeat;
    background-position: -598px -440px;
    opacity: 0.7;
    margin-left: 14px;
    filter: alpha(opacity=70);
    /* For IE8 and earlier */
}

.next {
    cursor: pointer;
    right: 0;
    float: right;
    position: absolute;
    /* background-color: #fff; */
    height: 60px;
    width: 24px;
    margin-top: 130px;
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-repeat: no-repeat;
    background-position: -622px -440px;
    opacity: 0.7;
    margin-right: 14px;
    filter: alpha(opacity=70);
    /* For IE8 and earlier */
}

.next:hover,
.prev:hover {
    opacity: 1;
    filter: alpha(opacity=100);
    /* For IE8 and earlier */
    -webkit-transition: all 0.4s;
    transition: all 0.4s;
}

.width48 #cruises .prijsfly {
    margin-top: -6px !important;
    padding: 4px;
    line-height: 16px;
    right: 156px;
}

/*.show_vaarroute {text-decoration:underline;cursor:pointer;}
.show_vaarroute:hover {color:#2178b3!important;}*/

#vluchtinformatie_manual .ajax-loader {
    margin-top: 20px;
}

.selected-cruises {
    display: none;
}

.small-button {
    cursor: pointer;
}

#cruise-overzicht #betalingsinfo {
    display: none !important;
}

.div_hutinfo {
    display: none !important;
}

.landing_intro p {
    font-size: 14px !important;
    line-height: 22px !important;
}

.landing_intro h2 {
    font-size: 18px !important;
    line-height: 28px !important;
}

.smallheader {
    max-height: 300px;
    overflow: hidden;
}

.smallheader img {
    width: 100% !important;
    min-height: 282px;
}

.width100 .padding10 .width30 .margintop50 {
    width: 80% !important;
}

#campagne_succes2 {
    color: #9dd057 !important;
    font-weight: bold;
    font-style: normal;
    margin-top: 4px;
    margin-bottom: 4px;
}

.button-groen {
    background: #070;
}

.button-groen:hover {
    background: #090;
}

.button-orange {
    background: #f39c12;
}

.button-orange:hover {
    background: #ffa413;
}

#footerquotes {
    width: calc(100% - 20px);
    height: 20px;
}

#footerquotes div {
    width: calc(100% - 20px) !important;
    margin: auto;
    padding: 10px;
    height: auto;
}

/* Cookie bar */

#cookie-bar {
    background: #eee;
    height: 24px;
    line-height: 24px;
    color: #eeeeee;
    text-align: center;
    padding: 10px 0;
}

#cookie-bar.fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

#cookie-bar.fixed.bottom {
    bottom: 0;
    top: auto;
}

#cookie-bar p {
    margin: 0;
    padding: 0;
}

#cookie-bar a {
    color: #fff;
    display: inline-block;
    border-radius: 3px;
    text-decoration: none;
    padding: 0 6px;
    margin-left: 8px;
}

#cookie-bar .cb-enable {
    background: #070;
}

#cookie-bar .cb-enable:hover {
    background: #090;
}

#cookie-bar .cb-disable {
    background: #900;
}

#cookie-bar .cb-disable:hover {
    background: #b00;
}

#cookie-bar .cb-policy {
    background: #03b;
}

#cookie-bar .cb-policy:hover {
    background: #05d;
}

.wistia_embed {
    width: 100% !important;
}

ul#noty_bottomLeft_layout_container {
    margin-right: -80px !important;
    background: none !important;
}

ul#noty_bottomLeft_layout_container li {
    margin: 0 0 3px 0 !important;
    background: none !important;
    width: 225px !important;
    border: 0 solid #ccc !important;
    background-color: #5ba0d0 !important;
    color: #fff !important;
    text-align: center !important;
}

.noty_message {
    text-align: center !important;
}

.noty_text {
    color: #fff !important;
    font-size: 12px !important;
    text-align: center !important;
}

#noty_bottomRight_layout_container {
    margin-bottom: 30px !important;
    margin-right: 30px !important;
}

.fb_iframe_widget {
    float: right;
}

.fa-star {
    color: #ffc000;
}

.gly-rotate-90 {
    -moz-transform: scaleX(-1) !important;
    -o-transform: scaleX(-1) !important;
    -webkit-transform: scaleX(-1) !important;
    transform: scaleX(-1) !important;
    filter: FlipH !important;
    -ms-filter: 'FlipH' !important;
}

.height25 {
    height: 25px;
}

.betalen_field {
    border: 1px solid #e8e8e8;
    float: left;
    padding: 20px;
    padding-top: 10px;
}

.betalen_checkboxfield {
    background-color: #f7f7f7;
    border-top: 1px solid #e8e8e8;
    padding: 20px;
    margin-bottom: 15px;
}

#betalen_warning {
    display: none;
}

.button-disabled-color {
    background-color: #bbbbbb !important;
}

.button-disabled-color:hover {
    background-color: #bbbbbb !important;
}

/* vanaf hier css wesley */

.witbg {
    background-color: #fff;
    position: relative;
    float: left;
    width: 100%;
    padding-top: 14px;
    padding-left: 14px;
    padding-bottom: 30px;
}

.prijsb {
    color: #37b5d3;
    font-weight: bold;
}

.vliegtuigPos {
    position: relative;
    right: 50px;
}

.hrStijl {
    margin-left: 5%;
    margin-right: 5%;
    border-top: 1px solid #fff;
}

.overflow-auto {
    overflow: auto;
}

.clear-both {
    clear: both;
}

.countdown {
    margin: 0 auto;
    padding: 0px;
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
}

.timer-holder {
    margin: 0 auto;
    text-align: center;
}

.timer-slot {
    border: 1px solid #ccc;
    text-align: center;
    background-color: #f7f7f7;
    color: #323232;
    margin: 5px;
    padding: 5px;
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
}

.timer-time {
    font-family: calibri, verdana;
    font-size: 24px;
    font-weight: bold;
}

.timer-title {
    font-family: calibri, verdana;
    font-size: 10px;
    padding: 3px 0px;
}

.clearfix {
    float: none;
    clear: both;
    margin-bottom: 0 !important;
}

.countdown-melding {
    text-align: center;
    font-weight: bold;
}

/* vanaf hier css offerte upsells */

.upsells_container {
    width: 98%;
    margin: 0 auto;
    margin-bottom: 15px;
    margin-top: 15px;
}

.upsells {
    margin: 15px;
    overflow: hidden;
    width: 100%;
}

.upsells-header {
    text-align: center;
}

.upsell-email-register {
    display: none;
}

#bekijk-offerte {
    cursor: pointer;
}

.upsell-input {
    padding: 5px;
    width: 100%;
}

#logo-royal-caribbean {
    height: 50px;
}

.recommendation h3 {
    text-align: center;
}

.recommendation button {
    color: #fff;
    width: 9%;
    height: 35px;
    background-color: #37b5d3;
    border: white 2px solid;
}

.recommendation button:hover,
button:active {
    cursor: pointer;
    background-color: #da7a00;
}

.recommendation .likelyness {
    padding-top: 10px;
    font-weight: bold;
}

.recommendation .likelyness #likely {
    float: right;
}

.recommendation .selected {
    background-color: #1f91a5 !important;
    border-color: #0a0a0a !important;
}

.recommendation fieldset {
    border: none;
}

.recommendation .disabled button {
    cursor: default;
    background-color: #37b5d3;
    border: white 2px solid;
}

/* --------------------------------

    Primary style

    -------------------------------- */

@media only screen and (max-width: 1024px) {
    html {
        font-size: 62.5%;
    }

    body {
        font-size: 1.6rem;
        font-family: sans-serif;
        color: #2e3233;
        background-color: #ffffff;
    }
}

@media only screen and (max-width: 1169px) {
    body.nav-on-left.overflow-hidden {
        overflow: hidden;
    }
}

img {
    /* make images responsive */
    max-width: 100%;
}

input[type='search']::-ms-clear {
    /* removes close icon - IE */
    display: none;
}

input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-results-button,
input[type='search']::-webkit-search-results-decoration {
    display: none;
}

/* --------------------------------

    Main components

    -------------------------------- */
.cd-main-content,
.cd-main-header {
    /* Force Hardware Acceleration in WebKit */
    /*-webkit-transform: translateZ(0);
        -moz-transform: translateZ(0);
        -ms-transform: translateZ(0);
        -o-transform: translateZ(0);
        transform: translateZ(0);*/
    /*will-change: transform;*/
}

.cd-main-content,
.cd-main-header {
    position: relative;
    -webkit-transition: -webkit-transform 0.3s;
    -moz-transition: -moz-transform 0.3s;
    transition: transform 0.3s;
}

@media only screen and (max-width: 1169px) {
    .cd-main-content.nav-is-visible,
    .cd-main-header.nav-is-visible {
        -webkit-transform: translateX(260px);
        -moz-transform: translateX(260px);
        -ms-transform: translateX(260px);
        -o-transform: translateX(260px);
        transform: translateX(260px);
    }
    .nav-on-left .cd-main-content.nav-is-visible,
    .nav-on-left .cd-main-header.nav-is-visible {
        -webkit-transform: translateX(-260px);
        -moz-transform: translateX(-260px);
        -ms-transform: translateX(-260px);
        -o-transform: translateX(-260px);
        transform: translateX(-260px);
    }
}

.cd-main-content {
    z-index: 2;
}

.cd-main-header {
    height: 44px;
    z-index: 30;
}

.nav-is-fixed .cd-main-header {
    /* add .nav-is-fixed class to body if you want a fixed navigation on > 1170px */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

@media only screen and (min-width: 1170px) {
    .cd-main-header {
        height: 80px;
    }
    .cd-main-header:after {
        content: '';
        display: table;
        clear: both;
    }
}

.cd-logo {
    position: absolute;
    top: 12px;
    left: 5%;
}

.cd-logo img {
    display: block;
}

@media only screen and (max-width: 1169px) {
    .nav-on-left .cd-logo {
        left: auto;
        right: 5%;
    }
}

@media only screen and (min-width: 1170px) {
    .cd-logo {
        top: 26px;
        left: 4em;
    }
}

.cd-header-buttons {
    position: absolute;
    display: inline-block;
    top: -20px;
    right: 1%;
}

.cd-header-buttons li {
    display: inline-block;
}

@media only screen and (max-width: 1169px) {
    .nav-on-left .cd-header-buttons {
        right: auto;
        left: 5%;
    }
    .nav-on-left .cd-header-buttons li {
        float: right;
    }
}

@media only screen and (min-width: 1170px) {
    .cd-header-buttons {
        top: 18px;
        right: 4em;
    }
}

.cd-search-trigger,
.cd-nav-trigger {
    position: relative;
    display: block;
    width: 44px;
    height: 44px;
    overflow: hidden;
    white-space: nowrap;
    /* hide text */
    color: transparent;
    z-index: 10000000 !important;
}

.cd-search-trigger::before,
.cd-search-trigger::after {
    /* search icon */
    content: '';
    position: absolute;
    -webkit-transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
    transition: opacity 0.3s;
    /* Force Hardware Acceleration in WebKit */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.cd-search-trigger::before {
    /* lens */
    top: 11px;
    left: 11px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 3px solid #2e3233;
}

.cd-search-trigger::after {
    /* handle */
    height: 3px;
    width: 8px;
    background: #2e3233;
    bottom: 14px;
    right: 11px;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}

.cd-search-trigger span {
    /* container for the X icon */
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

.cd-search-trigger span::before,
.cd-search-trigger span::after {
    /* close icon */
    content: '';
    position: absolute;
    display: inline-block;
    height: 3px;
    width: 22px;
    top: 50%;
    margin-top: -2px;
    left: 50%;
    margin-left: -11px;
    background: #2e3233;
    opacity: 0;
    /* Force Hardware Acceleration in WebKit */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
    -moz-transition: opacity 0.3s, -moz-transform 0.3s;
    transition: opacity 0.3s, transform 0.3s;
}

.cd-search-trigger span::before {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}

.cd-search-trigger span::after {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

.cd-search-trigger.search-is-visible::before,
.cd-search-trigger.search-is-visible::after {
    /* hide search icon */
    opacity: 0;
}

.cd-search-trigger.search-is-visible span::before,
.cd-search-trigger.search-is-visible span::after {
    /* show close icon */
    opacity: 1;
}

.cd-search-trigger.search-is-visible span::before {
    -webkit-transform: rotate(135deg);
    -moz-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    -o-transform: rotate(135deg);
    transform: rotate(135deg);
}

.cd-search-trigger.search-is-visible span::after {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}

.cd-nav-trigger span,
.cd-nav-trigger span::before,
.cd-nav-trigger span::after {
    /* hamburger icon in CSS */
    position: absolute;
    display: inline-block;
    height: 3px;
    width: 24px;
    background: #2e3233;
}

.cd-nav-trigger span {
    /* line in the center */
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -2px;
    -webkit-transition: background 0.3s 0.3s;
    -moz-transition: background 0.3s 0.3s;
    transition: background 0.3s 0.3s;
}

.cd-nav-trigger span::before,
.cd-nav-trigger span::after {
    /* other 2 lines */
    content: '';
    right: 0;
    /* Force Hardware Acceleration in WebKit */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform-origin: 0 50%;
    -moz-transform-origin: 0 50%;
    -ms-transform-origin: 0 50%;
    -o-transform-origin: 0 50%;
    transform-origin: 0 50%;
    -webkit-transition: -webkit-transform 0.3s 0.3s;
    -moz-transition: -moz-transform 0.3s 0.3s;
    transition: transform 0.3s 0.3s;
}

.cd-nav-trigger span::before {
    /* menu icon top line */
    top: -6px;
}

.cd-nav-trigger span::after {
    /* menu icon bottom line */
    top: 6px;
}

.cd-nav-trigger.nav-is-visible span {
    /* hide line in the center */
    background: rgba(46, 50, 51, 0);
}

.cd-nav-trigger.nav-is-visible span::before,
.cd-nav-trigger.nav-is-visible span::after {
    /* keep visible other 2 lines */
    background: #2e3233;
}

.cd-nav-trigger.nav-is-visible span::before {
    -webkit-transform: translateX(4px) translateY(-3px) rotate(45deg);
    -moz-transform: translateX(4px) translateY(-3px) rotate(45deg);
    -ms-transform: translateX(4px) translateY(-3px) rotate(45deg);
    -o-transform: translateX(4px) translateY(-3px) rotate(45deg);
    transform: translateX(4px) translateY(-3px) rotate(45deg);
}

.cd-nav-trigger.nav-is-visible span::after {
    -webkit-transform: translateX(4px) translateY(2px) rotate(-45deg);
    -moz-transform: translateX(4px) translateY(2px) rotate(-45deg);
    -ms-transform: translateX(4px) translateY(2px) rotate(-45deg);
    -o-transform: translateX(4px) translateY(2px) rotate(-45deg);
    transform: translateX(4px) translateY(2px) rotate(-45deg);
}

@media only screen and (min-width: 1170px) {
    .cd-nav-trigger {
        display: none;
    }
}

#cd-primary-nav {
    margin: 0;
    padding: 0;
}

.cd-primary-nav,
.cd-primary-nav ul {
    position: fixed;
    top: 0;
    left: 0;
    list-style: none;
    height: 100%;
    width: 260px;
    background: #37b5d3;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 9999;
    /* Force Hardware Acceleration in WebKit */
    -webkit-transform: translate(0);
    -moz-transform: translate(0);
    -ms-transform: translate(0);
    -o-transform: translate(0);
    transform: translate(0);
    -webkit-transition: -webkit-transform 0.3s;
    -moz-transition: -moz-transform 0.3s;
    transition: transform 0.3s;
}

.cd-primary-nav a,
.cd-primary-nav ul a {
    display: block;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #5bc2da;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    /*will-change: transform, opacity;*/
    -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
    -moz-transition: -moz-transform 0.3s, opacity 0.3s;
    transition: transform 0.3s, opacity 0.3s;
}

.cd-primary-nav.is-hidden,
.cd-primary-nav ul.is-hidden {
    /* secondary navigations hidden by default */
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
    transform: translateX(100%);
}

.cd-primary-nav.moves-out > li > a,
.cd-primary-nav ul.moves-out > li > a {
    /* push the navigation items to the left - and lower down opacity - when secondary nav slides in */
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
}

@media only screen and (max-width: 1169px) {
    .nav-on-left .cd-primary-nav,
    .nav-on-left .cd-primary-nav ul {
        right: auto;
        left: 0;
    }
}

.cd-primary-nav .see-all a {
    /* different style for the See all button on mobile and tablet */
    color: #69aa6f;
}

.cd-primary-nav .cd-nav-gallery .cd-nav-item,
.cd-primary-nav .cd-nav-icons .cd-nav-item {
    /* items with picture (or icon) and title */
    height: 80px;
    line-height: 80px;
}

.cd-primary-nav .cd-nav-gallery .cd-nav-item h3,
.cd-primary-nav .cd-nav-icons .cd-nav-item h3 {
    overflow: hidden;
    text-overflow: ellipsis;
}

.cd-primary-nav .cd-nav-gallery .cd-nav-item {
    padding-left: 90px;
}

.cd-primary-nav .cd-nav-gallery .cd-nav-item img {
    position: absolute;
    display: block;
    height: 40px;
    width: auto;
    left: 20px;
    top: 50%;
    margin-top: -20px;
}

.cd-primary-nav .cd-nav-icons .cd-nav-item {
    padding-left: 75px;
}

.cd-primary-nav .cd-nav-icons .cd-nav-item p {
    color: #2e3233;
    font-size: 1.3rem;
    /* hide description on small devices */
    display: none;
}

.cd-primary-nav .cd-nav-icons .cd-nav-item::before {
    /* item icon */
    content: '';
    display: block;
    position: absolute;
    left: 20px;
    top: 50%;
    margin-top: -20px;
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 40px 40px;
}
.slide-enter-active,
.slide-leave-active {
    transition: visibility 0s 3.3s;
    visibility: visible;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    visibility: hidden;
    transition: visibility 0s 0.3s;
}

@media only screen and (max-width: 1169px) {
    .cd-primary-nav {
        /* by default .cd-primary-nav is hidden - trick for iOS devices where you can see the navigation if you pull down */
        visibility: visible;
        position: fixed;
        -webkit-transition: visibility 0s 0.3s;
        -moz-transition: visibility 0s 0.3s;
        transition: visibility 0s 0.3s;
        list-style: none;
    }
}

@media only screen and (min-width: 1170px) {
    .veelgesteldevragen input {
        width: 70% !important;
    }
    .veelgesteldevragen button {
        width: 25% !important;
    }
    .cd-primary-nav {
        position: static;
        padding: 0 150px 0 0;
        height: auto;
        width: auto;
        float: right;
        overflow: visible;
        background: transparent;
    }
    .cd-primary-nav:after {
        content: '';
        display: table;
        clear: both;
    }
    .cd-primary-nav.moves-out > li > a {
        /* reset mobile style */
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
    .cd-primary-nav ul {
        position: static;
        height: auto;
        width: auto;
        background: transparent;
        overflow: visible;
        z-index: 3;
        list-style: none;
    }
    .cd-primary-nav ul.is-hidden {
        /* reset mobile style */
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
        transform: translateX(0);
    }
    .cd-primary-nav ul.moves-out > li > a {
        /* reset mobile style */
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
    .cd-primary-nav > li {
        float: left;
        margin-left: 3em;
    }
    .cd-primary-nav > li > a {
        /* main navigation buttons style */
        position: relative;
        display: inline-block;
        height: 80px;
        line-height: 80px;
        padding: 0 10px;
        color: #2e3233;
        overflow: visible;
        border-bottom: none;
        -webkit-transition: color 0.3s, box-shadow 0.3s;
        -moz-transition: color 0.3s, box-shadow 0.3s;
        transition: color 0.3s, box-shadow 0.3s;
    }
    .cd-primary-nav > li > a:hover {
        color: #69aa6f;
    }
    .cd-primary-nav > li > a.selected {
        color: #69aa6f;
        box-shadow: inset 0 -2px 0 #69aa6f;
    }
    .cd-primary-nav .go-back,
    .cd-primary-nav .see-all {
        display: none;
    }
    .cd-primary-nav .cd-secondary-nav,
    .cd-primary-nav .cd-nav-gallery,
    .cd-primary-nav .cd-nav-icons {
        /* dropdown menu style */
        position: absolute;
        top: 80px;
        width: 100vw;
        background: #ffffff;
        padding: 48px 64px 130px;
        box-shadow: inset 0 1px 0 #e2e3df, 0 3px 6px rgba(0, 0, 0, 0.05);
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
        transform: translateX(0);
        -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
        -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
        transition: opacity 0.3s 0s, visibility 0s 0s;
    }
    .cd-primary-nav .cd-secondary-nav:after,
    .cd-primary-nav .cd-nav-gallery:after,
    .cd-primary-nav .cd-nav-icons:after {
        content: '';
        display: table;
        clear: both;
    }
    .cd-primary-nav .cd-secondary-nav.is-hidden,
    .cd-primary-nav .cd-nav-gallery.is-hidden,
    .cd-primary-nav .cd-nav-icons.is-hidden {
        opacity: 0;
        visibility: hidden;
        -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
        -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
        transition: opacity 0.3s 0s, visibility 0s 0.3s;
    }
    .cd-primary-nav .cd-secondary-nav > .see-all,
    .cd-primary-nav .cd-nav-gallery > .see-all,
    .cd-primary-nav .cd-nav-icons > .see-all {
        /* this is the BIG See all button at the bottom of the dropdown menu */
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 80px;
        width: 100%;
        overflow: hidden;
        /* reset some inherited style */
        margin: 0;
        padding: 0;
    }
    .cd-primary-nav .cd-secondary-nav > .see-all a,
    .cd-primary-nav .cd-nav-gallery > .see-all a,
    .cd-primary-nav .cd-nav-icons > .see-all a {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        font-size: 2.2rem;
        font-weight: bold;
        text-align: center;
        line-height: 80px;
        border-top: 1px solid #e2e3df;
        /* reset some inherited style */
        border-bottom: none;
        margin: 0;
        padding: 0;
        -webkit-transition: color 0.2s, background 0.2s, border 0.2s;
        -moz-transition: color 0.2s, background 0.2s, border 0.2s;
        transition: color 0.2s, background 0.2s, border 0.2s;
    }
    .cd-primary-nav .cd-secondary-nav > .see-all a:hover,
    .cd-primary-nav .cd-nav-gallery > .see-all a:hover,
    .cd-primary-nav .cd-nav-icons > .see-all a:hover {
        background: #2e3233;
        border-color: #2e3233;
        color: #ffffff;
    }
    .cd-primary-nav .cd-secondary-nav > li {
        /* change the height according to your needs - you can even set height: auto */
        height: 340px;
        /* here you set the number of columns - use width percentage */
        width: 23%;
        float: left;
        margin-right: 2.66%;
        border-right: 1px solid #e2e3df;
        overflow: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .cd-primary-nav .cd-secondary-nav > li:nth-child(4n + 2) {
        /* +2 because we have 2 list items with display:none */
        margin-right: 0;
        border-right: none;
    }
    .cd-primary-nav .cd-secondary-nav > li > a {
        /* secondary nav title */
        color: #69aa6f;
        font-weight: bold;
        font-size: 1.6rem;
        margin-bottom: 0.6em;
    }
    .cd-primary-nav .cd-secondary-nav a {
        height: 30px;
        line-height: 30px;
        padding: 0 18% 0 0;
        color: #2e3233;
        border-bottom: none;
        font-size: 1.4rem;
    }
    .cd-primary-nav .cd-secondary-nav a:hover {
        color: #69aa6f;
    }
    .cd-primary-nav .cd-secondary-nav ul {
        /* Force Hardware Acceleration in WebKit */
        -webkit-transform: translateZ(0);
        -moz-transform: translateZ(0);
        -ms-transform: translateZ(0);
        -o-transform: translateZ(0);
        transform: translateZ(0);
    }
    .cd-primary-nav .cd-secondary-nav ul ul {
        /* tertiary navigation */
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
    .cd-primary-nav .cd-secondary-nav ul ul.is-hidden {
        -webkit-transform: translateX(100%);
        -moz-transform: translateX(100%);
        -ms-transform: translateX(100%);
        -o-transform: translateX(100%);
        transform: translateX(100%);
    }
    .cd-primary-nav .cd-secondary-nav ul ul .go-back {
        display: block;
    }
    .cd-primary-nav .cd-secondary-nav ul ul .go-back a {
        color: transparent;
    }
    .cd-primary-nav .cd-secondary-nav ul ul .see-all {
        display: block;
    }
    .cd-primary-nav .cd-secondary-nav .moves-out > li > a {
        /* push the navigation items to the left - and lower down opacity - when tertiary nav slides in */
        -webkit-transform: translateX(-100%);
        -moz-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
        -o-transform: translateX(-100%);
        transform: translateX(-100%);
    }
    .cd-primary-nav .cd-nav-gallery li {
        /* set here number of columns - use width percentage */
        width: 22%;
        float: left;
        margin: 0 4% 40px 0;
    }
    .cd-primary-nav .cd-nav-gallery li:nth-child(4n + 2) {
        /* +2 because we have two additional list items with display:none */
        margin-right: 0;
    }
    .cd-primary-nav .cd-nav-gallery .cd-nav-item {
        border-bottom: none;
        padding: 0;
        height: auto;
        line-height: 1.2;
    }
    .cd-primary-nav .cd-nav-gallery .cd-nav-item img {
        position: static;
        margin-top: 0;
        height: auto;
        width: 100%;
        margin-bottom: 0.6em;
    }
    .cd-primary-nav .cd-nav-gallery .cd-nav-item h3 {
        color: #69aa6f;
        font-weight: bold;
        padding: 0 0.4em;
    }
    .cd-primary-nav .cd-nav-icons li {
        /* set here number of columns - use width percentage */
        width: 32%;
        float: left;
        margin: 0 2% 20px 0;
    }
    .cd-primary-nav .cd-nav-icons li:nth-child(3n + 2) {
        /* +2 because we have two additional list items with display:none */
        margin-right: 0;
    }
    .cd-primary-nav .cd-nav-icons .cd-nav-item {
        border-bottom: none;
        height: 80px;
        line-height: 1.2;
        padding: 24px 0 0 85px;
    }
    .cd-primary-nav .cd-nav-icons .cd-nav-item:hover {
        background: #f6f6f5;
    }
    .cd-primary-nav .cd-nav-icons .cd-nav-item h3 {
        color: #69aa6f;
        font-weight: bold;
    }
    .cd-primary-nav .cd-nav-icons .cd-nav-item p {
        display: block;
    }
    .cd-primary-nav .cd-nav-icons .cd-nav-item::before {
        left: 25px;
    }
}

.has-children > a,
.go-back a {
    position: relative;
}

.has-children > a::before,
.has-children > a::after,
.go-back a::before,
.go-back a::after {
    /* arrow icon in CSS - for element with nested unordered lists */
    content: '';
    position: absolute;
    top: 50%;
    margin-top: -1px;
    display: inline-block;
    height: 2px;
    width: 10px;
    background: #fff;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    color: #fff;
}

.has-children > a::before,
.go-back a::before {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}

.has-children > a::after,
.go-back a::after {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

@media only screen and (min-width: 1170px) {
    .has-children > a::before,
    .has-children > a::after,
    .go-back a::before,
    .go-back a::after {
        background: #c9cbc4;
    }
    .has-children > a:hover::before,
    .has-children > a:hover::after,
    .go-back a:hover::before,
    .go-back a:hover::after {
        background: #69aa6f;
    }
}

.has-children > a {
    padding-right: 40px;
}

.has-children > a::before,
.has-children > a::after {
    /* arrow goes on the right side - children navigation */
    right: 20px;
    -webkit-transform-origin: 9px 50%;
    -moz-transform-origin: 9px 50%;
    -ms-transform-origin: 9px 50%;
    -o-transform-origin: 9px 50%;
    transform-origin: 9px 50%;
}

.cd-primary-nav .go-back a {
    padding-left: 40px;
}

.cd-primary-nav .go-back a::before,
.cd-primary-nav .go-back a::after {
    /* arrow goes on the left side - go back button */
    left: 20px;
    -webkit-transform-origin: 1px 50%;
    -moz-transform-origin: 1px 50%;
    -ms-transform-origin: 1px 50%;
    -o-transform-origin: 1px 50%;
    transform-origin: 1px 50%;
}

@media only screen and (min-width: 1170px) {
    .has-children > a::before,
    .has-children > a::after {
        right: 15%;
    }

    .cd-primary-nav > .has-children > a {
        /* main navigation arrows on larger devices */
        padding-right: 30px !important;
    }
    .cd-primary-nav > .has-children > a::before,
    .cd-primary-nav > .has-children > a::after {
        width: 9px;
        -webkit-transform-origin: 50% 50%;
        -moz-transform-origin: 50% 50%;
        -ms-transform-origin: 50% 50%;
        -o-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
        background: #c9cbc4;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: width 0.3s, -webkit-transform 0.3s;
        -moz-transition: width 0.3s, -moz-transform 0.3s;
        transition: width 0.3s, transform 0.3s;
    }
    .cd-primary-nav > .has-children > a::before {
        right: 12px;
    }
    .cd-primary-nav > .has-children > a::after {
        right: 7px;
    }
    .cd-primary-nav > .has-children > a.selected::before,
    .cd-primary-nav > .has-children > a.selected::after {
        width: 14px;
    }
    .cd-primary-nav > .has-children > a.selected::before {
        -webkit-transform: translateX(5px) rotate(-45deg);
        -moz-transform: translateX(5px) rotate(-45deg);
        -ms-transform: translateX(5px) rotate(-45deg);
        -o-transform: translateX(5px) rotate(-45deg);
        transform: translateX(5px) rotate(-45deg);
    }
    .cd-primary-nav > .has-children > a.selected::after {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .cd-secondary-nav > .has-children > a::before,
    .cd-secondary-nav > .has-children > a::after {
        /* remove arrows on secondary nav titles */
        display: none;
    }

    .cd-primary-nav .go-back a {
        padding-left: 20px;
    }
    .cd-primary-nav .go-back a::before,
    .cd-primary-nav .go-back a::after {
        left: 1px;
    }
}

.cd-search {
    position: absolute;
    height: 50px;
    width: 100%;
    top: 50px;
    left: 0;
    z-index: 3;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
    transition: opacity 0.3s 0s, visibility 0s 0.3s;
}

.cd-search form {
    height: 100%;
    width: 100%;
}

.cd-search input {
    border-radius: 0;
    border: none;
    background: #ffffff;
    height: 100%;
    width: 100%;
    padding: 0 5%;
    box-shadow: inset 0 1px 0 #e2e3df, 0 3px 6px rgba(0, 0, 0, 0.05);
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    /*appearance: none;*/
}

.cd-search input::-webkit-input-placeholder {
    color: #c9cbc4;
}

.cd-search input::-moz-placeholder {
    color: #c9cbc4;
}

.cd-search input:-moz-placeholder {
    color: #c9cbc4;
}

.cd-search input:-ms-input-placeholder {
    color: #c9cbc4;
}

.cd-search input:focus {
    outline: none;
}

.cd-search.is-visible {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
    transition: opacity 0.3s 0s, visibility 0s 0s;
}

.nav-is-fixed .cd-search {
    position: fixed;
}

@media only screen and (min-width: 1170px) {
    .cd-search {
        height: 120px;
        top: 80px;
    }
    .cd-search input {
        padding: 0 2em;
        font-size: 3.2rem;
        font-weight: 300;
    }
}

.cd-overlay {
    /* shadow layer visible when navigation is active */
    position: fixed;
    z-index: 2;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background-color: rgba(239, 239, 239, 0.8);
    visibility: visible;
    opacity: 1;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s,
        -webkit-transform 0.3s 0s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s, -moz-transform 0.3s 0s;
    transition: opacity 0.3s 0s, visibility 0s 0.3s, transform 0.3s 0s;
}

@media only screen and (max-width: 1169px) {
    .cd-overlay.is-visible {
        -webkit-transform: translateX(260px);
        -moz-transform: translateX(260px);
        -ms-transform: translateX(260px);
        -o-transform: translateX(260px);
        transform: translateX(260px);
    }
    .nav-on-left .cd-overlay.is-visible {
        -webkit-transform: translateX(-260px);
        -moz-transform: translateX(-260px);
        -ms-transform: translateX(-260px);
        -o-transform: translateX(-260px);
        transform: translateX(-260px);
    }
    .cd-overlay.is-visible.search-is-visible,
    .nav-on-left .cd-overlay.is-visible.search-is-visible {
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
        transform: translateX(0);
    }
}

/* --------------------------------

    support for no js

    -------------------------------- */
.no-js .cd-primary-nav {
    position: relative;
    height: auto;
    width: 100%;
    overflow: visible;
    visibility: visible;
    z-index: 2;
}

.no-js .cd-search {
    position: relative;
    top: 0;
    opacity: 1;
    visibility: visible;
}

@media only screen and (min-width: 1170px) {
    .no-js .cd-primary-nav {
        position: absolute;
        z-index: 3;
        display: inline-block;
        width: auto;
        top: 0;
        right: 150px;
        padding: 0;
    }

    .no-js .nav-is-fixed .cd-primary-nav {
        position: fixed;
    }
}

.cd-primary-nav.nav-is-visible li a {
    color: #fff;
}

.cd-primary-nav.nav-is-visible a li a {
    color: #fff;
}

/* Less than 480px */
@media screen and (max-width: 479px) {
    /* Your styles here */

    #debug-console:after {
        content: ' Under 480px';
    }

    #marketingblok {
        margin-left: auto;
        margin-right: auto;
        width: 91% !important;
    }
}

@media screen and (max-width: 372px) {
    #bestemming_titel {
        font-size: 13px !important;
    }
}
@media screen and (min-width: 320px) and (max-width: 479px) {
    /* themas EN bestemmingen mobile */
    .responsive_thema {
        margin-right: 0 !important;
        margin-left: 10px !important;
    }
    .responsive_bestemming {
        margin-right: 10px !important;
        margin-left: 5px !important;
    }
    #thema_img {
        width: 100%;
    }
    #thema_text {
        width: 83%;
    }
    #thema_titel {
        font-size: 20px !important;
    }
    #bestemming_img {
        width: 45%;
    }
    #bestemming_text {
        width: 36%;
    }
    #bestemming_titel {
        font-size: 16px !important;
    }
}

@media screen and (min-width: 478px) and (max-width: 641px) {
    /* themas EN bestemmingen middel */
    .responsive_thema {
        margin-right: 0 !important;
        margin-left: 15px !important;
    }
    .responsive_bestemming {
        margin-right: 0 !important;
        margin-left: 9px !important;
    }
    #thema_img {
        width: 90% !important;
    }
    #thema_text {
        width: 100% !important;
    }
    #thema_titel {
        font-size: 20px !important;
    }
    #bestemming_img {
        width: 45% !important;
    }
    #bestemming_text {
        width: 100% !important;
    }
    #bestemming_titel {
        font-size: 16px !important;
    }
}

@media screen and (min-width: 625px) and (max-width: 900px) {
    /* marketing blok tablet klein */

    #marketingblok {
        margin-bottom: 15px;
    }

    #text-openingstijden {
        display: none;
    }

    #checkjes-show {
        display: none;
    }
}

@media screen and (min-width: 900px) and (max-width: 1025px) {
    /* marketing blok tablet middel */
    #greyblock-size {
        top: 97.5%;
        height: 32%;
        width: 130%;
    }

    #text-openingstijden {
        display: none;
    }

    #checkjes-show {
        display: none;
    }
}

/* Over 480px - 900px */
@media screen and (min-width: 481px) and (max-width: 900px) {
    /* Your styles here */

    #debug-console:after {
        content: ' Over 480px - Under 900px';
    }

    /* themas EN bestemmingen tablet middel */
    #thema_img {
        width: 47%;
    }
    #thema_text {
        width: 46%;
    }
    #thema_titel {
        font-size: 20px !important;
    }
    #bestemming_img {
        width: 30%;
    }
    #bestemming_text {
        width: 26%;
    }
    #bestemming_titel {
        font-size: 16px !important;
    }
}
@media screen and (max-width: 1000px) {
    .hutImage {
        width: 100% !important;
    }
}
@media screen and (max-width: 900px) {
    .fb-like {
        display: none !important;
    }
    .hutstyle {
        clear: left;
    }
    .verzorging {
        width: 100% !important;
    }
    .verzorgingtitle {
        width: 100% !important;
    }
    .firstselect {
        margin-bottom: 12px;
    }
}
/* Over 900px - 1024px */
@media screen and (min-width: 640px) and (max-width: 900px) {
    .optiontable {
        margin-left: 12px;
    }
}

/* Over 900px - 1024px */
@media screen and (min-width: 900px) and (max-width: 1023px) {
    /* Your styles here */

    #debug-console:after {
        content: ' Over 900px - Under 1024px';
    }
}

#kantoor_image {
    background-image: url('https://cdn.cruisereizen.nl/img/marketing/kantoor/pand.jpg');
    width: auto;
    height: 109px;
}

@media screen and (max-width: 840px) {
    .stap-header .width60,
    .stap-header .width30 {
        width: 95% !important;
        margin-bottom: 12px;
    }
}
@media screen and (max-width: 900px) {
    #kantoor_image {
        background-image: none;
    }

    #cruise-logo {
        margin-top: 0;
        float: left;
    }

    #footerquotes {
        margin-bottom: 20px;
    }

    /* themas EN bestemmingen middelmaat */
    #thema_img {
        width: 90% !important;
    }
    #thema_text {
        width: 83% !important;
    }
    #bestemming_img {
        width: 45% !important;
    }
    #bestemming_text {
        width: 36% !important;
    }

    html,
    body {
        font-size: 14px;
        line-height: 22px;
        width: 100%;
        overflow-x: hidden;
    }
    body {
        min-width: 96% !important;
    }
    #bottom {
        min-width: 96% !important;
    }
    #menu-back {
        display: none;
    }
    #menu-back-m {
        display: inline;
    }
    #top {
        margin-bottom: 0 !important;
    }
    .label {
        width: 25% !important;
    }
    .stap-content .label {
        width: 100% !important;
    }
    .variabel {
        width: 75% !important;
    }
    .header3 {
        font-size: 14px !important;
    }
    .fontsize14 {
        font-size: 16px !important;
    }
    select {
        font-size: 14px !important;
    }
    .waarom {
        display: none !important;
    }
    #cookie-bar {
        display: none !important;
    }
    .top-right {
        width: 94% !important;
        margin-left: 2.5%;
    }
    #cruises .cruiseblok .width30 {
        width: 100%;
    }
    #cruises .cruiseblok .width47 {
        width: 100%;
    }
    #cruises .cruiseblok .width22 {
        width: 100%;
    }
    .cruise-foto img {
        margin-top: -60px;
        margin-left: 0 !important;
    }
    .cruise-prijs-content-image {
        width: 100%;
    }

    .center {
        width: 100%;
    }
    .intro,
    #intro {
        position: relative;
        margin: 0;
        left: 0;
        width: 100% !important;
        padding: 0;
    }
    #intro .font14,
    .intro .font14 {
        font-size: 18px;
        line-height: 30px;
    }
    .cruise-prijs-content-prijs {
        background-color: #37b5d3 !important;
        color: #fff !important;
        border-radius: 50px;
        width: 100px;
        height: 76px;
        padding-top: 20px;
        position: absolute;
        margin-top: 0;
        left: auto;
        right: 0;
    }
    #filter #filtersubcontent #begindatum,
    #filter #filtersubcontent #einddatum,
    #filter #filtersubcontent #begindatum2 {
        background-position: 318px !important;
    }
    .cruise-prijs-content {
        float: left;
        width: 99%;
        margin-top: 0;
    }
    .cruise-prijs-content-image img {
        margin-top: 0;
        width: 150px;
        height: auto;
    }
    .cruise-prijs-content-meer {
        clear: both;
        margin-top: 4px;
        float: left;
        width: 100%;
        margin-bottom: 10px;
    }
    .cruise-prijs-content {
        background-color: transparent;
        height: auto !important;
    }
    .waarom {
        width: 100% !important;
    }
    #center {
        width: 96%;
    }
    /*#topmenu,.spreken {display:none !important;} */
    .marginright15 {
        margin: 0;
    }
    /*.block .checks li {float:left;width:44%;}*/
    .prijsfly {
        margin-right: 0;
    }
    #map {
        display: none;
    }
    .campaign-sale {
        width: 65%;
    }
    .campaign-button {
        width: 30%;
        margin-top: 20px !important;
    }
    #campaign-body {
        margin-bottom: 20px;
    }
    .paddingleft20 {
        padding-left: 0;
    }
    #front-featured {
        margin-bottom: 15px;
    }
    #newsletter-content span.font16,
    #newsletter-content span.font14 {
        font-size: 16px !important;
    }
    #newsletter-content {
        text-align: center !important;
    }
    .waarom {
        margin-top: 40px !important;
    }
    .waarom .checks li {
        margin-right: 15px !important;
        font-size: 12px !important;
    }
    .cruise-stappen .stap-content .width20 {
        width: 40% !important;
    }
    .cruise-stappen .stap-content .width80 {
        width: 60%;
    }
    .stap-header .width60,
    .stap-header .width30 {
        width: 95% !important;
        margin-bottom: 0;
    }
    .cruiseinfoimg {
        cursor: pointer;
    }
    .stap-header .width30 {
        margin-bottom: 10px !important;
    }
    #cruisepagina {
        margin-top: 20px !important;
    }
    .stap-content .width20 {
        width: 96% !important;
    }
    .cruise-prijs-content-vluchten {
        display: none;
    }
    /* Template width responsive 640px */
    .facts .label {
        width: 100% !important;
    }
    .video.margintop92 {
        margin-top: 0;
    }

    #logo {
        position: relative;
        float: right;
        text-align: center;
        margin-bottom: 8px;
    }
    #logos {
        float: none;
        width: 100%;
        margin: 0 auto;
    }
    #home-filter {
        margin-top: 0;
    }
    .divider {
        display: none;
    }
    /* Veranderd van ID naar class */
    .cruise-logo {
        width: 164px;
        height: 34px;
        background-size: 382%;
        margin-right: 5px;
    }

    .cd-main-header {
        float: left !important;
        left: 0 !important;
        width: 70px !important;
        left: 30px;
    }

    #head {
        margin-top: -1px;
        height: 38px;
    }

    .head_fixed {
        background-color: #fff;
        width: 100%;
        margin-left: -10px;
        padding-left: 7px;
        position: fixed;
        z-index: 10;
        display: none;
        /*box-shadow: 0 12px 23px 6px #fff;border-bottom: 1px solid #eee;*/
    }
    .displaynone_desktop {
        display: block;
    }
    /*Footer */
    .personeelsfoto_index {
        display: none;
    }
    .footerb1,
    .footerb2,
    .footerb3 {
        display: none;
    }
    .content {
        display: none;
    }
    .copyrightmenu,
    .copyrightsocial {
        display: none;
    }
    #front-banner,
    .rederij-logos,
    .blocks,
    #front-newsletter,
    .campaign-slogan {
        display: none;
    }
    .pand {
        display: none !important;
    }
    #front-featured .height150 {
        padding: 0 !important;
    }
    #front-featured img {
        margin-top: -75px;
    }
    #home-filter {
        border: 1px solid #eee;
    }
    #home-filter #begindatum,
    #home-filter #begindatum2,
    #home-filter #einddatum {
        width: 100% !important;
    }
    .main {
        margin-top: 0 !important;
    }
    #filter {
        margin-top: 20px;
    }
    #campaign {
        margin-top: 15px !important;
    }
    #top #divider {
        display: none;
    }
    .topmenu ul li.item288 {
        padding: 0;
        border: 0;
        margin: 0;
        text-align: center;
    }

    #intro,
    #overcruise {
        display: none;
    }
    .artikel-intro #intro {
        display: block !important;
        margin: 0 !important;
        width: 92% !important;
    }
    .bedrag {
        width: 228px !important;
    }
    #cruise-overzicht .stap-header {
        margin: -10px;
        margin-bottom: 10px;
    }
    .cruise-stappen .stap-content input.width20 {
        width: 95% !important;
    }
    #cruise-overzicht:after {
        border: 0 !important;
        display: none !important;
    }
    #ui-datepicker-div {
        width: 88% !important;
    }
    .buttongrijs {
        display: none !important;
    }
    .bigheader-center h1 {
        font-size: 24px;
    }
    .dagplanning,
    #cruisepagina .width69,
    #cruisepagina .width59 {
        width: 100% !important;
    }
    .width59,
    .width69 {
        padding-left: 0 !important;
        margin-top: 10px !important;
    }
    .width59 .paddingleft15,
    .width69 .paddingleft15 {
        padding-left: 0 !important;
    }
    .artikel-article {
        margin-top: 20px;
    }
    .height32 {
        height: auto;
        float: left;
    }
    #cruise-overzicht {
        width: 100% !important;
        padding: 10px;
        border: 1px solid #efefef;
    }
    .blog-intro #intro {
        display: block;
        margin: 0 !important;
        width: 90% !important;
    }
    .blog-intro img {
        display: none;
    }
    .blog-intro-blok {
        margin: 0 !important;
        width: 100% !important;
        position: relative !important;
        margin-top: 30px !important;
    }
    .blog-intro {
        margin-bottom: 0 !important;
    }
    .blog-intro-blok h1 {
        font-size: 24px !important;
    }
    .blog-intro-blok p {
        font-size: 14px !important;
    }
    .blog-intro {
        width: 100% !important;
        margin-top: 0;
        overflow: hidden;
        margin-bottom: 10px;
    }
    .blogartikel-article .blog-intro {
        height: 106px;
        overflow: hidden;
    }
    .blogartikel-article .blog-intro img {
        height: 282px !important;
        width: 100%;
    }
    .cruise-prijs-content-prijs-vanaf {
        font-size: 12px !important;
        color: #fff !important;
    }
    .cruise-prijs-content .prijsfly {
        margin-right: -4px !important;
        margin-top: -296px !important;
        padding: 4px !important;
        line-height: 16px !important;
        z-index: 100 !important;
    }
    .blog-image {
        height: 150px;
    }
    .blog-image img {
        width: 100%;
        margin: 0;
        margin-top: -50px;
        height: auto;
    }
    .blog-content h2 {
        margin-top: 10px !important;
        font-size: 18px !important;
    }
    .blog-article .width72 {
        width: 100% !important;
        margin-bottom: 25px;
    }
    .cruise-overzicht .stap-header {
        display: block !important;
    }
    .persoon .width38 {
        width: 30% !important;
    }
    .stap-content .regel .label {
        width: 32% !important;
    }
    .cruise-stappen .stap-content .regel .width80 {
        width: 100% !important;
    }
    .cruise-info .regel .width58 {
        width: 42% !important;
    }
    .cruise-info .regel .width38 {
        width: 55% !important;
    }
    .cruise-prijzen .variabel {
        width: 38% !important;
    }
    .cruise-boeken {
        display: none;
    }
    .campagnetekst .width100 {
        width: 95% !important;
    }
    .epicthumbs {
        margin-top: 10px;
    }
    .sorted,
    .hutten-header {
        font-size: 0.85em !important;
    }
    #cruise-overzicht {
        width: 100% !important;
    }
    #div_extra_informatie {
        width: 40% !important;
        z-index: 1000000 !important;
    }
    /*.stap-content .grootbutton {display:none !important;}*/
    /*.button, .button:link, .button:visited, .button:hover {height:40px !important;line-height:40px !important;} */
    .topmenu {
        width: 100%;
    }
    /*.logos-img {float: right;clear: both;display: block;width:50%;margin:0 auto !important;margin-top:-50px !important;}*/
    .overiglogos .logos-img {
        margin-top: 0 !important;
        float: none !important;
        margin: 0 auto !important;
        width: 84px !important;
    }
    .breadcrumb .floatleft {
        display: none;
    }
    .bel {
        float: none;
        clear: both;
        width: 295px;
        margin: 0 auto !important;
        display: none;
    }
    #slideshow,
    #main-image-sub,
    #slideshow-cruise,
    .hoofdmenu {
        display: none;
    }
    #home-filter {
        position: relative;
        top: 0;
        width: 100%;
    }
    .campaign-button {
        width: 35%;
    }
    .campaign-button a {
        margin-right: 20px;
    }
    .campaign-sale {
        width: 60%;
    }
    .mobile {
        display: block;
    }
    .cd-main-header {
        /*background-color:#37b5d3;*/
    }

    .keuze_hidemobile {
        display: none;
    }
    #keuze_toonmeer {
        display: block;
    }
    html,
    body {
        font-size: 14px;
        line-height: 22px;
        width: 100%;
        overflow-x: hidden;
    }

    /* RESETTEN MAAR */
    .center {
        width: 95% !important;
        position: initial;
    }
    .width23,
    .width24,
    .width25,
    .width31,
    .width32,
    .width73,
    .width48 {
        width: 100% !important;
    }

    .width20,
    .width80 {
        width: 100% !important;
    }
    .width80 .width100,
    .width40 {
        width: 96% !important;
    }
    .width75 {
        width: 100%;
    }
    .width80 .width100 .width20 {
        width: 96%;
        margin-bottom: 15px;
    }
    .width80 .width100 .width19 {
        width: 96%;
        margin-bottom: 15px;
    }

    /*rederijen */
    .rederij-sfeer {
        display: none;
    }
    .rederijen-overzicht .width80 {
        width: 70% !important;
    }
    .rederijen-overzicht .checks2 {
        margin-top: 8px !important;
    }
    /*header */
    .tijden {
        font-size: 11px;
    }
    .cardtable .cardsdivider .width25 {
        width: 100% !important;
        text-align: center;
    }
    .cardtable .cardsdivider .width75 {
        display: none;
    }
    .cardtable .cardsheader .width25 {
        width: 25% !important;
        float: left;
    }
    .cardtable .cardsdivider .width25 {
        width: 100% !important;
    }
    .cardtable .cardline .width25 {
        width: 100% !important;
        margin-bottom: 5px;
        text-align: center;
    }
    .cardtable .cardline .width75 .width25 {
        width: 25% !important;
    }

    /* aanbieding banner */
    .campaign-sale {
        margin-left: 9px;
    }

    /* filter */
    #home-filter {
        width: 95%;
        margin-top: 15px;
    }

    /* waarom cruisereizen */
    #middle-top {
        margin-top: -20px;
    }
    .top-right {
        max-width: 94%;
        margin-left: 2.5%;
    }

    /* divider */
    .divider {
        display: none;
    }
    .mobile-divider {
        display: block;
    }

    /* aanbiedingen front-featured */
    .bigheader-center h1 {
        font-size: 16px;
        padding-top: 10px;
    }
    .ff-mobile {
        max-width: 94%;
        margin-left: 2.5%;
        margin-top: 16px;
    }
    .prijsfly {
        margin-top: -10px;
    }

    /* wie en wat is cruisereizen */
    .content {
        display: block;
        width: 100%;
    }
    .darkblue {
        font-size: 16px;
    }

    /*footer */
    .footer-blok {
        max-width: 94%;
        margin-left: 2.5%;
    }
    #footer-2-content {
        max-width: 94%;
        margin-left: 2.5%;
    }

    /*footer social */
    .footer-item-logo {
        width: 50%;
        font-size: 0.9em;
    }
    .footer-item-menu {
        width: 50%;
    }
    .footer-item-images {
        display: block !important;
    }

    .copyrightsocial {
        display: block;
        position: absolute;
        right: 0;
    }
    .google a img {
        float: right;
        position: absolute;
        right: 13px;
        top: 40px;
    }

    .anvr-img {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -869px -18px;
        display: block;
        width: 21px;
        height: 30px;
    }
    .sgr-img {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -895px -18px;
        display: block;
        width: 21px;
        height: 30px;
    }
    .cal-img {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -922px -18px;
        display: block;
        width: 21px;
        height: 30px;
    }
    .clia-img {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -946px -18px;
        display: block;
        width: 20px;
        height: 30px;
    }

    /* Schip pagina */
    #content_pagina .width68,
    #content_pagina .width30,
    #content_pagina .width28 {
        width: 100%;
    }
    #content_pagina .height300 {
        height: auto;
    }
    #content_pagina .margintop20 {
        margin-top: 0;
    }
    #content_pagina .beauty-info {
        margin-top: -120px !important;
    }
    #content_pagina .eten-info,
    #content_pagina .ontspanning-info,
    #content_pagina .beauty-info,
    #content_pagina .sport-info,
    #content_pagina .rolstoel-info,
    #content_pagina .wifi-info,
    #content_pagina .kinderen-info {
        width: 45%;
        float: left;
        margin-right: 10px;
    }
    #content_pagina .eten-content,
    #content_pagina .ontspanning-content,
    #content_pagina .beauty-content,
    #content_pagina .sport-content,
    #content_pagina .rolstoel-content,
    #content_pagina .wifi-content,
    #content_pagina .kinderen-content {
        width: 67%;
        float: left;
        margin-right: 0;
    }
    #content_pagina .tabs .active:after,
    .tabs a:hover:after {
        border: 0;
    }
    #content_pagina .width100 .width2 {
        height: 5px;
    }
    #content_pagina .width49 {
        width: 100%;
    }
    #content_pagina .minheight126 {
        min-height: auto;
    }
    #content_pagina .hutinformatie .width50 {
        width: 100%;
    }
    #content_pagina .hutinformatie .width40 {
        width: 40% !important;
    }
    #content_pagina .cruise-prijs-content-prijs {
        width: 78px !important;
        margin-top: 0;
        right: 0;
        left: auto;
        height: 66px !important;
        padding-top: 10px;
    }
    #content_pagina .cruise-prijs-content-prijs-bedrag {
        font-size: 18px;
    }
    #content_pagina .blokken100 .width50 {
        width: 100% !important;
        margin-top: 10px !important;
    }
    #content_pagina .blokken100 .margin10 {
        margin: 0 !important;
    }
    #content_pagina .blokken100 .marginbottom20 {
        margin-bottom: 10px !important;
    }
    #content_pagina .width48 {
        margin-top: 20px !important;
    }
    #content_pagina .blokken100 .width10 {
        display: none;
    }
    #content_pagina .blokken100 .width85 {
        width: 100% !important;
    }
    .excursieinformatie .width50,
    .highlightinformatie .width50 {
        width: 100% !important;
    }

    #content_pagina .width75 .width65 {
        width: 100%;
    }
    #content_pagina .width75 .width65 .paddingleft25 {
        padding: 0;
    }
    #content_pagina .width75 .width65 .paddingleft25 img {
        width: 100%;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .bestemmingen-overzicht .width28 {
        margin: 0;
        width: 100%;
    }
    .bestemmingen-overzicht .width42 img {
        display: none;
    }
    .bestemmingen-overzicht .width25 img {
        width: 100%;
        margin-top: 10px;
    }

    #cruisepagina-content .width40,
    #cruisepagina-content .width59 {
        width: 100% !important;
    }
    .cruise-tabs-ul li a {
        padding: 10px 10px;
    }

    /* Aanbiedingen */
    #middle-content #side {
        width: 100% !important;
    }
    .feedback {
        display: none;
    }
    /* Nieuwsbrief */
    #newsletter-content .marginright10 {
        margin: 0 !important;
    }
    #newsletter-content .width42 {
        width: 100% !important;
    }
    #mc_embed_signup {
        float: left !important;
        width: 100% !important;
    }
    .newsletterslogan {
        text-align: center;
        float: left !important;
        margin-right: 0 !important;
    }
    #newsletter-content input {
        width: 88% !important;
        margin-bottom: 10px !important;
    }
    .mc-field-group {
        width: 100% !important;
        margin-bottom: 10px !important;
        margin-top: 10px !important;
    }
    #newsletter-content input {
        height: 44px;
        padding: 0 20px;
        transition: all 0.4s;
        margin-left: 0;
        line-height: 44px;
        border: 1px solid #cccccc;
        font-family: sans-serif;
        font-size: 14px;
        width: 270px;
        background-position: right 15px center;
        background-repeat: no-repeat;
        margin-top: 0 !important;
    }
    #mc_embed_signup input.button {
        width: 200px !important;
        color: #fff;
        height: 44px;
        border: 0;
        cursor: pointer;
        float: none !important;
        margin: 0 auto !important;
        clear: both;
    }
    /* Dekken pagina */
    .artikel-content .width30,
    .artikel-content .width50 {
        width: 100% !important;
        margin: 0 !important;
    }
    .artikel-content .width50 {
        margin-top: 20px !important;
    }
    .artikel-content .width45 {
        width: 100% !important;
    }
    .artikel-content .width31 {
        width: 32% !important;
    }
    .artikel-content .width69 {
        width: 100% !important;
    }
    .artikel-content .width100 .width45 span.width100 {
        font-size: 14px !important;
        margin-top: 10px !important;
    }
    .artikel-content .width100 .width25 .width31 {
        width: 100% !important;
    }
    .artikel-content .width100 .width25 .width100 {
        width: 45% !important;
    }
    .artikel-content .width100 .width100 .width50 {
        width: 45% !important;
    }

    .breadcrumb {
        margin-top: 20px !important;
    }
    /*footer menu */
    .copyrightmenu {
        display: block;
    }
    #home-filter #begindatum,
    #home-filter #begindatum2,
    #home-filter #einddatum {
        width: 100% !important;
        box-sizing: border-box;
    }

    /* CRUISE PAGINA */
    .cruisepagina .overzichtonderbetalen {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .cruisepagina h1 {
        margin-top: 20px !important;
    }
    .cruisepagina .overzichtonderbetalen {
        display: none;
    }
    .cruisepagina #cruise-offerte_aanvragen .width60 {
        width: 100% !important;
    }
    .cruisepagina .stap-content .cijfers {
        overflow: hidden;
        white-space: nowrap !important;
        float: none !important;
    }
    .cruisepagina .stap-content .cijfers .width24 .width100 {
        width: 100% !important;
    }

    .bedrag .even:hover,
    .bedrag .even:hover {
        background-color: #37b5d3 !important;
        color: #fff !important;
        cursor: pointer;
        font-weight: normal !important;
    }
    .tijden {
        display: none;
    }
    .cd-main-header {
        clear: both;
        float: right;
        width: 50%;
        margin-top: -52px;
        z-index: 10000 !important;
    }
    .cd-header-buttons {
        margin: 0 !important;
        padding: 0 !important;
        top: 0 !important;
    }
    .cd-nav-trigger span,
    .cd-nav-trigger span::before,
    .cd-nav-trigger span::after {
        position: absolute;
        display: inline-block;
        height: 3px;
        width: 24px;
        background: #2178b3;
    }
    .cd-main-header.nav-is-visible {
        z-index: 10000 !important;
    }
    #top {
        border-bottom: 1px solid #efefef;
    }
    .cd-nav-trigger span::before {
        top: -5px !important;
    }
    .cd-nav-trigger {
        margin-right: 20px !important;
    }
    .logos-img li {
        float: right !important;
    }
    .logos-img {
        margin-right: 15px !important;
        display: none;
    }
    .reisstappen .regel {
        width: 96% !important;
        background-color: #fff;
    }
    .cruise-tabs-ul li {
        width: 100%;
    }
    .fancybox-wrap {
        width: 90% !important;
    }
    .fancybox-inner {
        width: 100% !important;
    }
    .cruise-tabs-ul li a.active {
        width: 94%;
    }
    .cruise-tabs-style {
        display: none !important;
    }
    #cruisepagina-content #info_prijzen .checks {
        margin-left: 31% !important;
        margin-top: 6px;
        width: 194px;
    }
    .overiglogos2 {
        margin-left: 28%;
    }
    #cruisepagina-content #info_prijzen .checks li {
        float: left;
        margin: 0;
    }
    .betalen .width60,
    .betalen .width40 {
        width: 100%;
    }
    .betalen .stappenlijst .widthimp24 {
        width: 90% !important;
        text-align: left;
        padding-left: 20px;
        margin-bottom: 2px;
    }
    .betalen .stappenlijst {
        margin-top: 20px;
    }
    .betalen .height50 {
        display: none;
    }
    .betalen .button {
        width: 100%;
    }
    .font40 {
        font-size: 28px !important;
    }

    /* SCHEPEN PAGINA */
    #schepen_pagina .schipinformatie .width65,
    #schepen_pagina .schipinformatie .width30 {
        width: 100%;
        margin-top: 20px;
    }
    #schepen_pagina .textcenter img {
        margin-top: 50px;
    }

    /* BETALEN */
    .betalen .width20 {
        float: none;
        width: 80% !important;
        margin: 0 auto;
    }
    .betalen .width45 {
        width: 100% !important;
    }
    .betalen .width35 {
        width: 100% !important;
        margin-top: 50px !important;
    }
    .betalen .height125 {
        display: none;
    }
    .betalen .verticalmenu4 {
        margin-bottom: 20px !important;
    }
    .betalen .width45 input {
        width: 100% !important;
        font-size: 14px !important;
    }
    .betalen .width65 {
        width: 100% !important;
    }
    .betalen .width65 .width100 .width40,
    .betalen .width65 .width100 .width60 {
        width: 40% !important;
    }
    .width19,
    .width18 {
        width: 100% !important;
    }
    .facinformatie .width50 {
        width: 100% !important;
    }
    .width48 .cruise-prijs-content-prijs-vanaf {
        font-size: 10px !important;
        color: #fff !important;
        line-height: 14px;
        margin-bottom: -12px;
    }
    .width48 #cruises .prijsfly {
        margin-right: -24px !important;
        top: 0;
        right: 92px;
    }
    .width48 .cruise-prijs-content-prijs {
        line-height: 48px !important;
    }
    .width48 .prijsfly {
        height: 50px !important;
        width: 50px !important;
    }
    .topmenu .width42 {
        width: 100% !important;
    }
    .topmenu .width58 {
        display: none;
    }
    .topmenu {
        display: none;
    }
    #logos .topmenu {
        display: block;
    }
    #head #logos {
        width: auto;
        float: right;
    }
    #head #logos .topmenu ul li {
        margin-top: -2px;
    }
    #cruises .width100 .cruise-tekst {
        width: 100% !important;
        margin-top: 10px !important;
        margin-bottom: 10px !important;
    }
    #cruises .width100 .cruise-tekst .paddingleft10 {
        padding: 0 !important;
    }
    .width75 .cruise-foto {
        width: 100% !important;
    }
    .vluchten_transfer .width20 img {
        display: none;
    }
    .vluchten_transfer .width80 img {
        width: 40% !important;
    }
    #cruisepagina-content .div_hutinfo .width60 {
        display: none;
    }
    #cruisepagina-content .div_hutinfo .width35 {
        width: 100% !important;
        margin-top: 0;
    }
    .vluchten_transfer .width20 {
        display: none !important;
    }
    .vluchten_transfer .width80 {
        width: 100% !important;
    }

    .wacht .width50 {
        width: 90% !important;
    }
    .wacht .width50 h1 {
        font-size: 20px !important;
        margin-bottom: 4px !important;
    }
    .wacht .width50 p {
        font-size: 14px !important;
    }
    .wacht .middle-footer span {
        clear: both;
        float: none;
        display: block;
    }
    .gegevens .width70 {
        width: 100% !important;
    }
    .gegevens .width29 {
        width: 100% !important;
    }
    .gegevens .width70 .width20 {
        width: 20% !important;
    }
    .gegevens .width25 {
        width: 100% !important;
        margin-bottom: 10px !important;
    }
    #form-boeken .width73 .shadow .width50 {
        width: 100% !important;
    }
    #form-boeken .width73 .shadow .width50 .width50 {
        width: 50% !important;
    }

    #form-boeken .width73 .dag3 {
        width: 100% !important;
        height: 160px !important;
    }
    #form-boeken .width73 .width66 {
        width: 100% !important;
    }
    #form-boeken .cruise-boeken {
        width: 92% !important;
    }
    #form-boeken .width73 .width40 {
        width: 40% !important;
    }
    #form-boeken .hutkiezen .width5 {
        width: 10% !important;
    }
    #form-boeken .hutkiezen .width45 {
        width: 35% !important;
    }
    .side {
        display: none;
    }
    .width73 .rounded .borderorange2 {
        display: none;
    }
    .gegevens .width100 .width60 {
        width: 100% !important;
    }
    .gegevens .width70 .width30 {
        display: none !important;
    }
    .gegevens .width70 .width60 {
        width: 100% !important;
    }
    .gegevens .width29 #scroll_lockfixed {
        width: 100% !important;
    }

    /* VIDEO */
    .video .width70 {
        width: 100%;
    }
    .video .width25 {
        width: 100%;
    }
    .video .width5 {
        display: none;
    }

    /*Cruise thumbnails movile version*/
}
@media screen and (max-width: 910px) {
    #bar-icons {
        display: none !important;
    }
    #top-bar {
        width: 94% !important;
    }
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
    html,
    body {
        font-size: 12px;
        line-height: 22px;
        width: 100%;
        overflow-x: hidden;
        min-width: 900px;
    }

    /* RESETTEN MAAR */
    .center {
        width: auto;
        position: initial;
    }

    /* ipad 3/4 topmenu */
    #topmenu {
        display: block;
        padding: 0 15px;
        font-weight: bold;
    }

    /* ipad 3/4 header portrait */
    #logo {
    }
    #logo img {
        width: 200px;
    }
    #logo a img {
    }
    .bel {
        text-align: right;
    }
    .logos-img {
        position: center;
    }
    .topmenu {
        position: center;
        padding-right: 40px;
    }
    #logos {
        width: auto;
        text-align: center;
        float: right;
    }

    .hoofdmenu {
        display: block;
    }

    .hoofdmenu .menu > li {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }
    .hoofdmenu .menu > li > a {
        margin-left: 0;
        margin-right: 0;
        font-size: 13px;
    }
    .hoofdmenu .menu .submenudrop > li > a {
        padding-right: 25px;
    }

    .hoofdmenu .menu li.submenudrop a,
    .hoofdmenu .menu li.submenudrop-current a {
        background-position: right 5px center;
    }

    /* ipad 3/4 actie */
    .campaign-sale {
        font-size: 16px;
        padding-left: 14px;
    }
    .campaign-slogan {
        font-size: 14px;
    }
    #campaign-body {
        width: 95%;
        margin-left: 15px;
    }
    .campaign-button {
        width: 18%;
    }

    /* ipad 3/4 HOME FILTER */

    /* ipad 3/4 banner */
    .slideshow-text {
        width: 45%;
    }

    /* ipad 3/4 logos */
    .rederij-logos img {
        height: 22px;
    }

    /* width optimalisatie ipad 3/4 */
    .width80 {
        width: 70% !important;
    }
    .width20 {
        width: 30% !important;
    }

    .width19 {
        width: 39% !important;
    }
    .width23 {
        min-width: 46%;
    }
    .width24 {
        min-width: 45%;
        top: 20px;
    }
    .width73 {
        width: 70% !important;
    }
    .width40 {
        width: 39% !important;
    }
    .width48 {
        width: 46% !important;
    }
    /*
        .width20 {min-width:20%;}
        .width19 {min-width:19%;}
        .width23 {min-width:360px;}
        .width24 {min-width:360px; top:20px;}*/

    /* Cruise pagina */
    .cruise-prijzen .variabel {
        width: 27% !important;
    }
    .cruise-info .label {
        width: 50% !important;
    }
    .cruise-info .variabel {
        width: 40% !important;
    }
    .cruise-info .rederijoverzicht .label,
    .cruise-info .schipoverzicht .label,
    .cruise-info .rederijoverzicht .variabel,
    .cruise-info .schipoverzicht .variabel {
        width: 100% !important;
    }

    .rederij-logos {
        width: 100%;
        overflow: hidden;
        height: 30px;
    }
    .rederij-logos .nolist {
        width: 150% !important;
    }

    /*EDIT*/
    /* front featured ipad 3/4 */
    /*.textcenter, .textcenter img {margin-top:-12px;margin-right:-12px;}*/
    #middle-content {
        padding-bottom: 20px;
    }
    .blocks {
        margin-left: 10px;
    }
    #middle-content .width23 {
        min-width: 23%;
        width: 23%;
    }
    #middle-content .width24 {
        min-width: 23%;
        top: 0;
        width: 23%;
    }
    #middle-content .marginright15 {
        margin-right: 15px;
    }

    /* mid content ipad 3/4 */
    #middle-bottom {
        margin-left: 15px;
        margin-right: 15px;
    }

    /* footer ipad 3/4 */
    .footer-blok {
        margin-left: 10px;
        max-width: 15%;
        min-width: 15%;
    }
    .copyrightsocial {
        float: left;
    }
    .copyrightmenu {
        width: auto;
    }

    #content_pagina .center {
        width: 100% !important;
    }
    #content_pagina .center a.width50 {
        width: 50% !important;
    }
    #contentbody .cardtable .width75 {
        width: 75%;
    }
    #content_pagina .width32 {
        width: 31% !important;
    }
    #content_pagina .width100 .width20 {
        display: none;
    }
    #content_pagina .width100 .width25 {
        width: 25% !important;
    }
    #content_pagina .width100 .padding10 .width45 {
        width: 65% !important;
    }
    #content_pagina .width100 .width45 {
        width: 45% !important;
    }
    #content_pagina .divlink .width15 img {
        display: none;
    }
    #content_pagina .divlink .width70 {
        width: 74%;
    }
    #content_pagina .divlink .width15 {
        width: 25%;
    }
    #content_pagina .divlink .width70 .paddingleft10 {
        padding: 0 !important;
    }

    /* ipad 3/4 chat window */
    #habla_window_div {
        margin: 0 20px;
        right: 0; /*top: 181px;*/
        display: none;
        position: absolute;
    }
    #home-filter #begindatum,
    #home-filter #begindatum2,
    #home-filter #einddatum {
        width: 100% !important;
        box-sizing: border-box;
    }
    .prijsfly {
        margin-top: -10px;
    }
    .intro,
    #intro {
        left: 15%;
        width: 66% !important;
    }
    .header {
        font-size: 13px;
    }
    .label {
        width: 26% !important;
    }
    .cruise-prijs-content {
        height: auto !important;
    }
    #contentbody .width75 {
        width: 60%;
    }
    #contentbody .cardtable .width75 {
        width: 75%;
    }
    #contentbody .font24 {
        font-size: 20px;
    }
    .blog-intro-blok {
        margin-top: 15px !important;
        margin-left: 0 !important;
        left: 0 !important;
    }
    #content_pagina .tab {
        top: 0;
        width: 18% !important;
        min-width: 18% !important;
    }
    #content_pagina .hutinformatie .label {
        width: 50% !important;
    }
    .bestemmingen-overzicht .width24,
    .bestemmingen-overzicht .width23 {
        top: 0;
        width: 23% !important;
        min-width: 23% !important;
    }
    .bestemmingen-overzicht .width23 {
        width: 22% !important;
        min-width: 22% !important;
    }
    .bestemmingen-overzicht .width42 {
        float: left;
        width: 38%;
    }
    #content_pagina .height300 {
        height: auto;
    }
    #cruisepagina-content .width40 {
        width: 50% !important;
    }
    #cruisepagina-content .width59 {
        width: 45% !important;
    }
    .cruisepagina .width73 {
        width: 67% !important;
    }
    .cruisepagina .width25 {
        width: 30% !important;
    }
    .cruisepagina .cruise-stappen .width20 {
        width: 25% !important;
    }
    .cruisepagina .cruise-stappen .width80 {
        width: 100% !important;
    }
    .cruisepagina .overzichtonderbetalen {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    .cruisepagina .overzichtonderbetalen {
        display: none;
    }
    .cruisepagina #cruise-offerte_aanvragen .width60 {
        width: 100% !important;
    }
    .cruisepagina .cruise-stappen .hut {
        width: 20% !important;
    }
    .cruisepagina .cruise-stappen .cijfers {
        width: 80% !important;
    }
    .rederijoverzicht,
    .schipoverzicht {
        display: none;
    }
    #front-featured {
        width: 32% !important;
        margin-right: 5px !important;
        display: block;
        position: relative;
    }

    /* Rederij pagina */
    .schipinformatie .width30 {
        width: 40%;
    }
    .schipinformatie .width65 {
        width: 55%;
    }
    .cruise-prijs-content .width49 {
        width: 38%;
    }
    #cruisepagina-content #info_prijzen .checks {
        float: none;
        margin-left: 37% !important;
        margin-top: 6px;
        width: 194px;
    }
    .overiglogos2 {
        margin-left: 32%;
    }
    #cruisepagina-content #info_prijzen .checks li {
        float: left;
        margin: 0;
    }
    .reisstappen .regel {
        width: 96% !important;
        background-color: #fff;
    }
    .reisstappen .height32 {
        float: left;
        height: auto;
    }
    #main-image-sub img,
    #main-image-sub2 img {
        width: auto; /*height: auto;*/
        min-height: 432px;
        min-width: 100%;
        margin-top: 0;
        max-width: none;
        margin-left: -40%;
    }
    .facts .width40 {
        width: 38% !important;
    }
    .selected-cruises .marginright15 {
        margin-right: 10px !important;
    }
    .width48 .cruise-prijs-content-prijs-vanaf {
        font-size: 10px !important;
    }
    .topmenu .width58 {
        display: none;
    }
    .topmenu .width42 {
        width: 48% !important;
        float: right !important;
    }
    .topmenu .width42 form {
        float: right !important;
    }
    .landing #front-featured {
        width: 100% !important;
    }
    .rederij-logos {
        margin-left: 0 !important;
    }
    #cruisepagina-content .div_hutinfo .width40 {
        width: 40% !important;
    }
    #cruises .width100 .width75 {
        width: 75% !important;
    }
    #cruises .width100 .width25 {
        float: right;
        width: 25% !important;
    }
    .wacht .width50 {
        width: 70% !important;
    }
    .wacht .width50 h1 {
        font-size: 24px !important;
        margin-bottom: 4px !important;
    }
    .wacht .width50 p {
        font-size: 16px !important;
    }
    .wacht .middle-footer span {
        clear: both;
        float: none;
        display: block;
    }

    /* ONLINE BOEKEN */
    #form-boeken .shadow .width32 {
        width: 100% !important;
    }
    #form-boeken .width73 .shadow .width50 {
        width: 100% !important;
    }
    #form-boeken .width73 .shadow .width50 .width50 {
        width: 50% !important;
    }
    #form-boeken .width73 .dag3 {
        width: 100% !important;
        height: 160px !important;
    }
    #form-boeken .width73 .width66 {
        width: 100% !important;
    }
    #form-boeken .hutkiezen .width5 {
        width: 10% !important;
    }
    #form-boeken .hutkiezen .width45 {
        width: 35% !important;
    }
    .gegevens .width29 #scroll_lockfixed {
        width: 100% !important;
    }
}

@media screen and (min-width: 1025px) and (max-width: 1080px) {
    .rederij-logos {
        margin-left: 0 !important;
        width: 100%;
        height: 30px;
        overflow: hidden;
    }
}

.cd-main-header {
    display: none;
}

.cd-main-content {
    display: block;
}

@media screen and (max-width: 900px) {
    body {
        font-size: 12px;
    }
    .cd-main-header {
        display: block;
    }
    .cd-main-content {
        display: block;
    }
    #flight-data .width48 {
        width: 100% !important;
        margin: 0 !important;
    }

    #flight-data .width45 {
        width: 100% !important;
        margin: 0 !important;
    }

    #flight-data .width49 {
        width: 100% !important;
        margin: 0 !important;
    }
    #flight-data .width48 {
        width: 100% !important;
        margin: 0 !important;
    }

    @media only screen and (max-width: 900px) {
        .hutnr .label {
            width: 100% !important;
        }
        .hutnr .label .variabel {
            margin-bottom: 5px !important;
        }
    }

    @media only screen and (max-width: 900px) {
        #stap-hut .width30 {
            width: 100% !important;
        }
        #hutdesc {
            width: calc(100% - 6px) !important;
            padding: 3px;
            margin: auto;
        }
    }
    @media screen and (max-width: 500px) {
        .stap-content .regel .label {
            width: 60% !important;
        }
    }

    @media only screen and (max-width: 1024px) {
        .pricepos {
            width: 100% !important;
        }
        .flighticon {
            margin-top: 8px;
            margin-left: 24px;
            float: none !important;
        }
        .flighttitle {
            width: 100% !important;
        }
        .flightcontainer {
            width: 100% !important;
            font-size: 14px !important;
            border-top: 0.5px solid lightgrey;
            border-bottom: 0.5px solid lightgrey;
        }
        .flightbagage {
            width: 100% !important;
            margin-left: 20px;
            margin-top: 8px;
        }
        .prijspos {
            padding-top: 0 !important;
            padding-bottom: 10px !important;
        }
        .plane2 {
            visibility: hidden !important;
        }
    }
}
</style>
